import React, { Component } from "react";
import { CompactPicker, SketchPicker } from "react-color";
import { connect } from "react-redux";
import qs from "query-string";
import NumberFormat from "react-number-format";
import { withRouter } from "react-router-dom";
import _, { isEqual, property } from "lodash";
import reactCSS from "reactcss";
import commonActions from "../../common/actions";

import { ALIGNMENTS, FONT_COLOR, HEADINGS, LIST_STYLES, SPACING_RULE, FRAME_STYLES } from "../constants";
import Portal from "../../common/components/Portal";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import actions from "../actions";
import reportPropertyActions from "../../reportProperties/actions";
import ReactTooltip from "react-tooltip";
import SortedRecommendation from "./SortedRecommendation";
import NormalRecommendationForm from "./NormalRecommendationForm";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SortedRecommendationForm from "./SortedRecommendationForm";
import { reorderArray } from "../../../config/utils";
import BbiForm from "./BbiForm";
import { deepCompareObjects } from "../../smartCharts/components/SmartchartUtils";
import DefaultPropertiesModal from "./DefaultPropertiesModal";
import history from "../../../config/history";
import BsiForm from "./BsiForm";
import { sanitizeHtml } from "../../common/components/SafeHtml";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../common/components/Loader";

let initial_state = {
    id: "",
    name: "",
    client_id: "",
    description: "",
    notes: "",
    asset_props: {
        table: {
            table_page_fit: false,
            data: {
                font_id: "",
                alignment: "left",
                font_size: 6,
                font_color: "435254",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                },
                image_band: {
                    img_width: 1.5,
                    img_height: 1
                }
            },
            sub_total: {
                font_id: "",
                bg_color: "003f2d",
                alignment: "left",
                font_size: 6,
                font_color: "ffffff",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                }
            },
            heading: {
                font_id: "",
                bg_color: "003f2d",
                alignment: "left",
                font_size: 6,
                font_color: "ffffff",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                },
                blank_line_height: 4
            },
            custom_head: {
                font_size: 14,
                font_id: "",
                font_color: "",
                bg_color: "",
                alignment: "left",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                },
                blank_line_height: 4
            },

            table_style_id: ""
        },
        properties: [
            {
                width: 1,
                is_active: true,
                heading: "Code",
                is_static_field: true,
                key: "assets.code"
            },
            {
                width: 1,
                is_active: true,
                heading: "Asset Name",
                is_static_field: true,
                key: "assets.asset_name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Description",
                is_static_field: true,
                key: "assets.asset_description"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Condition Description",
                is_static_field: true,
                key: "assets.asset_condition"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Note",
                is_static_field: true,
                key: "assets.asset_note"
            },
            {
                width: 1,
                is_active: false,
                heading: "CSP Unit",
                is_static_field: true,
                key: "assets.csp_unit"
            },
            {
                width: 1,
                is_active: false,
                heading: "CRV",
                is_static_field: true,
                key: "assets.crv"
            },
            {
                width: 1,
                is_active: false,
                heading: "FCA Cost",
                is_static_field: true,
                key: "assets.fca_cost"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Status",
                is_static_field: true,
                key: "assets.asset_status_id"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Tag",
                is_static_field: true,
                key: "assets.asset_tag"
            },
            {
                width: 1,
                is_active: false,
                heading: "Model Number",
                is_static_field: true,
                key: "assets.model_number"
            },
            {
                width: 1,
                is_active: false,
                heading: "Core Model Number",
                is_static_field: true,
                key: "assets.core_model_number"
            },
            {
                width: 1,
                is_active: false,
                heading: "Serial Number",
                is_static_field: true,
                key: "assets.serial_number"
            },
            {
                width: 1,
                is_active: false,
                heading: "Region",
                is_static_field: true,
                key: "regions.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Site",
                is_static_field: true,
                key: "sites.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Building",
                is_static_field: true,
                key: "buildings.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Building Description",
                is_static_field: true,
                key: "buildings.description"
            },
            {
                width: 1,
                is_active: false,
                heading: "Building Type",
                is_static_field: true,
                key: "buildings.main_building_type_name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Addition",
                is_static_field: true,
                key: "additions.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Floor",
                is_static_field: true,
                key: "floors.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Room Number",
                is_static_field: true,
                key: "assets.room_number"
            },
            {
                width: 1,
                is_active: false,
                heading: "Architectural Room Number",
                is_static_field: true,
                key: "assets.architectural_room_number"
            },
            {
                width: 1,
                is_active: false,
                heading: "Room Name",
                is_static_field: true,
                key: "assets.room_name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Location",
                is_static_field: true,
                key: "assets.location"
            },
            {
                width: 1,
                is_active: false,
                heading: "Additional Room Description",
                is_static_field: true,
                key: "assets.additional_room_description"
            },
            {
                width: 1,
                is_active: false,
                heading: "Year Manufactured",
                is_static_field: true,
                key: "assets.year_manufactured"
            },
            {
                width: 1,
                is_active: false,
                heading: "Manufacturer",
                is_static_field: true,
                key: "assets.manufacturer"
            },
            {
                width: 1,
                is_active: false,
                heading: "Installed Year",
                is_static_field: true,
                key: "assets.installed_year"
            },
            {
                width: 1,
                is_active: false,
                heading: "Installed Year Status",
                is_static_field: true,
                key: "assets.installed_year_status"
            },
            {
                width: 1,
                is_active: false,
                heading: "Current Age",
                is_static_field: true,
                key: "assets.current_age"
            },
            {
                width: 1,
                is_active: false,
                heading: "Service Life",
                is_static_field: true,
                key: "assets.service_life"
            },
            {
                width: 1,
                is_active: false,
                heading: "End of Service Life",
                is_static_field: true,
                key: "assets.end_of_service_life"
            },
            {
                width: 1,
                is_active: false,
                heading: "Useful Life Remaining",
                is_static_field: true,
                key: "assets.usefull_life_remaining"
            },
            {
                width: 1,
                is_active: false,
                heading: "Refrigerant",
                is_static_field: true,
                key: "assets.refrigerant"
            },
            {
                width: 1,
                is_active: false,
                heading: "Warranty Start",
                is_static_field: true,
                key: "assets.warranty_start"
            },
            {
                width: 1,
                is_active: false,
                heading: "Warranty End",
                is_static_field: true,
                key: "assets.warranty_end"
            },
            {
                width: 1,
                is_active: false,
                heading: "Install Date",
                is_static_field: true,
                key: "assets.install_date"
            },
            {
                width: 1,
                is_active: false,
                heading: "Startup Date",
                is_static_field: true,
                key: "assets.startup_date"
            },
            {
                width: 1,
                is_active: false,
                heading: "Capacity",
                is_static_field: true,
                key: "assets.capacity"
            },
            {
                width: 1,
                is_active: false,
                heading: "Area Served",
                is_static_field: true,
                key: "assets.area_served"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Type",
                is_static_field: true,
                key: "asset_types.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Barcode",
                is_static_field: true,
                key: "assets.asset_barcode"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset CMMS ID",
                is_static_field: true,
                key: "assets.asset_cmms_id"
            },
            {
                width: 1,
                is_active: false,
                heading: "Upstream Asset Barcode Number",
                is_static_field: true,
                key: "assets.upstream_asset_barcode_number"
            },
            {
                width: 1,
                is_active: false,
                heading: "Linked Asset Barcode Number",
                is_static_field: true,
                key: "assets.linked_asset_barcode_number"
            },
            {
                width: 1,
                is_active: false,
                heading: "Source Panel Barcode Number",
                is_static_field: true,
                key: "assets.source_panel_barcode_number"
            },
            {
                width: 1,
                is_active: false,
                heading: "Source Panel",
                is_static_field: true,
                key: "assets.source_panel"
            },
            {
                width: 1,
                is_active: false,
                heading: "Notes",
                is_static_field: true,
                key: "assets.notes"
            },
            {
                width: 1,
                is_active: false,
                heading: "Uniformat Level 1 ID",
                is_static_field: true,
                key: "uniformat_level_1s.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Uniformat Level 2 ID",
                is_static_field: true,
                key: "uniformat_level_2s.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Uniformat Level 3 ID",
                is_static_field: true,
                key: "uniformat_level_3s.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Uniformat Level 4 ID",
                is_static_field: true,
                key: "uniformat_level_4s.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Uniformat Level 5 ID",
                is_static_field: true,
                key: "uniformat_level_5s.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Uniformat Level 6 ID",
                is_static_field: true,
                key: "uniformat_level_6s.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Created At",
                is_static_field: true,
                key: "assets.created_at"
            },
            {
                width: 1,
                is_active: false,
                heading: "Updated At",
                is_static_field: true,
                key: "assets.updated_at"
            },
            {
                width: 1,
                is_active: false,
                heading: "Criticality",
                is_static_field: true,
                key: "assets.criticality"
            },
            {
                width: 1,
                is_active: false,
                heading: "Client",
                is_static_field: true,
                key: "clients.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Main Category",
                is_static_field: true,
                key: "main_categories.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Sub Category 1",
                is_static_field: true,
                key: "sub_category_1.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Sub Category 2",
                is_static_field: true,
                key: "sub_category_2.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Sub Category 3",
                is_static_field: true,
                key: "sub_category_3.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Client Asset Condition",
                is_static_field: true,
                key: "client_asset_conditions.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Trade",
                is_static_field: true,
                key: "trades.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Sub System",
                is_static_field: true,
                key: "sub_systems.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "System",
                is_static_field: true,
                key: "systems.name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Parent Global ID",
                is_static_field: true,
                key: "assets.parent_global_id"
            },
            {
                width: 1,
                is_active: false,
                heading: "Survey Global ID",
                is_static_field: true,
                key: "assets.survey_global_id"
            },
            {
                width: 1,
                is_active: false,
                heading: "Survey ID",
                is_static_field: true,
                key: "assets.survey_id"
            },
            {
                width: 1,
                is_active: false,
                heading: "GUID",
                is_static_field: true,
                key: "assets.guid"
            },
            {
                width: 1,
                is_active: false,
                heading: "Estimated Replacement Cost",
                is_static_field: true,
                key: "assets.est_replacement_cost"
            },
            {
                width: 1,
                is_active: false,
                heading: "Source Panel Name",
                is_static_field: true,
                key: "assets.source_panel_name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Skysite Hyperlink",
                is_static_field: true,
                key: "assets.skysite_hyperlink"
            },
            {
                width: 1,
                is_active: false,
                heading: "Capacity Unit",
                is_static_field: true,
                key: "assets.capacity_unit"
            },
            {
                width: 1,
                is_active: false,
                heading: "Quantity",
                is_static_field: true,
                key: "assets.quantity"
            },
            {
                width: 1,
                is_active: false,
                heading: "RTLS Tag",
                is_static_field: true,
                key: "assets.rtls_tag"
            },
            {
                width: 1,
                is_active: false,
                heading: "Latitude",
                is_static_field: true,
                key: "assets.latitude"
            },
            {
                width: 1,
                is_active: false,
                heading: "Longitude",
                is_static_field: true,
                key: "assets.longitude"
            },
            {
                width: 1,
                is_active: false,
                heading: "Age",
                is_static_field: true,
                key: "assets.age"
            },
            {
                width: 1,
                is_active: false,
                heading: "New Asset",
                is_static_field: true,
                key: "assets.new_asset"
            },
            {
                width: 1,
                is_active: false,
                heading: "Survey Property Note",
                is_static_field: true,
                key: "assets.survey_property_note"
            },
            {
                width: 1,
                is_active: false,
                heading: "Capacity Status",
                is_static_field: true,
                key: "assets.capacity_status"
            },
            {
                width: 1,
                is_active: false,
                heading: "Name Plate Status",
                is_static_field: true,
                key: "assets.name_plate_status"
            },
            {
                width: 1,
                is_active: false,
                heading: "QA Notes",
                is_static_field: true,
                key: "assets.qa_notes"
            },
            {
                width: 1,
                is_active: false,
                heading: "Unit Cost",
                is_static_field: true,
                key: "assets.unit_cost"
            },
            {
                width: 1,
                is_active: false,
                heading: "Additional QA Notes",
                is_static_field: true,
                key: "assets.additional_qa_notes"
            },
            {
                width: 1,
                is_active: false,
                heading: "Surveyor",
                is_static_field: true,
                key: "assets.surveyor"
            },
            {
                width: 1,
                is_active: false,
                heading: "Editor",
                is_static_field: true,
                key: "assets.editor"
            },
            {
                width: 1,
                is_active: false,
                heading: "Survey Date Created",
                is_static_field: true,
                key: "assets.survey_date_created"
            },
            {
                width: 1,
                is_active: false,
                heading: "Survey Date Edited",
                is_static_field: true,
                key: "assets.survey_date_edited"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Condition Notes",
                is_static_field: true,
                key: "assets.asset_condition_notes"
            },
            {
                width: 1,
                is_active: false,
                heading: "Category Description",
                is_static_field: true,
                key: "assets.category_description"
            },
            {
                width: 1,
                is_active: false,
                heading: "Recommendation Count",
                is_static_field: true,
                key: "assets.recommendation_count"
            },
            {
                width: 1,
                is_active: false,
                heading: "Has Recommendation",
                is_static_field: true,
                key: "assets.has_recommendation"
            },
            {
                width: 1,
                is_active: false,
                heading: "Image Count",
                is_static_field: true,
                key: "assets.image_count"
            },
            {
                width: 1,
                is_active: false,
                heading: "Uniformat Level 3 Custom Description",
                is_static_field: true,
                key: "assets.uniformat_level_3_custom_description"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Ownership",
                is_static_field: true,
                key: "assets.asset_ownership"
            },
            {
                width: 1,
                is_active: false,
                heading: "Asset Name Unique",
                is_static_field: true,
                key: "assets.asset_name_unique"
            },
            {
                width: 1,
                is_active: false,
                heading: "Energy Use Type",
                is_static_field: true,
                key: "assets.energy_use_type"
            },
            {
                key: "image",
                width: 1,
                heading: "Image",
                is_active: false,
                is_static_field: true
            }
        ]
    },
    properties: {
        chart: {
            width: 500,
            height: 300,
            alignment: "center",
            frame: false,
            frame_props: {
                size: "6",
                space: "1",
                color: "bfbfbf",
                val: "single"
            }
        },
        header: {
            project: {
                font_id: "",
                font_size: 8.5,
                color: "4b90fa",
                bold: false,
                font_id: ""
            },
            logo: {
                width: 75,
                height: 25,
                client: false
            },
            client: {
                font_id: "",
                font_size: 8.5,
                color: "4b90fa",
                bold: false
            }
        },
        heading: {
            bold: true,
            color: "101010",
            alignment: "center",
            font_size: 13,
            font_id: ""
        },
        x_axis: {
            color: "666666",
            font_size: 11
        },
        y_axis: {
            color: "666666",
            font_size: 11
        },
        data_labels: {
            color: "000000",
            font_size: 11
        },
        chart_font: {
            font_id: ""
        },
        legend: {
            show_legend: true,
            backgroundColor: "",
            borderColor: "",
            borderRadius: 0,
            borderWidth: 0,
            font_size: 12,
            bold: true,
            font_color: "333333",
            display_formats: ["K", "M"]
        },
        custom_legend: {
            show_legend: true,

            legend_heading: {
                bold: false,
                color: "101010",
                alignment: "left",
                font_size: 10,
                font_id: "",
                bg_color: "ffffff"
            },
            legend_value: {
                display_formats: ["K", "M"],
                bold: false,
                color: "101010",
                alignment: "left",
                font_size: 10,
                font_id: "",
                bg_color: "ffffff"
            }
        },
        total: {
            display_formats: ["K", "M"],
            show_total: true,
            bold: false,
            color: "101010",
            alignment: "left",
            font_size: 12,
            font_id: "",
            bg_color: "ffffff"
        },
        table: {
            table_style_id: "",
            col_width: 10,
            table_page_fit: false,
            sub_total: {
                font_id: "",
                alignment: "left",
                font_size: 12,
                font_color: "ffffff",
                bg_color: "4117bf",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                }
            },
            data: {
                font_id: "",
                alignment: "",
                font_size: 13,
                font_color: "",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                }
            },
            heading: {
                font_id: "",
                font_size: 3,
                bg_color: "4117bf",
                alignment: "left",
                // font_size: 14,
                font_color: "fff700",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                }
            },
            custom_head: {
                font_id: "",
                bg_color: "4117bf",
                alignment: "center",
                font_size: 15,
                font_color: "fff700",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                },
                blank_line_height: 4
            }

            // table_style: ""
        },
        memo_properties: {
            memo_props_active: false,
            heading: {
                font_id: "",
                font_size: 9,
                font_color: "003F2D",
                font_bold: false,
                font_family: ""
            },
            body: {
                font_id: "",
                font_size: 9,
                font_color: "000000",
                font_bold: false,
                font_family: ""
            }
        },
        comp_analysis: {
            table: {
                table_page_fit: false,
                table_style_id: "",
                col_width: 10,
                sub_total: {
                    font_id: "",
                    alignment: "left",
                    font_size: 12,
                    font_color: "ffffff",
                    bg_color: "4117bf",
                    cell_margin: {
                        top: 0.1,
                        left: 0.3,
                        right: 0.09,
                        bottom: 0.04
                    }
                },
                data: {
                    font_id: "",
                    alignment: "",
                    font_size: 13,
                    font_color: "",
                    cell_margin: {
                        top: 0.1,
                        left: 0.3,
                        right: 0.09,
                        bottom: 0.04
                    },
                    blank_line_height: 4
                },
                heading: {
                    font_id: "",
                    font_size: 3,
                    bg_color: "4117bf",
                    alignment: "left",
                    // font_size: 14,
                    font_color: "fff700",
                    cell_margin: {
                        top: 0.1,
                        left: 0.3,
                        right: 0.09,
                        bottom: 0.04
                    },
                    head_first_index_label: "FCA"
                },
                custom_head: {
                    font_id: "",
                    bg_color: "4117bf",
                    alignment: "center",
                    font_size: 15,
                    font_color: "fff700",
                    cell_margin: {
                        top: 0.1,
                        left: 0.3,
                        right: 0.09,
                        bottom: 0.04
                    },
                    blank_line_height: 4
                }
            },
            ca_recommendation: {
                code: {
                    label: "Code",
                    show_total: false,
                    data_type: "str",
                    selected: true,
                    width: 1
                },
                name: {
                    label: "Name",
                    show_total: false,
                    data_type: "str",
                    selected: true,
                    width: 1
                },
                description: {
                    label: "Description",
                    show_total: false,
                    data_type: "str",
                    selected: true,
                    width: 1
                },
                building_type: {
                    label: "Type",
                    show_total: false,
                    data_type: "str",
                    selected: true,
                    width: 1
                },
                place: {
                    label: "Place",
                    show_total: false,
                    data_type: "str",
                    selected: false,
                    width: 1
                },
                total_area: {
                    label: "Area",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    width: 1
                },
                recommendations_count: {
                    label: "Recommendation Count",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    width: 1
                },
                project_total: {
                    label: "Sum Construction Cost",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    show_dollar: true,
                    width: 1
                },
                cost: {
                    label: "Cost",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    show_dollar: true,
                    width: 1
                },
                differed_maintenance: {
                    label: "Deferred Maintenance",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    show_dollar: true,
                    width: 1
                },
                future_capital: {
                    label: "Future Capital",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    show_dollar: true,
                    width: 1
                },
                non_infrastructure: {
                    label: "Non-Infrastructure",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    show_dollar: true,
                    width: 1
                },
                dm_count: {
                    label: "Deferred Maintenance Count",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    width: 1
                },
                fc_count: {
                    label: "Future Capital Count",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    width: 1
                },
                ni_count: {
                    label: "Non-Infrastructure Count",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    width: 1
                },
                dollar_per_square_foot: {
                    label: "Dollar per square foot",
                    show_total: false,
                    data_type: "int",
                    selected: true,
                    width: 1
                },
                city: {
                    label: "City",
                    show_total: false,
                    data_type: "str",
                    selected: false,
                    width: 1
                },
                state: {
                    label: "State",
                    show_total: false,
                    data_type: "str",
                    selected: false,
                    width: 1
                },
                country: {
                    label: "Country",
                    show_total: false,
                    data_type: "str",
                    selected: false,
                    width: 1
                }
            },
            ca_asset: {
                code: {
                    label: "Code",
                    show_total: false,
                    data_type: "str",
                    selected: true,
                    width: 1
                },
                name: {
                    label: "Name",
                    show_total: false,
                    data_type: "str",
                    selected: true,
                    width: 1
                },
                description: {
                    label: "Description",
                    show_total: false,
                    data_type: "str",
                    selected: true,
                    width: 1
                },
                building_type: {
                    label: "Type",
                    show_total: false,
                    data_type: "str",
                    selected: true,
                    width: 1
                },
                place: {
                    label: "Place",
                    show_total: false,
                    data_type: "str",
                    selected: false,
                    width: 1
                },
                area: {
                    label: "Area",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    width: 1
                },
                asset_count: {
                    label: "Asset Count",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    width: 1
                },
                cost: {
                    label: "Cost",
                    show_total: false,
                    data_type: "str",
                    selected: true,
                    width: 1
                },
                total_crv: {
                    label: "Total CRV",
                    show_total: true,
                    data_type: "int",
                    selected: true,
                    show_dollar: true,
                    width: 1
                },
                asset_condition: {
                    label: "Asset Condition",
                    show_total: false,
                    data_type: "",
                    selected: true,
                    width: 1
                },
                asset_condition_count: {
                    label: "Asset Condition Count",
                    show_total: false,
                    data_type: "",
                    selected: true,
                    width: 1
                },
                city: {
                    label: "City",
                    show_total: false,
                    data_type: "str",
                    selected: false,
                    width: 1
                },
                state: {
                    label: "State",
                    show_total: false,
                    data_type: "str",
                    selected: false,
                    width: 1
                },
                country: {
                    label: "Country",
                    show_total: false,
                    data_type: "str",
                    selected: false,
                    width: 1
                }
            }
        },
        user_doc: {
            building_default_image: {
                alignment: "center",
                img_width: 4.5,
                img_height: 3.4
            }
        },
        page_header: {
            font_id: "",
            font_bold: false,
            font_size: 9,
            font_color: "435254",
            font_family: "",
            alignment: "left"
        },
        gauge_chart_props: {
            body: {
                font_id: "",
                font_bold: true,
                font_size: 20,
                font_color: "000000",
                font_family: ""
            },
            total: {
                font_id: "",
                font_bold: true,
                font_size: 24,
                font_color: "000000",
                font_family: ""
            }
        }
    },
    recommendation_props: {
        body: {
            font_size: 9,
            font_id: "",
            font_colour: "",
            background_colour: "",
            border_colour: "",
            border_width: {
                top: 6,
                left: 6,
                right: 6,
                bottom: 6
            },
            cell_margin: {
                top: 0.04,
                left: 0.04,
                right: 0.04,
                bottom: 0.04
            }
        },
        site: {
            font_size: 12,
            font_id: "",
            font_colour: "",
            background_colour: "",
            border_colour: "",
            border_width: {
                top: 6,
                left: 6,
                right: 6,
                bottom: 6
            },
            cell_margin: {
                top: 0.04,
                left: 0.04,
                right: 0.04,
                bottom: 0.04
            },
            heading_alignment: "left",
            total_alignment: "right"
        },
        addition: {
            font_size: 10,
            font_id: "",
            font_colour: "",
            background_colour: "",
            border_colour: "",
            border_width: {
                top: 6,
                left: 6,
                right: 6,
                bottom: 6
            },
            cell_margin: {
                top: 0.04,
                left: 0.04,
                right: 0.04,
                bottom: 0.04
            },
            heading_alignment: "left",
            total_alignment: "right"
        },
        building: {
            font_size: 11,
            font_id: "",
            font_colour: "",
            background_colour: "",
            border_colour: "",
            border_width: {
                top: 6,
                left: 6,
                right: 6,
                bottom: 6
            },
            cell_margin: {
                top: 0.04,
                left: 0.04,
                right: 0.04,
                bottom: 0.04
            },
            heading_alignment: "left",
            total_alignment: "right"
        },
        grand_total: {
            font_size: 13,
            font_id: "",
            font_colour: "",
            background_colour: "",
            border_colour: "",
            border_width: {
                top: 6,
                left: 6,
                right: 6,
                bottom: 6
            },
            cell_margin: {
                top: 0.04,
                left: 0.04,
                right: 0.04,
                bottom: 0.04
            },
            total_alignment: "right"
        },
        table_style: {
            style_id: ""
        },
        table_heading: {
            font_size: 13,
            font_id: "",
            font_colour: "",
            background_colour: "",
            border_colour: "",

            border: {
                left: false,
                right: false,
                bottom: false,
                top: false
            },
            border_width: {
                top: 6,
                left: 6,
                right: 6,
                bottom: 6
            },
            cell_margin: {
                top: 0.04,
                left: 0.04,
                right: 0.04,
                bottom: 0.04
            }
        },
        custom_heading: {
            font_size: 14,
            font_id: "",
            font_colour: "",
            background_colour: "",
            cell_margin: {
                top: 0.04,
                left: 0.04,
                right: 0.04,
                bottom: 0.04
            },
            heading_label: "Building, Addition, Year, and Priority"
        },
        year: {
            end_count: 10,
            start_count: 1
        },
        properties: [
            {
                key: "sl_no",
                width: 1,
                heading: "Sl No",
                is_active: true,
                is_index_number: true,
                is_static_field: true
            },
            {
                key: "code",
                width: 1,
                heading: "Code",
                is_active: true,
                is_static_field: true
            },
            {
                key: "description",
                width: 4,
                heading: "Recommendation",
                is_active: true,
                is_static_field: true
            },
            {
                key: "trade",
                width: 1,
                heading: "Trade",
                is_active: true,
                is_static_field: true
            },
            {
                key: "category",
                width: 1,
                heading: "Category",
                is_active: true,
                is_static_field: true
            },
            {
                key: "addition_name",
                width: 1,
                heading: "Addition",
                is_active: true,
                is_static_field: true
            },

            {
                key: "project_total",
                width: 1.3,
                heading: "Construction Cost",
                is_active: true,
                is_static_field: true
            },
            {
                key: "project_costs",
                width: 1.3,
                heading: "Project Cost",
                is_active: false,
                is_static_field: true
            },
            {
                key: "priority",
                width: 1,
                heading: "Priority",
                is_active: false,
                is_static_field: true
            },
            {
                key: "criticality",
                width: 1,
                heading: "Criticality",
                is_active: false,
                is_static_field: true
            },

            {
                key: "funding_source",
                width: 1,
                heading: "Funding Source",
                is_active: false,
                is_static_field: true
            },
            {
                key: "recommendation_capital_type",
                width: 1,
                heading: "Recommendation Capital Type",
                is_active: false,
                is_static_field: true
            },
            {
                key: "responsibility_name",
                width: 1,
                heading: "Responsibility Name",
                is_active: false,
                is_static_field: true
            },
            {
                key: "years_with_value",
                width: 1,
                heading: "Year(s)",
                is_active: false,
                is_custom_field: true
            },
            {
                key: "unit",
                width: 1,
                heading: "Unit",
                is_active: false,
                is_static_field: true
            },
            {
                key: "cost_per_unit",
                width: 1,
                heading: "Cost Per Unit",
                is_active: false,
                is_static_field: true
            },
            {
                key: "quantity",
                width: 1,
                heading: "Quantity",
                is_active: false,
                is_static_field: true
            },
            {
                key: "budget_priority",
                width: 1,
                heading: "Budget Priority",
                is_active: false,
                is_static_field: true
            },
            {
                key: "building",
                width: 1,
                heading: "Building",
                is_active: false,
                is_static_field: true
            },
            {
                key: "building_description",
                width: 2,
                heading: "Building Description",
                is_active: false,
                is_static_field: true
            },

            {
                key: "department",
                width: 1,
                heading: "Department",
                is_active: false,
                is_static_field: true
            },

            {
                key: "system",
                width: 1,
                heading: "System",
                is_active: false,
                is_static_field: true
            },
            {
                key: "sub_system",
                width: 1,
                heading: "Sub System",
                is_active: false,
                is_static_field: true
            },
            {
                key: "building_type",
                width: 1,
                heading: "Building Type",
                is_active: false,
                is_static_field: true
            },
            {
                key: "recommendation_space_type",
                width: 1,
                heading: "Space Type",
                is_static_field: true,
                is_active: false
            },
            {
                key: "recommendation_type",
                width: 1,
                heading: "Recommendation Type",
                is_active: false,
                is_static_field: true
            },
            {
                key: "project",
                width: 1,
                heading: "Project",
                is_active: false,
                is_static_field: true
            },
            {
                key: "region",
                width: 1,
                heading: "Region",
                is_active: false,
                is_static_field: true
            },
            {
                key: "site",
                width: 1,
                heading: "Site",
                is_active: false,
                is_static_field: true
            },

            {
                key: "initiative_name",
                width: 1,
                heading: "Initiative",
                is_active: false,
                is_static_field: true
            },
            {
                key: "hospital_name",
                width: 1,
                heading: "Parent Building",
                is_active: false,
                is_static_field: true
            },
            {
                key: "client",
                width: 1,
                heading: "Client",
                is_active: false,
                is_static_field: true
            },
            {
                key: "consultancy",
                width: 1,
                heading: "Consultancy",
                is_active: false,
                is_static_field: true
            },
            {
                key: "ministry",
                width: 1,
                heading: "Ministry",
                is_active: false,
                is_static_field: true
            },
            {
                key: "floor",
                width: 1,
                heading: "Floor",
                is_active: false,
                is_static_field: true
            },
            {
                key: "room",
                width: 1,
                heading: "Room",
                is_active: false,
                is_static_field: true
            },

            {
                key: "asset_name",
                width: 1,
                heading: "Asset Name",
                is_active: false,
                is_static_field: true
            },
            {
                key: "condition",
                width: 1,
                heading: "Condition",
                is_active: false,
                is_static_field: true
            },
            {
                key: "installed_year",
                width: 1,
                heading: "Installed Year",
                is_active: false,
                is_static_field: true
            },
            {
                key: "service_life",
                width: 1,
                heading: "Service Life",
                is_active: false,
                is_static_field: true
            },
            {
                key: "usefull_life_remaining",
                width: 1,
                heading: "Usefull Life Remaining",
                is_active: false,
                is_static_field: true
            },
            {
                key: "crv",
                width: 1,
                heading: "Crv",
                is_active: false,
                is_static_field: true
            },
            {
                key: "essential",
                width: 1,
                heading: "Essential",
                is_active: false,
                is_static_field: true
            },
            {
                key: "surveyor",
                width: 1,
                heading: "Surveyor",
                is_active: false,
                is_static_field: true
            },
            {
                key: "surveyor_role",
                width: 1,
                heading: "Surveyor Role",
                is_static_field: true,
                is_active: false
            },
            {
                key: "inspection_date",
                width: 1,
                heading: "Inspection Date",
                is_active: false,
                is_static_field: true
            },
            {
                key: "source",
                width: 1,
                heading: "Origin",
                is_active: false,
                is_static_field: true
            },
            {
                key: "status",
                width: 1,
                heading: "Status",
                is_active: false,
                is_static_field: true
            },
            {
                key: "recommendation_narrative",
                width: 1,
                heading: "Recommendation Narrative",
                is_active: false,
                is_static_field: true
            },
            {
                key: "fmp",
                width: 1,
                heading: "Fmp",
                is_active: false,
                is_static_field: true
            },
            {
                key: "fmp_id",
                width: 1,
                heading: "Fmp Id",
                is_active: false,
                is_static_field: true
            },
            {
                key: "fmp_track",
                width: 1,
                heading: "Fmp Track",
                is_active: false,
                is_static_field: true
            },
            {
                key: "fmp_project",
                width: 1,
                heading: "Fmp Project",
                is_active: false,
                is_static_field: true
            },
            {
                key: "infrastructure_request",
                width: 1,
                heading: "Infrastructure Request",
                is_active: false,
                is_static_field: true
            },
            {
                key: "red_line",
                width: 1,
                heading: "Red Line",
                is_active: false,
                is_static_field: true
            },
            {
                key: "continuous_fca",
                width: 1,
                heading: "Continuous FCA",
                is_active: false,
                is_static_field: true
            },
            {
                key: "energy_band_show",
                width: 1,
                heading: "Energy Band Show",
                is_active: false,
                is_static_field: true
            },
            {
                key: "water_band_show",
                width: 1,
                heading: "Water Band Show",
                is_active: false,
                is_static_field: true
            },

            {
                key: "options_cost",
                width: 1,
                heading: "Opinions of Cost",
                is_active: false,
                is_static_field: true
            },
            {
                key: "created_at",
                width: 1,
                heading: "Created At",
                is_active: false,
                is_static_field: true
            },
            {
                key: "updated_at",
                width: 1,
                heading: "Updated At",
                is_active: false,
                is_static_field: true
            }
        ]
    },
    multi_recommendation_props: {
        heading: {
            font_id: "",
            font_size: 12,
            font_color: "",
            font_family: ""
        },
        caption: {
            font_id: "",
            font_size: 12,
            font_color: "",
            font_family: ""
        },
        body: {
            font_id: "",
            font_size: 12,
            font_color: "",
            font_family: ""
        },
        notes: {
            font_id: "",
            font_size: 12,
            font_color: "",
            font_family: ""
        },
        seperator_line: {
            space_after: 0,
            size: 0,
            space_before: 0,
            style: "single",
            color: "#4b90fa"
        },
        sub_total: {
            is_sub_total: true,
            font_id: "",
            font_size: 8,
            font_colour: "",
            border_colour: "",
            background_colour: "",
            border: {
                left: false,
                right: false,
                top: false,
                bottom: false
            },
            cell_margin: {
                top: 0.04,
                left: 0.04,
                right: 0.04,
                bottom: 0.04
            }
        },
        filter_by_custom_props: {
            filter_custom_heading: {
                font_size: 10,
                font_bold: true,
                label: "",
                font_family: "",
                font_id: "",
                font_colour: "000000"
            },
            filter_by_props: {
                labels: {
                    font_size: 10,
                    font_family: "",
                    font_id: "",
                    font_bold: true,
                    font_colour: "000000"
                },
                values: {
                    font_size: 10,
                    font_family: "",
                    font_id: "",
                    font_bold: false,
                    font_colour: "000000"
                }
            },
            space_after: 6,
            space_before: 0,
            cell_margin: {
                top: 0.04,
                left: 0.04,
                right: 0.04,
                bottom: 0.04
            },
            alignment: "left"
        },
        memo_properties: {
            memo_props_active: false,
            heading: {
                font_id: "",
                font_size: 9,
                font_color: "003F2D",
                font_bold: false,
                font_family: ""
            },
            body: {
                font_id: "",
                font_size: 9,
                font_color: "000000",
                font_bold: false,
                font_family: ""
            }
        }
    },
    normal_recommendation_props: {
        table: {
            table_page_fit: false,
            data: {
                font_id: "",
                alignment: "left",
                font_size: 6,
                font_color: "435254",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                },
                image_band: {
                    img_width: 1.5,
                    img_height: 1
                }
            },
            sub_total: {
                font_id: "",
                bg_color: "003f2d",
                alignment: "left",
                font_size: 6,
                font_color: "ffffff",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                }
            },
            heading: {
                font_id: "",
                bg_color: "003f2d",
                alignment: "left",
                font_size: 6,
                font_color: "ffffff",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                }
            },
            custom_head: {
                font_size: 14,
                font_id: "",
                font_color: "",
                bg_color: "",
                alignment: "left",
                cell_margin: {
                    top: 0.1,
                    left: 0.3,
                    right: 0.09,
                    bottom: 0.04
                },
                blank_line_height: 4
            },
            table_style_id: ""
        },
        year: {
            end_count: 10,
            start_count: 1
        },
        properties: [
            {
                key: "code",
                width: 1,
                heading: "Id",
                is_active: true,
                is_static_field: true
            },
            {
                key: "project_total",
                width: 1.3,
                heading: "Construction Cost",
                is_active: true,
                is_static_field: true
            },
            {
                key: "project_costs",
                width: 1.3,
                heading: "Project Cost",
                is_active: false,
                is_static_field: true
            },
            {
                key: "description",
                width: 4,
                heading: "Recommendation",
                is_active: true,
                is_static_field: true
            },
            {
                key: "budget_priority",
                width: 1,
                heading: "Budget Priority",
                is_active: true,
                is_static_field: true
            },
            {
                key: "building",
                width: 1,
                heading: "Building",
                is_active: true,
                is_static_field: true
            },
            {
                key: "building_description",
                width: 2,
                heading: "Building Description",
                is_active: true,
                is_static_field: true
            },
            {
                key: "addition_name",
                width: 1,
                heading: "Addition",
                is_active: false,
                is_static_field: true
            },
            {
                key: "department",
                width: 1,
                heading: "Department",
                is_active: false,
                is_static_field: true
            },
            {
                key: "recommendation_capital_type",
                width: 1,
                heading: "Recommendation Capital Type",
                is_active: false,
                is_static_field: true
            },
            {
                key: "category",
                width: 1,
                heading: "Category",
                is_active: false,
                is_static_field: true
            },
            {
                key: "trade",
                width: 1,
                heading: "Trade",
                is_active: false,
                is_static_field: true
            },
            {
                key: "system",
                width: 1,
                heading: "System",
                is_active: false,
                is_static_field: true
            },
            {
                key: "sub_system",
                width: 1,
                heading: "Sub System",
                is_active: false,
                is_static_field: true
            },
            {
                key: "building_type",
                width: 1,
                heading: "Building Type",
                is_active: false,
                is_static_field: true
            },
            {
                key: "recommendation_space_type",
                width: 1,
                heading: "Space Type",
                is_static_field: true,
                is_active: false
            },
            {
                key: "recommendation_type",
                width: 1,
                heading: "Recommendation Type",
                is_active: false,
                is_static_field: true
            },
            {
                key: "project",
                width: 1,
                heading: "Project",
                is_active: false,
                is_static_field: true
            },
            {
                key: "region",
                width: 1,
                heading: "Region",
                is_active: false,
                is_static_field: true
            },
            {
                key: "site",
                width: 1,
                heading: "Site",
                is_active: false,
                is_static_field: true
            },
            {
                key: "criticality",
                width: 1,
                heading: "Criticality",
                is_active: false,
                is_static_field: true
            },
            {
                key: "priority",
                width: 1,
                heading: "Priority",
                is_active: false,
                is_static_field: true
            },
            {
                width: 1,
                is_active: false,
                heading: "Initiative",
                is_static_field: true,
                key: "initiative_name"
            },
            {
                width: 1,
                is_active: false,
                heading: "Parent Building",
                is_static_field: true,
                key: "hospital_name"
            },
            {
                key: "client",
                width: 1,
                heading: "Client",
                is_active: false,
                is_static_field: true
            },
            {
                key: "consultancy",
                width: 1,
                heading: "Consultancy",
                is_active: false,
                is_static_field: true
            },
            {
                key: "ministry",
                width: 1,
                heading: "Ministry",
                is_active: false,
                is_static_field: true
            },
            {
                key: "floor",
                width: 1,
                heading: "Floor",
                is_active: false,
                is_static_field: true
            },
            {
                key: "room",
                width: 1,
                heading: "Room",
                is_active: false,
                is_static_field: true
            },
            {
                key: "funding_source",
                width: 1,
                heading: "Funding Source",
                is_active: false,
                is_static_field: true
            },
            {
                key: "responsibility_name",
                width: 1,
                heading: "Responsibility Name",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_name",
                width: 1,
                heading: "Asset Name",
                is_active: false,
                is_static_field: true
            },
            {
                key: "condition",
                width: 1,
                heading: "Condition",
                is_active: false,
                is_static_field: true
            },
            {
                key: "installed_year",
                width: 1,
                heading: "Installed Year",
                is_active: false,
                is_static_field: true
            },
            {
                key: "service_life",
                width: 1,
                heading: "Service Life",
                is_active: false,
                is_static_field: true
            },
            {
                key: "usefull_life_remaining",
                width: 1,
                heading: "Usefull Life Remaining",
                is_active: false,
                is_static_field: true
            },
            {
                key: "crv",
                width: 1,
                heading: "Crv",
                is_active: false,
                is_static_field: true
            },
            {
                key: "essential",
                width: 1,
                heading: "Essential",
                is_active: false,
                is_static_field: true
            },
            {
                key: "surveyor",
                width: 1,
                heading: "Surveyor",
                is_active: false,
                is_static_field: true
            },
            {
                key: "surveyor_role",
                width: 1,
                heading: "Surveyor Role",
                is_static_field: true,
                is_active: false
            },
            {
                key: "inspection_date",
                width: 1,
                heading: "Inspection Date",
                is_active: false,
                is_static_field: true
            },
            {
                key: "source",
                width: 1,
                heading: "Origin",
                is_active: false,
                is_static_field: true
            },
            {
                key: "status",
                width: 1,
                heading: "Status",
                is_active: false,
                is_static_field: true
            },
            {
                key: "recommendation_narrative",
                width: 1,
                heading: "Recommendation Narrative",
                is_active: false,
                is_static_field: true
            },
            {
                key: "fmp",
                width: 1,
                heading: "Fmp",
                is_active: false,
                is_static_field: true
            },
            {
                key: "fmp_id",
                width: 1,
                heading: "Fmp Id",
                is_active: false,
                is_static_field: true
            },
            {
                key: "fmp_track",
                width: 1,
                heading: "Fmp Track",
                is_active: false,
                is_static_field: true
            },
            {
                key: "fmp_project",
                width: 1,
                heading: "Fmp Project",
                is_active: false,
                is_static_field: true
            },
            {
                key: "infrastructure_request",
                width: 1,
                heading: "Capital Request",
                is_active: false,
                is_static_field: true
            },
            {
                key: "red_line",
                width: 1,
                heading: "Red Line",
                is_active: false,
                is_static_field: true
            },
            {
                key: "continuous_fca",
                width: 1,
                heading: "Continuous FCA",
                is_active: false,
                is_static_field: true
            },
            {
                key: "energy_band_show",
                width: 1,
                heading: "Energy Band Show",
                is_active: false,
                is_static_field: true
            },
            {
                key: "water_band_show",
                width: 1,
                heading: "Water Band Show",
                is_active: false,
                is_static_field: true
            },
            {
                key: "unit",
                width: 1,
                heading: "Unit",
                is_active: false,
                is_static_field: true
            },
            {
                key: "cost_per_unit",
                width: 1,
                heading: "Cost Per Unit",
                is_active: false,
                is_static_field: true
            },
            {
                key: "quantity",
                width: 1,
                heading: "Quantity",
                is_active: false,
                is_static_field: true
            },
            {
                key: "options_cost",
                width: 1,
                heading: "Opinions of Cost",
                is_active: false,
                is_static_field: true
            },
            {
                key: "created_at",
                width: 1,
                heading: "Created At",
                is_active: false,
                is_static_field: true
            },
            {
                key: "updated_at",
                width: 1,
                heading: "Updated At",
                is_active: false,
                is_static_field: true
            },
            {
                key: "years_with_value",
                width: 1,
                heading: "Year(s)",
                is_active: false,
                is_custom_field: true
            },
            {
                key: "asset_client_condition",
                width: 1,
                heading: "Asset Condition",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_tag",
                width: 1,
                heading: "Asset Tag",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_serial_number",
                width: 1,
                heading: "Asset Serial Number",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_installed_year",
                width: 1,
                heading: "Asset Installed Year",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_current_age",
                width: 1,
                heading: "Asset Current Age",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_service_life",
                width: 1,
                heading: "Asset Service Life",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_end_of_service_life",
                width: 1,
                heading: "Asset End of Service Life",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_usefull_life_remaining",
                width: 1,
                heading: "Asset Useful Life Remaining",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_model_number",
                width: 1,
                heading: "Asset Model Number",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_manufacturer",
                width: 1,
                heading: "Asset Manufacturer",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_capacity",
                width: 1,
                heading: "Asset Capacity",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_capacity_unit",
                width: 1,
                heading: "Asset Capacity Unit",
                is_active: false,
                is_static_field: true
            },
            {
                key: "asset_refrigerant",
                width: 1,
                heading: "Asset Refrigerant",
                is_active: false,
                is_static_field: true
            },
            {
                key: "client_site_id",
                width: 1,
                heading: "Client Site ID",
                is_active: false,
                is_static_field: true
            },
            {
                key: "criticality_type",
                width: 1,
                heading: "Criticality Type",
                is_active: false,
                is_static_field: true
            },
            {
                key: "image",
                width: 1,
                heading: "Image",
                is_active: false,
                is_static_field: true
            }
        ]
    },
    bbi_bsi_props: {},
    basic_props: { bsi: {} }
};
class Form extends Component {
    state = {
        showErrorBorder: false,
        property: initial_state,
        colorModalState: null,
        activeDetail: "chart",
        initialValues: {},
        selectedTab: "chart",
        isYearValid: true,
        totalRowsForColumnDnd:
            initial_state?.properties?.comp_analysis?.ca_recommendation &&
            Object?.keys(initial_state?.properties?.comp_analysis?.ca_recommendation)?.length
                ? Math.trunc(Object?.keys(initial_state?.properties?.comp_analysis?.ca_recommendation)?.length / 4) +
                  (Object?.keys(initial_state?.properties?.comp_analysis?.ca_recommendation)?.length % 4 ? 1 : 0)
                : 0,
        resetToGlobalDefaultValue: false,
        resetConfirmationModal: false,
        resetToDefaultBandKeys: {},
        // only the edit form fetches the saved property, so the add form needs no overlay
        isFormLoading: !!(this.props.selectedProperty && this.props.selectedProperty !== "undefined")
    };

    componentDidMount = async () => {
        const { isSmartchartView, match } = this.props;
        await this.props.getDropdownList("fonts");
        this.props.getDropdownList("table_styles");
        if (this.props.selectedProperty && this.props.selectedProperty !== "undefined") {
            let propertyData = {};
            if (isSmartchartView) {
                await this.props.getPropertyById(this.props.selectedProperty);
                propertyData = this.props.chartPropertyReducer.getPropertyByIdResponse;
            } else {
                propertyData = await this.props.getPropertyDataById();
            }
            await this.setState({
                property: {
                    ...this.state.property,
                    id: propertyData.id,
                    name: propertyData.name,
                    client_id: propertyData?.client?.id,
                    description: propertyData.description,
                    notes: propertyData.notes,
                    // properties: propertyData.properties,
                    properties: {
                        ...propertyData.properties,
                        chart: {
                            ...propertyData.properties?.chart,
                            frame_props: {
                                ...this.state.property.properties.chart.frame_props,
                                ...propertyData.properties?.chart?.frame_props
                            }
                        },
                        custom_legend: {
                            show_legend: true,
                            ...propertyData?.properties?.custom_legend
                        },
                        total: {
                            show_total: true,
                            ...propertyData.properties.total
                        },
                        legend: {
                            ...this.state.property.properties.legend,
                            ...propertyData.properties.legend
                        },
                        table: {
                            ...this.state.property.properties.table,
                            ...propertyData.properties.table,
                            data: {
                                ...this.state.property.properties.table.data,
                                ...propertyData?.properties?.table?.data
                            },
                            sub_total: {
                                ...this.state.property.properties.table.sub_total,
                                ...propertyData?.properties?.table?.sub_total
                            },
                            header: {
                                ...this.state.property.properties.table.header,
                                ...propertyData?.properties?.table?.header
                            },
                            heading: {
                                ...this.state.property.properties.table.heading,
                                ...propertyData?.properties?.table?.heading
                            },
                            custom_head: {
                                ...this.state.property.properties.table.custom_head,
                                ...propertyData?.properties?.table?.custom_head
                            }
                        },
                        comp_analysis: {
                            table: {
                                ...this.state.property.properties?.comp_analysis?.table,
                                ...propertyData.properties?.comp_analysis?.table,
                                data: {
                                    ...this.state.property.properties?.comp_analysis?.table?.data,
                                    ...propertyData?.properties?.comp_analysis?.table?.data
                                },
                                sub_total: {
                                    ...this.state.property.properties?.comp_analysis?.table?.sub_total,
                                    ...propertyData?.properties?.comp_analysis?.table?.sub_total
                                },
                                heading: {
                                    ...this.state.property.properties?.comp_analysis?.table?.heading,
                                    ...propertyData?.properties?.comp_analysis?.table?.heading
                                },
                                custom_head: {
                                    ...this.state.property.properties?.comp_analysis?.table?.custom_head,
                                    ...propertyData?.properties?.comp_analysis?.table?.custom_head
                                }
                            },

                            ca_recommendation:
                                propertyData?.properties?.comp_analysis?.ca_recommendation &&
                                Object.keys(propertyData?.properties?.comp_analysis?.ca_recommendation)?.length
                                    ? typeof propertyData?.properties?.comp_analysis?.ca_recommendation === "string"
                                        ? JSON.parse(propertyData?.properties?.comp_analysis?.ca_recommendation)
                                        : propertyData?.properties?.comp_analysis?.ca_recommendation
                                    : { ...this.state.property.properties?.comp_analysis?.ca_recommendation },
                            ca_asset:
                                propertyData?.properties?.comp_analysis?.ca_asset &&
                                Object.keys(propertyData?.properties?.comp_analysis?.ca_asset)?.length
                                    ? typeof propertyData?.properties?.comp_analysis?.ca_asset === "string"
                                        ? JSON.parse(propertyData?.properties?.comp_analysis?.ca_asset)
                                        : propertyData?.properties?.comp_analysis?.ca_asset
                                    : { ...this.state.property.properties?.comp_analysis?.ca_asset }
                        },
                        memo_properties: {
                            ...this.state.property.properties.memo_properties,
                            ...propertyData?.properties?.memo_properties,
                            body: {
                                ...this.state.property.properties.memo_properties?.body,
                                ...propertyData?.properties?.memo_properties?.body
                            },
                            heading: {
                                ...this.state.property.properties.memo_properties?.heading,
                                ...propertyData?.properties?.memo_properties?.heading
                            }
                        }
                    },
                    recommendation_props: {
                        ...propertyData.recommendation_props,
                        year: {
                            ...this.state.property.recommendation_props?.year,
                            ...propertyData?.recommendation_props?.year
                        },
                        body: {
                            ...this.state.property.recommendation_props?.body,
                            ...propertyData?.recommendation_props?.body
                        },
                        site: {
                            ...this.state.property.recommendation_props?.site,
                            ...propertyData?.recommendation_props?.site
                        },
                        addition: {
                            ...this.recommendation_props?.addition,
                            ...propertyData?.recommendation_props?.addition
                        },
                        building: {
                            ...this.state.property.recommendation_props?.building,
                            ...propertyData?.recommendation_props?.building
                        },
                        grand_total: {
                            ...this.state.property.recommendation_props?.grand_total,
                            ...propertyData?.recommendation_props?.grand_total
                        },
                        table_style: {
                            ...this.state.property.recommendation_props?.table_style,
                            ...propertyData?.recommendation_props?.table_style
                        },
                        table_heading: {
                            ...this.state.property.recommendation_props?.table_heading,
                            ...propertyData?.recommendation_props?.table_heading
                        },
                        custom_heading: {
                            ...this.state.property.recommendation_props?.custom_heading,
                            ...propertyData?.recommendation_props?.custom_heading
                        },
                        properties: propertyData?.recommendation_props?.properties?.length
                            ? propertyData?.recommendation_props?.properties.find(e => e?.key === "years_with_value")
                                ? propertyData?.recommendation_props?.properties
                                : [
                                      ...propertyData?.recommendation_props?.properties,
                                      {
                                          key: "years_with_value",
                                          width: 1,
                                          heading: "Year(s)",
                                          is_active: false,
                                          is_custom_field: true
                                      }
                                  ]
                            : [...this.state.property?.recommendation_props?.properties]
                    },
                    multi_recommendation_props: {
                        ...propertyData.multi_recommendation_props,
                        body: {
                            ...this.multi_recommendation_props?.body,
                            ...propertyData?.multi_recommendation_props?.body
                        },
                        heading: {
                            ...this.multi_recommendation_props?.heading,
                            ...propertyData?.multi_recommendation_props?.heading
                        },
                        caption: {
                            ...this.multi_recommendation_props?.caption,
                            ...propertyData?.multi_recommendation_props?.caption
                        },
                        notes: {
                            ...this.multi_recommendation_props?.notes,
                            ...propertyData?.multi_recommendation_props?.notes
                        },
                        sub_total: {
                            ...this.state.property.multi_recommendation_props.sub_total,
                            ...propertyData?.multi_recommendation_props?.sub_total
                        },
                        filter_by_custom_props: {
                            ...this.state.property.multi_recommendation_props.filter_by_custom_props,
                            ...propertyData?.multi_recommendation_props?.filter_by_custom_props,
                            filter_custom_heading: {
                                ...this.state.property.multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading,
                                ...propertyData?.multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading
                            },
                            filter_by_props: {
                                ...this.state.property.multi_recommendation_props?.filter_by_custom_props?.filter_by_props,
                                ...propertyData?.multi_recommendation_props?.filter_by_custom_props?.filter_by_props,
                                labels: {
                                    ...this.state.property.multi_recommendation_props.filter_by_custom_props?.filter_by_props?.labels,
                                    ...propertyData?.multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels
                                },
                                values: {
                                    ...this.state.property.multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values,
                                    ...propertyData?.multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values
                                }
                            }
                        },
                        memo_properties: {
                            ...this.state.property.multi_recommendation_props.memo_properties,
                            ...propertyData?.multi_recommendation_props?.memo_properties,
                            body: {
                                ...this.state.property.multi_recommendation_props.memo_properties?.body,
                                ...propertyData?.multi_recommendation_props?.memo_properties?.body
                            },
                            heading: {
                                ...this.state.property.multi_recommendation_props.memo_properties?.heading,
                                ...propertyData?.multi_recommendation_props?.memo_properties?.heading
                            }
                        }
                    },
                    normal_recommendation_props: {
                        ...this.state.property.normal_recommendation_props,
                        table: {
                            ...this.state.property.normal_recommendation_props.table,
                            ...propertyData?.normal_recommendation_props?.table,
                            data: {
                                ...this.state.property.normal_recommendation_props.table.data,
                                ...propertyData?.normal_recommendation_props?.table?.data
                            },
                            sub_total: {
                                ...this.state.property.normal_recommendation_props.table.sub_total,
                                ...propertyData?.normal_recommendation_props?.table?.sub_total
                            },
                            heading: {
                                ...this.state.property.normal_recommendation_props.table.heading,
                                ...propertyData?.normal_recommendation_props?.table?.heading
                            },
                            custom_head: {
                                ...this.state.property.normal_recommendation_props.table.custom_head,
                                ...propertyData?.normal_recommendation_props?.table?.custom_head
                            }
                        },
                        year: {
                            ...this.state.property.normal_recommendation_props.year,
                            ...propertyData?.normal_recommendation_props?.year
                        },
                        properties: propertyData?.normal_recommendation_props?.properties?.length
                            ? propertyData?.normal_recommendation_props?.properties.find(e => e?.key === "years_with_value")
                                ? propertyData?.normal_recommendation_props?.properties
                                : [
                                      ...propertyData?.normal_recommendation_props?.properties,
                                      {
                                          key: "years_with_value",
                                          width: 1,
                                          heading: "Year(s)",
                                          is_active: false,
                                          is_custom_field: true
                                      }
                                  ]
                            : [...this.state.property?.normal_recommendation_props?.properties]
                    },
                    asset_props: {
                        ...this.state.property.asset_props,
                        table: {
                            ...this.state.property.asset_props.table,
                            ...propertyData?.asset_props?.table,
                            data: {
                                ...this.state.property.asset_props.table.data,
                                ...propertyData?.asset_props?.table?.data
                            },
                            sub_total: {
                                ...this.state.property.asset_props.table.sub_total,
                                ...propertyData?.asset_props?.table?.sub_total
                            },
                            heading: {
                                ...this.state.property.asset_props.table.heading,
                                ...propertyData?.asset_props?.table?.heading
                            },
                            custom_head: {
                                ...this.state.property.asset_props.table.custom_head,
                                ...propertyData?.asset_props?.table?.custom_head
                            }
                        },
                        properties: propertyData?.asset_props?.properties?.length
                            ? propertyData?.asset_props?.properties.find(e => e?.key === "years_with_value")
                                ? propertyData?.asset_props?.properties
                                : [...propertyData?.asset_props?.properties]
                            : [...this.state.property?.asset_props?.properties]
                    },
                    bbi_bsi_props: {
                        ...this.state.property?.bbi_bsi_props,
                        ...propertyData.bbi_bsi_props,
                        bbi_heading: {
                            ...this.state.property?.bbi_bsi_props?.bbi_heading,
                            ...propertyData?.bbi_bsi_props?.bbi_heading
                        },
                        bbi_sub_heading: {
                            ...this.state.property?.bbi_bsi_props?.bbi_sub_heading,
                            ...propertyData?.bbi_bsi_props?.bbi_sub_heading,
                            font_id: propertyData?.bbi_bsi_props?.bbi_sub_heading?.font_id
                                ? propertyData?.bbi_bsi_props?.bbi_sub_heading?.font_id
                                : this.findFontId(this.state.property?.bbi_bsi_props?.bbi_sub_heading?.font_family)
                        },
                        bbi_heading_executive_summary: {
                            ...this.state.property?.bbi_bsi_props?.bbi_heading_executive_summary,
                            ...propertyData?.bbi_bsi_props?.bbi_heading_executive_summary
                        },
                        executive_summary: {
                            ...this.bbi_bsi_props?.executive_summary,
                            additional: {
                                ...this.state.property?.bbi_bsi_props?.executive_summary?.additional,
                                ...propertyData?.bbi_bsi_props?.executive_summary?.additional,
                                font_id: propertyData?.bbi_bsi_props?.executive_summary?.additional?.font_id
                                    ? propertyData?.bbi_bsi_props?.executive_summary?.additional?.font_id
                                    : this.findFontId(this.state.property?.bbi_bsi_props?.executive_summary?.additional?.font_family)
                            },
                            trade: {
                                ...this.state.property?.bbi_bsi_props?.executive_summary?.trade,
                                ...propertyData?.bbi_bsi_props?.executive_summary?.trade,
                                font_id: propertyData?.bbi_bsi_props?.executive_summary?.trade?.font_id
                                    ? propertyData?.bbi_bsi_props?.executive_summary?.trade?.font_id
                                    : this.findFontId(this.state.property?.bbi_bsi_props?.executive_summary?.trade?.font_family)
                            }
                        },
                        bbi_table: {
                            ...this.state.property?.bbi_bsi_props?.bbi_table,
                            ...propertyData?.bbi_bsi_props?.bbi_table,
                            building_fields_heading: {
                                ...this.state.property?.bbi_bsi_props?.bbi_table?.building_fields_heading,
                                ...propertyData?.bbi_bsi_props?.bbi_table?.building_fields_heading,
                                font_id: propertyData?.bbi_bsi_props?.bbi_table?.building_fields_heading?.font_id
                                    ? propertyData?.bbi_bsi_props?.bbi_table?.building_fields_heading?.font_id
                                    : this.findFontId(this.state.property?.bbi_bsi_props?.bbi_table?.building_fields_heading?.font_family)
                            },
                            addition_fields_heading: {
                                ...this.state.property?.bbi_bsi_props?.bbi_table?.addition_fields_heading,
                                ...propertyData?.bbi_bsi_props?.bbi_table?.addition_fields_heading,
                                font_id: propertyData?.bbi_bsi_props?.bbi_table?.addition_fields_heading?.font_id
                                    ? propertyData?.bbi_bsi_props?.bbi_table?.addition_fields_heading?.font_id
                                    : this.findFontId(this.state.property?.bbi_bsi_props?.bbi_table?.addition_fields_heading?.font_family)
                            },
                            dynamic_fields_heading: {
                                ...this.state.property?.bbi_bsi_props?.bbi_table?.dynamic_fields_heading,
                                ...propertyData?.bbi_bsi_props?.bbi_table?.dynamic_fields_heading,
                                font_id: propertyData?.bbi_bsi_props?.bbi_table?.dynamic_fields_heading?.font_id
                                    ? propertyData?.bbi_bsi_props?.bbi_table?.dynamic_fields_heading?.font_id
                                    : this.findFontId(this.state.property?.bbi_bsi_props?.bbi_table?.dynamic_fields_heading?.font_family)
                            },
                            table_fields: {
                                ...this.state.property?.bbi_bsi_props?.bbi_table?.table_fields,
                                ...propertyData?.bbi_bsi_props?.bbi_table?.table_fields,
                                font_id: propertyData?.bbi_bsi_props?.bbi_table?.table_fields?.font_id
                                    ? propertyData?.bbi_bsi_props?.bbi_table?.table_fields?.font_id
                                    : this.findFontId(this.state.property?.bbi_bsi_props?.bbi_table?.table_fields?.font_family)
                            },
                            table_field_value: {
                                ...this.state.property?.bbi_bsi_props?.bbi_table?.table_field_value,
                                ...propertyData?.bbi_bsi_props?.bbi_table?.table_field_value,
                                font_id: propertyData?.bbi_bsi_props?.bbi_table?.table_field_value?.font_id
                                    ? propertyData?.bbi_bsi_props?.bbi_table?.table_field_value?.font_id
                                    : this.findFontId(this.state.property?.bbi_bsi_props?.bbi_table?.table_field_value?.font_family)
                            },
                            bbi_table_column_configuration: {
                                fields: {
                                    building_fields:
                                        propertyData?.bbi_bsi_props?.bbi_table?.bbi_table_column_configuration?.fields?.building_fields?.length > 0
                                            ? [...propertyData.bbi_bsi_props.bbi_table.bbi_table_column_configuration.fields.building_fields]
                                            : [
                                                  ...(this.state.property?.bbi_bsi_props?.bbi_table?.bbi_table_column_configuration?.fields
                                                      ?.building_fields || [])
                                              ],

                                    addition_fields:
                                        propertyData?.bbi_bsi_props?.bbi_table?.bbi_table_column_configuration?.fields?.addition_fields?.length > 0
                                            ? [...propertyData.bbi_bsi_props.bbi_table.bbi_table_column_configuration.fields.addition_fields]
                                            : [
                                                  ...(this.state.property?.bbi_bsi_props?.bbi_table?.bbi_table_column_configuration?.fields
                                                      ?.addition_fields || [])
                                              ],

                                    other_fields:
                                        propertyData?.bbi_bsi_props?.bbi_table?.bbi_table_column_configuration?.fields?.other_fields?.length > 0
                                            ? [...propertyData.bbi_bsi_props.bbi_table.bbi_table_column_configuration.fields.other_fields]
                                            : [
                                                  ...(this.state.property?.bbi_bsi_props?.bbi_table?.bbi_table_column_configuration?.fields
                                                      ?.other_fields || [])
                                              ]
                                }
                            }
                        },
                        memo_properties: {
                            ...this.state.property?.bbi_bsi_props?.memo_properties,
                            ...propertyData?.bbi_bsi_props?.memo_properties,
                            body: {
                                ...this.state.property?.bbi_bsi_props?.memo_properties?.body,
                                ...propertyData?.bbi_bsi_props?.memo_properties?.body
                            },
                            heading: {
                                ...this.state.property?.bbi_bsi_props?.memo_properties?.heading,
                                ...propertyData?.bbi_bsi_props?.memo_properties?.heading
                            }
                        },
                        stop_light: {
                            ...this.state.property?.bbi_bsi_props?.stop_light,
                            ...propertyData?.bbi_bsi_props?.stop_light
                        }
                    },
                    basic_props: {
                        ...this.state.property?.basic_props,
                        bsi: this.getBasicPropsInitialData("bsi", propertyData),
                        bai: this.getBasicPropsInitialData("bai", propertyData)
                    }
                }
            });
        } else {
            const {
                location: { search }
            } = this.props;
            const query = qs.parse(search);
            await this.props?.bbiDefaultGetProperty({ client_id: query?.client_id });
            await this.props?.bsiDefaultGetProperty({ client_id: query?.client_id });
            await this.props?.baiDefaultGetProperty({ client_id: query?.client_id });
            const { defaultPropertyGetResponse, defaultBsiPropertyGetResponse, defaultBaiPropertyGetResponse } = this.props.chartPropertyReducer;
            await this.setState({
                property: {
                    ...this.state.property,
                    client_id: query?.client_id,
                    bbi_bsi_props: { ...defaultPropertyGetResponse?.data },
                    basic_props: {
                        ...this.state.property?.basic_props,
                        bsi: { ...defaultBsiPropertyGetResponse?.data },
                        bai: { ...defaultBaiPropertyGetResponse?.data }
                    }
                }
            });
        }
        const totalRows =
            this.state.property?.properties?.comp_analysis?.ca_recommendation &&
            Object?.keys(this.state.property?.properties?.comp_analysis?.ca_recommendation)?.length
                ? Math.trunc(Object?.keys(this.state.property?.properties?.comp_analysis?.ca_recommendation)?.length / 4) +
                  (Object?.keys(this.state.property?.properties?.comp_analysis?.ca_recommendation)?.length % 4 ? 1 : 0)
                : 0;
        this.setState({ totalRowsForColumnDnd: totalRows, selectedTab: match?.params?.tab || "chart" });

        this.setState({ initialValues: _.cloneDeep(this.state.property), isFormLoading: false });
    };
    componentDidUpdate = async (prevProps, prevState) => {
        if (this.props?.isCancel !== prevProps?.isCancel) {
            this.props?.isCancel && this.cancelForm();
        }
        if (prevState.selectedTab !== this.state.selectedTab) {
            ReactTooltip.rebuild();
        }

        // unsaved prompt
        if (prevState.property !== this.state.property) {
            if (
                this.state.initialValues &&
                Object.keys(this.state.initialValues)?.length &&
                !isEqual(this.state.initialValues, this.state.property)
            ) {
                this.props.setFormDirty(true);
            } else {
                this.props.setFormDirty(false);
            }
        }
    };

    getBasicPropsInitialData = (sectionKey, propertyData) => {
        const stateSection = this.state.property?.basic_props?.[sectionKey] || {};
        const dataSection = propertyData?.basic_props?.[sectionKey] || {};

        const getFontId = (fontId, fallbackFont) => (fontId ? fontId : this.findFontId(fallbackFont));
        return {
            ...stateSection,
            ...dataSection,
            [`bbi_heading`]: {
                ...stateSection?.[`bbi_heading`],
                ...dataSection?.[`bbi_heading`]
            },
            [`bbi_sub_heading`]: {
                ...stateSection?.[`bbi_sub_heading`],
                ...dataSection?.[`bbi_sub_heading`],
                font_id: getFontId(dataSection?.[`bbi_sub_heading`]?.font_id, stateSection?.[`bbi_sub_heading`]?.font_family)
            },
            [`bbi_heading_executive_summary`]: {
                ...stateSection?.[`bbi_heading_executive_summary`],
                ...dataSection?.[`bbi_heading_executive_summary`]
            },
            executive_summary: {
                ...stateSection?.executive_summary,

                additional: {
                    ...stateSection?.executive_summary?.additional,
                    ...dataSection?.executive_summary?.additional,
                    font_id: getFontId(dataSection?.executive_summary?.additional?.font_id, stateSection?.executive_summary?.additional?.font_family)
                },

                trade: {
                    ...stateSection?.executive_summary?.trade,
                    ...dataSection?.executive_summary?.trade,
                    font_id: getFontId(dataSection?.executive_summary?.trade?.font_id, stateSection?.executive_summary?.trade?.font_family)
                }
            },
            [`bbi_table`]: {
                ...stateSection?.[`bbi_table`],
                ...dataSection?.[`bbi_table`],
                building_fields_heading: {
                    ...stateSection?.[`bbi_table`]?.building_fields_heading,
                    ...dataSection?.[`bbi_table`]?.building_fields_heading,
                    font_id: getFontId(
                        dataSection?.[`bbi_table`]?.building_fields_heading?.font_id,
                        stateSection?.[`bbi_table`]?.building_fields_heading?.font_family
                    )
                },
                ...(sectionKey === "bsi"
                    ? {
                          addition_fields_heading: {
                              ...stateSection?.[`bbi_table`]?.addition_fields_heading,
                              ...dataSection?.[`bbi_table`]?.addition_fields_heading,
                              font_id: getFontId(
                                  dataSection?.[`bbi_table`]?.addition_fields_heading?.font_id,
                                  stateSection?.[`bbi_table`]?.addition_fields_heading?.font_family
                              )
                          }
                      }
                    : null),
                table_fields: {
                    ...stateSection?.[`bbi_table`]?.table_fields,
                    ...dataSection?.[`bbi_table`]?.table_fields,
                    font_id: getFontId(dataSection?.[`bbi_table`]?.table_fields?.font_id, stateSection?.[`bbi_table`]?.table_fields?.font_family)
                },
                table_field_value: {
                    ...stateSection?.[`bbi_table`]?.table_field_value,
                    ...dataSection?.[`bbi_table`]?.table_field_value,
                    font_id: getFontId(
                        dataSection?.[`bbi_table`]?.table_field_value?.font_id,
                        stateSection?.[`bbi_table`]?.table_field_value?.font_family
                    )
                },
                [`bbi_table_column_configuration`]: {
                    fields: {
                        building_fields: dataSection?.[`bbi_table`]?.[`bbi_table_column_configuration`]?.fields?.building_fields?.length
                            ? [...dataSection[`bbi_table`][`bbi_table_column_configuration`].fields.building_fields]
                            : [...(stateSection?.[`bbi_table`]?.[`bbi_table_column_configuration`]?.fields?.building_fields || [])],

                        addition_fields: dataSection?.[`bbi_table`]?.[`bbi_table_column_configuration`]?.fields?.addition_fields?.length
                            ? [...dataSection[`bbi_table`][`bbi_table_column_configuration`].fields.addition_fields]
                            : [...(stateSection?.[`bbi_table`]?.[`bbi_table_column_configuration`]?.fields?.addition_fields || [])],

                        other_fields: dataSection?.[`bbi_table`]?.[`bbi_table_column_configuration`]?.fields?.other_fields?.length
                            ? [...dataSection[`bbi_table`][`bbi_table_column_configuration`].fields.other_fields]
                            : [...(stateSection?.[`bbi_table`]?.[`bbi_table_column_configuration`]?.fields?.other_fields || [])]
                    }
                }
            },
            memo_properties: {
                ...stateSection?.memo_properties,
                ...dataSection?.memo_properties,
                body: {
                    ...stateSection?.memo_properties?.body,
                    ...dataSection?.memo_properties?.body
                },
                heading: {
                    ...stateSection?.memo_properties?.heading,
                    ...dataSection?.memo_properties?.heading
                }
            },
            stop_light: {
                ...stateSection?.stop_light,
                ...dataSection?.stop_light
            }
        };
    };

    componentWillUnmount() {
        ReactTooltip.hide();
    }
    findFontId = fontFamily => {
        const {
            dropDownList: { fonts: FONT_FAMILY, table_styles: TABLE_STYLE }
        } = this.props.reportPropertyReducer;
        return FONT_FAMILY?.find(e => e?.name === fontFamily)?.id || "";
    };
    validate = () => {
        const {
            properties: { header, heading, chart, custom_legend, total },
            name,
            description,
            normal_recommendation_props: { year }
        } = this.state.property;

        if (
            !name?.trim()?.length ||
            !description?.trim()?.length ||
            !header?.project?.font_id ||
            !header?.project?.font_size ||
            !header?.project?.color ||
            // !header?.project?.bold ||
            !header?.client?.font_id ||
            !header?.client?.font_size ||
            !header?.client?.color ||
            // !header?.client?.bold ||
            !heading?.font_id ||
            !heading?.font_size ||
            !heading?.color ||
            !heading?.alignment ||
            // !heading?.bold ||
            (custom_legend.show_legend && !custom_legend?.legend_heading?.font_id) ||
            (custom_legend.show_legend && !custom_legend?.legend_heading?.font_size) ||
            !custom_legend?.legend_heading?.color ||
            !custom_legend?.legend_heading?.alignment ||
            // !custom_legend?.legend_heading?.bold ||
            (custom_legend.show_legend && !custom_legend?.legend_value?.font_id) ||
            (custom_legend.show_legend && !custom_legend?.legend_value?.font_size) ||
            !custom_legend?.legend_value?.color ||
            !custom_legend?.legend_value?.alignment ||
            // !custom_legend?.legend_value?.bold ||
            (total.show_total && !total?.font_id) ||
            (total.show_total && !total?.font_size) ||
            !total?.color
            // ||!total?.alignment
            // !total?.bold
        ) {
            this.setState({ showErrorBorder: true, isYearValid: true });
            return false;
        }
        // if (!year.end_count || !year.start_count) {
        //     this.setState({ showErrorBorder: true, isYearValid: true });
        //     return false;
        // }
        // if (!this.state.property?.recommendation_props?.year?.end_count || !this.state.property?.recommendation_props?.year?.start_count) {
        //     this.setState({ showErrorBorder: true, isYearValid: true });
        //     return false;
        // }
        if (
            year.start_count > year.end_count ||
            this.state.property?.recommendation_props?.year?.start_count > this.state.property?.recommendation_props?.year?.end_count
        ) {
            this.setState({ showErrorBorder: true, isYearValid: false });
            return false;
        }
        return true;
    };

    handleSubmit = () => {
        if (this.validate()) {
            this.props.setFormDirty(false);
            let updatedProperty = { ...this.state.property };
            if (updatedProperty?.properties?.comp_analysis?.ca_recommendation) {
                updatedProperty.properties.comp_analysis.ca_recommendation = JSON.stringify(
                    updatedProperty.properties.comp_analysis.ca_recommendation
                );
            }
            if (updatedProperty?.properties?.comp_analysis?.ca_asset) {
                updatedProperty.properties.comp_analysis.ca_asset = JSON.stringify(updatedProperty.properties.comp_analysis.ca_asset);
            }
            if (this.props.selectedProperty && this.props.selectedProperty !== "undefined") {
                this.props.handleUpdateProperty(updatedProperty, this.state?.selectedTab);
            } else {
                this.props.handleAddProperty(updatedProperty, this.state?.selectedTab);
            }
        }
    };

    cancelForm = () => {
        if (deepCompareObjects(this.state?.property, this.state?.initialValues)) {
            this.clearForm();
        } else {
            this.setState({
                showConfirmModal: true
            });
        }
    };

    clearForm = async () => {
        await this.props.setFormDirty(false);

        // this.setState({
        //     property: initial_state,
        //     initialValues: initial_state
        // });
        this.props.cancelForm();
    };

    renderConfirmationModal = () => {
        const { showConfirmModal } = this.state;
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={`Do you want to CANCEL all changes performed in the current ${
                            this.props.selectedProperty ? "Edit" : "Add"
                        } session?`}
                        message={
                            <>
                                By hitting Cancel you will lose any changes performed in current {this.props.selectedProperty ? "Edit" : "Add"}{" "}
                                session.
                                <p>This action cannot be reverted.</p>
                                <p className="cancel-txt"> Are you sure you want to Cancel?</p>
                            </>
                        }
                        onNo={() => {
                            this.setState({ showConfirmModal: false });
                            this.props?.setIsCancel && this.props?.setIsCancel(false);
                        }}
                        onYes={this.clearForm}
                        messageClassName="pl-3 pr-3 mb-1"
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    handleChangeBasicDetails = e => {
        const { name, value } = e.target;
        const { property } = this.state;
        this.setState({
            property: { ...property, [name]: value }
        });
    };
    handleChangeHeader = (prop, key, value) => {
        const { property } = this.state;
        const { properties } = property;
        const { header } = properties;
        this.setState({
            property: { ...property, properties: { ...properties, header: { ...header, [prop]: { ...header[prop], [key]: value } } } }
        });
    };

    handleChangeCustomLegend = (prop, key, value) => {
        const { property } = this.state;
        const { properties } = property;
        const { custom_legend } = properties;
        this.setState({
            property: {
                ...property,
                properties: { ...properties, custom_legend: { ...custom_legend, [prop]: { ...custom_legend[prop], [key]: value } } }
            }
        });
    };

    handleDisplaySettings = (masterKey, key, selectedValue) => {
        const { property } = this.state;
        const { properties } = property;

        const displayFormats = selectedValue === "true" ? ["M"] : ["K", "M"];

        // if custom_legend
        const isCustomLegend = masterKey === "custom_legend";

        this.setState({
            property: {
                ...property,
                properties: {
                    ...properties,
                    [masterKey]: {
                        ...properties[masterKey],
                        ...(isCustomLegend
                            ? {
                                  legend_value: {
                                      ...properties[masterKey].legend_value,
                                      [key]: displayFormats
                                  }
                              }
                            : {
                                  [key]: displayFormats
                              })
                    }
                }
            }
        });
    };

    handleChangeChart = (masterKey, key, value) => {
        const { property } = this.state;
        const { properties } = property;
        this.setState({
            property: { ...property, properties: { ...properties, [masterKey]: { ...properties[masterKey], [key]: value } } }
        });
    };
    handleBbiChange = (masterKey, key, value, subKey, subKey2, propertyKey) => {
        const { property } = this.state;

        const isFromBasicProps = !!propertyKey;
        const currentKey = isFromBasicProps ? property.basic_props?.[propertyKey] : property.bbi_bsi_props;

        const update = {};

        if (subKey && subKey2) {
            update[masterKey] = {
                ...currentKey?.[masterKey],
                [subKey]: {
                    ...currentKey?.[masterKey]?.[subKey],
                    [subKey2]: {
                        ...currentKey?.[masterKey]?.[subKey]?.[subKey2],
                        ...(key
                            ? {
                                  [key]:
                                      typeof value === "object"
                                          ? {
                                                ...currentKey?.[masterKey]?.[subKey]?.[subKey2]?.[key],
                                                ...value
                                            }
                                          : value
                              }
                            : typeof value === "object"
                              ? {
                                    ...currentKey?.[masterKey]?.[subKey]?.[subKey2],
                                    ...value
                                }
                              : value)
                    },
                    ...(subKey2 === "structured_heading" && { custom_heading_props: {} }),
                    ...(subKey2 === "custom_heading_props" && { structured_heading: {} })
                }
            };
        } else if (subKey) {
            update[masterKey] = {
                ...currentKey?.[masterKey],
                [subKey]: {
                    ...currentKey?.[masterKey]?.[subKey],
                    ...(key
                        ? {
                              [key]:
                                  typeof value === "object"
                                      ? {
                                            ...currentKey?.[masterKey]?.[subKey]?.[key],
                                            ...value
                                        }
                                      : value
                          }
                        : typeof value === "object"
                          ? {
                                ...currentKey?.[masterKey]?.[subKey],
                                ...value
                            }
                          : value)
                },
                ...(subKey === "structured_heading" && { custom_heading_props: {} }),
                ...(subKey === "custom_heading_props" && { structured_heading: {} })
            };
        } else {
            update[masterKey] = {
                ...currentKey?.[masterKey],
                [key]: value
            };
        }
        this.setState({
            property: {
                ...property,
                ...(isFromBasicProps
                    ? {
                          basic_props: {
                              ...property.basic_props,
                              [propertyKey]: {
                                  ...currentKey,
                                  ...update
                              }
                          }
                      }
                    : {
                          bbi_bsi_props: {
                              ...currentKey,
                              ...update
                          }
                      })
            }
        });
    };

    setActiveTab = activeTab => {
        const { isSmartchartView } = this.props;
        if (isSmartchartView) {
            this.setState({ selectedTab: activeTab });
        } else {
            this.setState({ selectedTab: activeTab });
            let tabKeyList = ["CA", "sortedRecommendations", "multiRecommendation", "normalRecommendation", "asset", "bbi", "bsi", "bai"];
            if (activeTab !== "chart") {
                // this.props.history.push(`/chartProperties/edit/${this.props.match.params.id}/${tabKeyList.includes(activeTab) ? activeTab : null}`);

                history.push({
                    pathname: `/chartProperties/edit/${this.props.match.params.id}/${tabKeyList.includes(activeTab) ? activeTab : null}`,
                    state: { suppressPrompt: true }
                });
            } else {
                // this.props.history.push(`/chartProperties/edit/${this.props.match.params.id}`, { state: { suppressPrompt: true } });

                history.push({
                    pathname: `/chartProperties/edit/${this.props.match.params.id}`,
                    state: { suppressPrompt: true }
                });
            }
        }
    };

    setNormalRecomProperty = (parentKey = null, key, value, isAsset, customKey) => {
        if (customKey) {
            if (isAsset) {
                this.setState({
                    property: {
                        ...this.state.property,
                        asset_props: {
                            ...this.state.property.asset_props,
                            table: {
                                ...this.state.property.asset_props.table,
                                [parentKey]: {
                                    ...this.state.property.asset_props?.table?.[parentKey],
                                    [customKey]: {
                                        ...this.state.property.asset_props?.table?.[parentKey]?.[customKey],
                                        [key]: value
                                    }
                                }
                            }
                        }
                    }
                });
            } else {
                this.setState({
                    property: {
                        ...this.state.property,
                        normal_recommendation_props: {
                            ...this.state.property.normal_recommendation_props,
                            table: {
                                ...this.state.property.normal_recommendation_props.table,
                                [parentKey]: {
                                    ...this.state.property.normal_recommendation_props?.table?.[parentKey],
                                    [customKey]: {
                                        ...this.state.property.normal_recommendation_props?.table?.[parentKey]?.[customKey],
                                        [key]: value
                                    }
                                }
                            }
                        }
                    }
                });
            }
        } else {
            if (!parentKey) {
                if (isAsset) {
                    this.setState({
                        property: {
                            ...this.state.property,
                            asset_props: {
                                ...this.state.property.asset_props,
                                table: {
                                    ...this.state.property.asset_props?.table,
                                    [key]: value
                                }
                            }
                        }
                    });
                } else {
                    this.setState({
                        property: {
                            ...this.state.property,
                            normal_recommendation_props: {
                                ...this.state.property.normal_recommendation_props,
                                table: {
                                    ...this.state.property.normal_recommendation_props?.table,
                                    [key]: value
                                }
                            }
                        }
                    });
                }
                return;
            } else if (parentKey === "yearsValue") {
                this.setState({
                    property: {
                        ...this.state.property,
                        normal_recommendation_props: {
                            ...this.state.property.normal_recommendation_props,
                            year: {
                                ...this.state.property.normal_recommendation_props?.year,

                                [key]: Number(value) || ""
                            }
                        }
                    }
                });
                return;
            }
            if (isAsset) {
                this.setState({
                    property: {
                        ...this.state.property,
                        asset_props: {
                            ...this.state.property.asset_props,
                            table: {
                                ...this.state.property.asset_props?.table,
                                [parentKey]: {
                                    ...this.state.property.asset_props?.table?.[parentKey],
                                    [key]: value
                                }
                            }
                        }
                    }
                });
            } else {
                this.setState({
                    property: {
                        ...this.state.property,
                        normal_recommendation_props: {
                            ...this.state.property.normal_recommendation_props,
                            table: {
                                ...this.state.property.normal_recommendation_props?.table,
                                [parentKey]: {
                                    ...this.state.property.normal_recommendation_props?.table?.[parentKey],
                                    [key]: value
                                }
                            }
                        }
                    }
                });
            }
        }
    };
    setSortedRecommendationProperty = (parentValue = null, key, value, customKey, parentCostomKey = null) => {
        if (customKey) {
            if (!parentCostomKey) {
                this.setState({
                    property: {
                        ...this.state.property,
                        recommendation_props: {
                            ...this.state.property.recommendation_props,
                            [parentValue]: {
                                ...this.state.property.recommendation_props?.[parentValue],
                                [customKey]: {
                                    ...this.state.property.recommendation_props?.[parentValue]?.[customKey],
                                    [key]: value
                                }
                            }
                        }
                    }
                });
            } else {
                this.setState({
                    property: {
                        ...this.state.property,
                        recommendation_props: {
                            ...this.state.property.recommendation_props,
                            [parentValue]: {
                                ...this.state.property.recommendation_props?.[parentValue],
                                [customKey]: {
                                    ...this.state.property.recommendation_props?.[parentValue]?.[customKey],
                                    [key]: value
                                },
                                [parentCostomKey]: {
                                    ...this.state.property.recommendation_props?.[parentValue]?.[customKey],
                                    [key]: 6
                                }
                            }
                        }
                    }
                });
            }
        } else {
            if (!parentValue) {
                this.setState({
                    property: {
                        ...this.state.property,
                        recommendation_props: {
                            ...this.state.property.recommendation_props,

                            [key]: value
                        }
                    }
                });
                return;
            } else if (parentValue === "yearsValue") {
                this.setState({
                    property: {
                        ...this.state.property,
                        recommendation_props: {
                            ...this.state.property.recommendation_props,
                            year: {
                                ...this.state.property.recommendation_props?.year,
                                [key]: Number(value) || ""
                            }
                        }
                    }
                });
                return;
            }
            this.setState({
                property: {
                    ...this.state.property,
                    recommendation_props: {
                        ...this.state.property.recommendation_props,
                        [parentValue]: {
                            ...this.state.property.recommendation_props?.[parentValue],
                            [key]: value
                        }
                    }
                }
            });
        }
    };
    setSortedRecommendationTableColumnConfig = (columnKey, key, value) => {
        this.setState({
            property: {
                ...this.state.property,
                recommendation_props: {
                    ...this.state.property.recommendation_props,
                    properties: this.getUpdatedColumnCofigValues(this.state.property.recommendation_props?.properties, columnKey, key, value)
                }
            }
        });
    };

    setNormalRecommendationTableColumnConfig = (columnKey, key, value, isAsset) => {
        if (isAsset) {
            this.setState({
                property: {
                    ...this.state.property,
                    asset_props: {
                        ...this.state.property.asset_props,
                        properties: this.getUpdatedColumnCofigValues(this.state.property.asset_props?.properties, columnKey, key, value)
                    }
                }
            });
        } else {
            this.setState({
                property: {
                    ...this.state.property,
                    normal_recommendation_props: {
                        ...this.state.property.normal_recommendation_props,
                        properties: this.getUpdatedColumnCofigValues(
                            this.state.property.normal_recommendation_props?.properties,
                            columnKey,
                            key,
                            value
                        )
                    }
                }
            });
        }
    };
    setBbiBsiTableColumnConfig = (columnKey, key, value, type, propertyKey) => {
        const isFromBasicProps = !!propertyKey;
        const { property } = this.state;

        const currentKey = isFromBasicProps ? property.basic_props?.[propertyKey] : property.bbi_bsi_props;

        const updatedFields = {
            ...currentKey?.bbi_table?.bbi_table_column_configuration?.fields,
            [type]: this.getUpdatedColumnCofigValues(
                currentKey?.bbi_table?.bbi_table_column_configuration?.fields?.[type],
                columnKey,
                key,
                value,
                true
            )
        };

        const updatedProperty = {
            ...property,
            ...(isFromBasicProps
                ? {
                      basic_props: {
                          ...property.basic_props,
                          [propertyKey]: {
                              ...currentKey,
                              bbi_table: {
                                  ...currentKey?.bbi_table,
                                  bbi_table_column_configuration: {
                                      fields: updatedFields
                                  }
                              }
                          }
                      }
                  }
                : {
                      bbi_bsi_props: {
                          ...currentKey,
                          bbi_table: {
                              ...currentKey?.bbi_table,
                              bbi_table_column_configuration: {
                                  fields: updatedFields
                              }
                          }
                      }
                  })
        };

        this.setState({ property: updatedProperty });
    };

    setBbiBuildingTableColumnConfig = (columns, propertyKey) => {
        const isFromBasicProps = !!propertyKey;
        const { property } = this.state;

        const currentKey = isFromBasicProps ? property.basic_props?.[propertyKey] : property.bbi_bsi_props;

        const updatedFields = {
            ...currentKey?.bbi_table?.bbi_table_column_configuration?.fields,
            building_fields: columns
        };
        const updatedProperty = {
            ...property,
            ...(isFromBasicProps
                ? {
                      basic_props: {
                          ...property.basic_props,
                          [propertyKey]: {
                              ...currentKey,
                              bbi_table: {
                                  ...currentKey?.bbi_table,
                                  bbi_table_column_configuration: {
                                      fields: updatedFields
                                  }
                              }
                          }
                      }
                  }
                : {
                      bbi_bsi_props: {
                          ...currentKey,
                          bbi_table: {
                              ...currentKey?.bbi_table,
                              bbi_table_column_configuration: {
                                  fields: updatedFields
                              }
                          }
                      }
                  })
        };

        this.setState({ property: updatedProperty });
    };

    setCaColumnConfig = (columnKey, key, value, tableName) => {
        const updatedProperties = {
            ...this.state.property?.properties?.comp_analysis[tableName],

            [columnKey]: {
                ...this.state.property?.properties?.comp_analysis?.[tableName]?.[columnKey],
                [key]: value
            }
        };
        this.setState(prevState => ({
            property: {
                ...prevState.property,
                properties: {
                    ...prevState.property?.properties,
                    comp_analysis: {
                        ...prevState.property?.properties?.comp_analysis,
                        [tableName]: updatedProperties
                    }
                }
            }
        }));
    };
    getUpdatedColumnCofigValues = (configData = [], columnKey, key, value, isBbi) => {
        let updatedValues = [];
        if (configData.length) {
            updatedValues = configData.map(data => {
                if (isBbi ? data?.field_name === columnKey : data?.key === columnKey) {
                    data = {
                        ...data,
                        [key]: value
                    };
                }
                return data;
            });
        }
        return updatedValues || [];
    };

    onRecommendationColumnOrderChange = (updatedColumns, isAsset) => {
        if (isAsset) {
            this.setState({
                property: {
                    ...this.state.property,
                    asset_props: {
                        ...this.state.property.asset_props,
                        properties: [...updatedColumns]
                    }
                }
            });
        } else {
            this.setState({
                property: {
                    ...this.state.property,
                    normal_recommendation_props: {
                        ...this.state.property.normal_recommendation_props,
                        properties: [...updatedColumns]
                    }
                }
            });
        }
    };
    onBBiColumnOrderChange = (updatedColumns, type, propertyKey) => {
        const { property } = this.state;
        const isFromBasicProps = !!propertyKey;

        const currentKey = isFromBasicProps ? property.basic_props?.[propertyKey] : property.bbi_bsi_props;

        const updatedFields = {
            ...currentKey?.bbi_table?.bbi_table_column_configuration?.fields,
            [type]: [...updatedColumns]
        };

        this.setState({
            property: {
                ...property,
                ...(isFromBasicProps
                    ? {
                          basic_props: {
                              ...property.basic_props,
                              [propertyKey]: {
                                  ...currentKey,
                                  bbi_table: {
                                      ...currentKey?.bbi_table,
                                      bbi_table_column_configuration: {
                                          fields: updatedFields
                                      }
                                  }
                              }
                          }
                      }
                    : {
                          bbi_bsi_props: {
                              ...currentKey,
                              bbi_table: {
                                  ...currentKey?.bbi_table,
                                  bbi_table_column_configuration: {
                                      fields: updatedFields
                                  }
                              }
                          }
                      })
            }
        });
    };

    onSortedRecommendationColumnOrderChange = updatedColumns => {
        this.setState({
            property: {
                ...this.state.property,
                recommendation_props: {
                    ...this.state.property.recommendation_props,
                    properties: [...updatedColumns]
                }
            }
        });
    };
    onColumnDnd = additionalString => result => {
        if (!result.destination) {
            return;
        }
        const arrayData = Object.keys(this.state.property?.properties?.comp_analysis?.[additionalString]).map(key => ({
            [key]: this.state.property?.properties?.comp_analysis?.[additionalString][key]
        }));

        const keyList = reorderArray(arrayData, result.source.index, result.destination.index);
        const objectData = keyList.reduce((acc, obj) => {
            const [key, value] = Object.entries(obj)[0];
            return { ...acc, [key]: value };
        }, {});

        this.setState({
            property: {
                ...this.state.property,
                properties: {
                    ...this.state.property?.properties,
                    comp_analysis: {
                        ...this.state.property.properties?.comp_analysis,
                        [additionalString]: objectData
                    }
                }
            }
        });
    };
    ResetToDefault = ({ mainKey, subKeys = [], columnKey = null, columnKey2 = null, columnKey3 = null, band = "" }) => {
        this.setState({ resetToDefaultBandKeys: { mainKey, subKeys, columnKey, columnKey2, columnKey3, band } });
    };

    handleResetBand = (mainKey, subKeys = [], columnKey = null, columnKey2 = null, columnKey3 = null) => {
        this.setState(prevState => {
            const initialValues =
                mainKey === "bsi" || mainKey === "bai"
                    ? prevState.initialValues?.basic_props?.[mainKey] || {}
                    : prevState.initialValues?.[mainKey] || {};

            const getInitialValue = keys => {
                return keys.reduce((acc, key) => acc?.[key] ?? {}, initialValues);
            };

            const currentData =
                mainKey === "bsi" || mainKey === "bai" ? prevState.property?.basic_props?.[mainKey] || {} : prevState.property?.[mainKey] || {};
            let update = {};

            if (columnKey && columnKey2 && columnKey3) {
                update[columnKey] = {
                    ...(currentData?.[columnKey] || {}),
                    [columnKey2]: {
                        ...(currentData?.[columnKey]?.[columnKey2] || {}),
                        [columnKey3]: {
                            ...(currentData?.[columnKey]?.[columnKey2]?.[columnKey3] || {}),
                            ...subKeys.reduce((acc, key) => {
                                acc[key] = getInitialValue([columnKey, columnKey2, columnKey3, key]) ?? "";
                                return acc;
                            }, {})
                        }
                    }
                };
            } else if (columnKey && columnKey2) {
                update[columnKey] = {
                    ...(currentData?.[columnKey] || {}),
                    [columnKey2]: {
                        ...(currentData?.[columnKey]?.[columnKey2] || {}),
                        ...subKeys.reduce((acc, key) => {
                            acc[key] = getInitialValue([columnKey, columnKey2, key]) ?? "";
                            return acc;
                        }, {})
                    }
                };
            } else if (columnKey) {
                update[columnKey] = {
                    ...(currentData?.[columnKey] || {}),
                    ...subKeys.reduce((acc, key) => {
                        acc[key] = getInitialValue([columnKey, key]) ?? "";
                        return acc;
                    }, {})
                };
            } else if (subKeys?.length) {
                update = subKeys.reduce((acc, key) => {
                    acc[key] = getInitialValue([key]) ?? "";
                    return acc;
                }, {});
            } else {
                update = initialValues;
            }
            return {
                property: {
                    ...prevState.property,
                    ...(mainKey === "bsi" || mainKey === "bai"
                        ? {
                              basic_props: {
                                  ...prevState.property.basic_props,
                                  [mainKey]: {
                                      ...(prevState.property.basic_props?.[mainKey] || {}),
                                      ...update
                                  }
                              }
                          }
                        : {
                              [mainKey]: {
                                  ...prevState.property?.[mainKey],
                                  ...update
                              }
                          })
                }
            };
        });
    };
    parseProperty = property => {
        if (property && typeof property === "string") {
            try {
                return JSON.parse(property);
            } catch (error) {
                console.error(`Failed to parse property:`, error);
            }
        }
        return property;
    };
    handleUpdateDefaultProperty = () => {
        const { id, name, client_id, description, notes, ...remainingProperties } =
            this.props.chartPropertyReducer?.globalPropertyEntityParams?.selectedDefaultProperty?.[0] || {};
        if (remainingProperties?.properties?.comp_analysis) {
            const compAnalysis = remainingProperties?.properties?.comp_analysis;
            compAnalysis.ca_asset = this?.parseProperty(compAnalysis?.ca_asset);
            compAnalysis.ca_recommendation = this?.parseProperty(compAnalysis?.ca_recommendation);
        }
        this.setState({
            property: Object.keys(remainingProperties).length ? { ...this.state.property, ...remainingProperties } : this.state.property,
            resetToGlobalDefaultValue: false
        });

        if (!this.props?.isSmartchartView) this.props?.setSelectedDefaultProperty();
    };
    ResetToGlobalDefault = () => {
        this.setState({ resetToGlobalDefaultValue: true });
    };
    renderResetToDefaultExportProperties = () => {
        const { resetToGlobalDefaultValue } = this.state;
        if (!resetToGlobalDefaultValue) return null;
        return (
            <Portal
                body={
                    <DefaultPropertiesModal
                        onCancel={() => {
                            this.setState({ resetToGlobalDefaultValue: false });
                            if (!this.props?.isSmartchartView) this.props?.setSelectedDefaultProperty();
                        }}
                        handleUpdateDefaultProperty={() => {
                            this.setState({ resetConfirmationModal: true });
                        }}
                        exportPropertyId={this.state?.property?.id}
                    />
                }
                onCancel={() => {
                    this.setState({ resetToGlobalDefaultValue: false });
                    if (!this.props?.isSmartchartView) this.props?.setSelectedDefaultProperty();
                }}
            />
        );
    };
    hasBandValueChanged = (mainKey, keys = [], columnKey, columnKey2, columnKey3) => {
        let initial = this.state.initialValues;
        let propertyData = this.state.property;
        if (mainKey === "bsi" || mainKey === "bai") {
            initial = this.state.initialValues?.basic_props;
            propertyData = this.state.property?.basic_props;
        }
        return keys.every(key => {
            let initialValue, propertyValue;

            if (columnKey && columnKey2 && columnKey3) {
                initialValue = initial?.[mainKey]?.[columnKey]?.[columnKey2]?.[columnKey3]?.[key];
                propertyValue = propertyData?.[mainKey]?.[columnKey]?.[columnKey2]?.[columnKey3]?.[key];
            } else if (columnKey && columnKey2) {
                initialValue = initial?.[mainKey]?.[columnKey]?.[columnKey2]?.[key];
                propertyValue = propertyData?.[mainKey]?.[columnKey]?.[columnKey2]?.[key];
            } else if (columnKey) {
                initialValue = initial?.[mainKey]?.[columnKey]?.[key];
                propertyValue = propertyData?.[mainKey]?.[columnKey]?.[key];
            } else {
                initialValue = initial?.[mainKey]?.[key];
                propertyValue = propertyData?.[mainKey]?.[key];
            }

            return JSON.stringify(initialValue) === JSON.stringify(propertyValue);
        });
    };

    renderResetConfirmationModal = () => {
        if (!this.state?.resetConfirmationModal && !Object.keys(this.state?.resetToDefaultBandKeys || {})?.length) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={
                            this.state?.resetConfirmationModal
                                ? "Do you want to update the Chart, Comparative Analysis, Sorted Recommendations, Recommendation Summary, Recommendation Table, Asset Table, BBI,BSI & BAI properties with this set of properties?"
                                : `Are you sure you want to undo the change made in "${this.state?.resetToDefaultBandKeys?.band}" band`
                        }
                        message={null}
                        onNo={() => {
                            this.setState({ resetConfirmationModal: false, resetToDefaultBandKeys: {} });
                        }}
                        onYes={() => {
                            if (this.state?.resetConfirmationModal) this?.handleUpdateDefaultProperty();
                            else this?.handleResetBand(...Object.values(this.state.resetToDefaultBandKeys || {}));
                            this.setState({ resetConfirmationModal: false, resetToDefaultBandKeys: {} });
                        }}
                    />
                }
                onCancel={() => this.setState({ resetConfirmationModal: false, resetToDefaultBandKeys: {} })}
            />
        );
    };

    render() {
        const { property, showErrorBorder, colorModalState, selectedTab } = this.state;
        const {
            name,
            description,
            notes,
            properties,
            recommendation_props,
            multi_recommendation_props,
            normal_recommendation_props,
            asset_props,
            bbi_bsi_props,
            basic_props
        } = property;
        const { bsi = {}, bai = {} } = basic_props || {};
        const {
            header,
            heading,
            chart,
            legend,
            custom_legend,
            total,
            x_axis,
            y_axis,
            data_labels,
            chart_font,
            table,
            comp_analysis,
            memo_properties
        } = properties;

        const {
            dropDownList: { fonts: FONT_FAMILY, table_styles: TABLE_STYLE }
        } = this.props.reportPropertyReducer;
        const { custom_heading, addition, site, body, building, grand_total, table_heading, table_style } = recommendation_props;
        const { isSmartchartView } = this.props;
        const styles = reactCSS({
            default: {
                color: {
                    width: "40px",
                    height: "15px",
                    borderRadius: "3px",
                    zoom: "107%"
                },
                popover: {
                    position: "absolute",
                    zIndex: "3",
                    left: "10px",
                    top: "-310px"
                },
                cover: {
                    position: "fixed",
                    top: "0px",
                    right: "0px",
                    bottom: "0px",
                    left: "0px"
                },
                swatch: {
                    padding: "6px",
                    background: "#ffffff",
                    borderRadius: "2px",
                    cursor: "pointer",
                    display: "inline-block",
                    boxShadow: "0 0 0 1px rgba(0,0,0,.2)"
                }
            }
        });
        const tabKeyMap = {
            charts: "properties",
            CA: "comp_analysis",
            sortedRecommendations: "recommendation_props",
            multiRecommendation: "multi_recommendation_props",
            normalRecommendation: "normal_recommendation_props",
            asset: "asset_props",
            bbi: "bbi_bsi_props"
        };
        return (
            <LoadingOverlay active={this.state.isFormLoading} spinner={<Loader />} fadeSpeed={10}>
                <div className="dtl-sec col-md-12 system-building">
                    <div className="custom-col">
                        <div className="tab-dtl region-mng">
                            <ul>
                                {/* <div className="recom-notify-img">
                                <img src={exclmIcon} alt="" />
                            </div> */}
                                <li
                                    className={
                                        isSmartchartView
                                            ? selectedTab === "chart"
                                                ? " cursor-pointer active pl-4"
                                                : "cursor-pointer"
                                            : !this.props.match.params.tab
                                              ? " cursor-pointer active pl-4"
                                              : "cursor-pointer"
                                    }
                                    onClick={() => this.setActiveTab("chart")}
                                >
                                    {isSmartchartView ? "Chart, Chart Table" : "Chart"}
                                </li>
                                <li
                                    className={
                                        this.props.match.params.tab === "CA" || (isSmartchartView && selectedTab === "CA")
                                            ? " cursor-pointer active pl-4"
                                            : "cursor-pointer"
                                    }
                                    onClick={() => this.setActiveTab("CA")}
                                >
                                    Comparative Analysis
                                </li>
                                {/* {!isSmartchartView && ( */}
                                <>
                                    <li
                                        className={
                                            this.props.match.params.tab === "sortedRecommendations" ||
                                            (isSmartchartView && selectedTab === "sortedRecommendations")
                                                ? " cursor-pointer active pl-4"
                                                : "cursor-pointer"
                                        }
                                        onClick={() => this.setActiveTab("sortedRecommendations")}
                                    >
                                        Sorted Recommendations
                                    </li>
                                    <li
                                        className={
                                            this.props.match.params.tab === "multiRecommendation" ||
                                            (isSmartchartView && selectedTab === "multiRecommendation")
                                                ? " cursor-pointer active pl-4"
                                                : "cursor-pointer"
                                        }
                                        onClick={() => this.setActiveTab("multiRecommendation")}
                                    >
                                        Recommendation Summary
                                    </li>
                                    <li
                                        className={
                                            this.props.match.params.tab === "normalRecommendation" ||
                                            (isSmartchartView && selectedTab === "normalRecommendation")
                                                ? " cursor-pointer active pl-4"
                                                : "cursor-pointer"
                                        }
                                        onClick={() => this.setActiveTab("normalRecommendation")}
                                    >
                                        Recommendation Table
                                    </li>
                                    <li
                                        className={
                                            this.props.match.params.tab === "asset" || (isSmartchartView && selectedTab === "asset")
                                                ? " cursor-pointer active pl-4"
                                                : "cursor-pointer"
                                        }
                                        onClick={() => this.setActiveTab("asset")}
                                    >
                                        Asset Table
                                    </li>
                                    <li
                                        className={
                                            this.props.match.params.tab === "bbi" || (isSmartchartView && selectedTab === "bbi")
                                                ? " cursor-pointer active pl-4"
                                                : "cursor-pointer"
                                        }
                                        onClick={() => this.setActiveTab("bbi")}
                                    >
                                        BBI
                                    </li>
                                    <li
                                        className={
                                            this.props.match.params.tab === "bsi" || (isSmartchartView && selectedTab === "bsi")
                                                ? " cursor-pointer active pl-4"
                                                : "cursor-pointer"
                                        }
                                        onClick={() => this.setActiveTab("bsi")}
                                    >
                                        BSI
                                    </li>
                                    <li
                                        className={
                                            this.props.match.params.tab === "bai" || (isSmartchartView && selectedTab === "bai")
                                                ? " cursor-pointer active pl-4"
                                                : "cursor-pointer"
                                        }
                                        onClick={() => this.setActiveTab("bai")}
                                    >
                                        BAI
                                    </li>
                                    {/* <li
                                    className={activeDetail === "ChartDataTable" ? " cursor-pointer active pl-4" : "cursor-pointer"}
                                    onClick={() => this.setActiveTab("ChartDataTable")}
                                >
                                    Image Gallery
                                </li> */}
                                </>
                                {/* )} */}
                            </ul>

                            <div class="otr-common-edit custom-col new-area">
                                <div className="add-btn-wrapper d-flex justify-content-end align-items-center pt-0">
                                    <>
                                        <div className="mr-3">
                                            <button
                                                type="button"
                                                className={`reset-btn-recom ${
                                                    !this.state?.property?.id &&
                                                    this?.props?.match?.params?.id &&
                                                    this?.props?.match?.params?.id !== "undefined"
                                                        ? "cursor-disabled"
                                                        : ""
                                                }`}
                                                disabled={
                                                    this?.props?.match?.params?.id && this?.props?.match?.params?.id !== "undefined"
                                                        ? !this.state?.property?.id
                                                        : false
                                                }
                                                data-tip={`Update ALL Properties ${
                                                    this.state?.property?.name ? `for "${this.state.property.name}" ` : ""
                                                }from Global Properties`}
                                                data-for="chart_property"
                                                onClick={() => this?.ResetToGlobalDefault()}
                                            >
                                                <i className="fas fa-history reset text"></i>
                                                <span> Update ALL Properties from Global Properties</span>
                                            </button>
                                        </div>
                                        {showErrorBorder && (
                                            <span className="errorMessage">
                                                {this.state?.isYearValid
                                                    ? "* Required fields are missing"
                                                    : "Starting year must be less than the ending year"}
                                            </span>
                                        )}
                                        {!isSmartchartView && (
                                            <button className="button ml-2 cursor-hand" onClick={() => this.cancelForm()}>
                                                Cancel
                                            </button>
                                        )}
                                        <button
                                            className={`button btn-save ml-2 cursor-hand`}
                                            onClick={e => {
                                                e.preventDefault();
                                                this.handleSubmit();
                                            }}
                                        >
                                            {this.props.selectedProperty ? "Update Property" : "Add Property"}
                                        </button>
                                    </>
                                </div>
                            </div>
                        </div>
                        <div className="outer-font-section">
                            <div className="style-outer overf-height">
                                <div className="styles-box">
                                    <div className="outer-wrapp-resetprop">
                                        <h2 className="recom-h2-sec">Basic Details</h2>
                                    </div>
                                    <div className="styles-sec">
                                        <div className="d-flex f-outer">
                                            <div className="font-size font-st col-md-4">
                                                <label>Property Name *</label>

                                                <div className={`input-ft-size`}>
                                                    <input
                                                        autoComplete={"off"}
                                                        autoFill={"off"}
                                                        type="text"
                                                        className={`${
                                                            showErrorBorder && !name?.trim()?.length ? "error-border " : ""
                                                        }custom-input form-control ${isSmartchartView ? "cursor-diabled" : ""}`}
                                                        name="name"
                                                        onChange={e => this.handleChangeBasicDetails(e)}
                                                        value={name}
                                                        placeholder="Enter Property Name"
                                                        disabled={isSmartchartView}
                                                    />
                                                </div>
                                            </div>
                                            <div className="font-size font-st col-md-4">
                                                <label>Description *</label>

                                                <div className={`input-ft-size`}>
                                                    <input
                                                        autoComplete={"off"}
                                                        autoFill={"off"}
                                                        type="text"
                                                        className={`${
                                                            showErrorBorder && !description?.trim()?.length ? "error-border " : ""
                                                        }custom-input form-control ${isSmartchartView ? "cursor-diabled" : ""}`}
                                                        name="description"
                                                        onChange={e => this.handleChangeBasicDetails(e)}
                                                        value={description}
                                                        placeholder="Enter Description"
                                                        disabled={isSmartchartView}
                                                    />
                                                </div>
                                            </div>
                                            <div className="font-size font-st col-md-4">
                                                <label>Notes</label>
                                                <div className={`input-ft-size`}>
                                                    <input
                                                        autoComplete={"off"}
                                                        autoFill={"off"}
                                                        type="text"
                                                        className={`custom-input form-control ${isSmartchartView ? "cursor-diabled" : ""}`}
                                                        name="notes"
                                                        onChange={e => this.handleChangeBasicDetails(e)}
                                                        value={notes}
                                                        placeholder="Enter Notes"
                                                        disabled={isSmartchartView}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* sorted */}
                                {this.props.match.params.tab === "sortedRecommendations" ||
                                (isSmartchartView && selectedTab === "sortedRecommendations") ? (
                                    // <SortedRecommendation handleSetRecommendationProps={this.handleSetRecommendationProps}/>
                                    <SortedRecommendationForm
                                        fontFamilyData={FONT_FAMILY}
                                        fontColor={FONT_COLOR}
                                        setSortedRecommendationProperty={this.setSortedRecommendationProperty}
                                        sortedRecomProperty={recommendation_props}
                                        setSortedRecommendationTableColumnConfig={this.setSortedRecommendationTableColumnConfig}
                                        onSortedRecommendationColumnOrderChange={this.onSortedRecommendationColumnOrderChange}
                                        showErrorBorder={showErrorBorder}
                                        TABLE_STYLE={TABLE_STYLE}
                                        ResetToDefault={this?.ResetToDefault}
                                        hasBandValueChanged={this?.hasBandValueChanged}
                                    />
                                ) : this.props.match.params.tab === "bbi" || (isSmartchartView && selectedTab === "bbi") ? (
                                    <BbiForm
                                        bbiProperty={bbi_bsi_props}
                                        handleBbiChange={this?.handleBbiChange}
                                        FONT_FAMILY={FONT_FAMILY}
                                        styles={styles}
                                        setBbiBsiTableColumnConfig={this?.setBbiBsiTableColumnConfig}
                                        setBbiBuildingTableColumnConfig={this.setBbiBuildingTableColumnConfig}
                                        onBBiColumnOrderChange={this?.onBBiColumnOrderChange}
                                        ResetToDefault={this?.ResetToDefault}
                                        hasBandValueChanged={this?.hasBandValueChanged}
                                    />
                                ) : this.props.match.params.tab === "bsi" ||
                                  (isSmartchartView && selectedTab === "bsi") ||
                                  this.props.match.params.tab === "bai" ||
                                  (isSmartchartView && selectedTab === "bai") ? (
                                    <BsiForm
                                        bsiProperty={this.props.match.params.tab === "bai" || (isSmartchartView && selectedTab === "bai") ? bai : bsi}
                                        handleBsiChange={this?.handleBbiChange}
                                        FONT_FAMILY={FONT_FAMILY}
                                        styles={styles}
                                        setBbiBsiTableColumnConfig={this?.setBbiBsiTableColumnConfig}
                                        setBsiTableColumnConfig={this.setBbiBuildingTableColumnConfig}
                                        onBSiColumnOrderChange={this?.onBBiColumnOrderChange}
                                        ResetToDefault={this?.ResetToDefault}
                                        hasBandValueChanged={this?.hasBandValueChanged}
                                        type={this.props.match.params.tab || selectedTab}
                                    />
                                ) : this.props.match.params.tab === "multiRecommendation" ||
                                  (isSmartchartView && selectedTab === "multiRecommendation") ? (
                                    <>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Recommendation Summary Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("multi_recommendation_props", [
                                                                "heading",
                                                                "body",
                                                                "caption",
                                                                "notes",
                                                                "sub_total"
                                                            ])
                                                                ? "cursor-disabled"
                                                                : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("multi_recommendation_props", [
                                                            "heading",
                                                            "body",
                                                            "caption",
                                                            "notes",
                                                            "sub_total"
                                                        ])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "multi_recommendation_props",
                                                                subKeys: ["heading", "body", "caption", "notes", "sub_total"],
                                                                band: "Recommendation Summary Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Heading Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${
                                                                //     showErrorBorder && custom_legend?.show_legend && !total?.font_id
                                                                //         ? "error-border"
                                                                //         : ""
                                                                // }`}
                                                                className="dropdown"
                                                                value={multi_recommendation_props?.heading?.font_id || "-"}
                                                                // // name="table_style"
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                heading: {
                                                                                    ...this.state.property.multi_recommendation_props.heading,
                                                                                    font_id: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {/* <option value="CBRE Table - Emerald Option 2">CBRE Table - Emerald Option 2</option> */}
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Heading Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.heading?.font_size || "-"}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                heading: {
                                                                                    ...this.state.property.multi_recommendation_props.heading,

                                                                                    font_size: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Heading Font Color </label>
                                                        </div>

                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <span
                                                                style={{ cursor: "pointer" }}
                                                                className="arrow_close"
                                                                onClick={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                heading: {
                                                                                    ...this.state.property.multi_recommendation_props.heading,
                                                                                    font_color: ""
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "multi_recommendation_heading_font_color"
                                                                                ? null
                                                                                : "multi_recommendation_heading_font_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{multi_recommendation_props?.heading?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.heading?.font_color
                                                                            ? `#${multi_recommendation_props?.heading?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_heading_font_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={multi_recommendation_props?.heading?.font_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        heading: {
                                                                                            ...this.state.property.multi_recommendation_props.heading,

                                                                                            font_color: color.hex?.replace("#", "")
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Body Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${
                                                                //     showErrorBorder && custom_legend?.show_legend && !total?.font_id
                                                                //         ? "error-border"
                                                                //         : ""
                                                                // }`}
                                                                className="dropdown"
                                                                value={multi_recommendation_props?.body?.font_id || "-"}
                                                                // // name="table_style"
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                body: {
                                                                                    ...this.state.property.multi_recommendation_props.body,
                                                                                    font_id: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {/* <option value="CBRE Table - Emerald Option 2">CBRE Table - Emerald Option 2</option> */}
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Body Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.body?.font_size || "-"}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                body: {
                                                                                    ...this.state.property.multi_recommendation_props.body,

                                                                                    font_size: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Body Font Color </label>
                                                        </div>
                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                body: {
                                                                                    ...this.state.property.multi_recommendation_props.body,
                                                                                    font_color: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "multi_recommendation_body_font_color"
                                                                                ? null
                                                                                : "multi_recommendation_body_font_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{multi_recommendation_props?.body?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.body?.font_color
                                                                            ? `#${multi_recommendation_props?.body?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_body_font_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={multi_recommendation_props?.body?.font_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        body: {
                                                                                            ...this.state.property.multi_recommendation_props.body,

                                                                                            font_color: color.hex?.replace("#", "")
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Caption Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${
                                                                //     showErrorBorder && custom_legend?.show_legend && !total?.font_id
                                                                //         ? "error-border"
                                                                //         : ""
                                                                // }`}
                                                                className="dropdown"
                                                                value={multi_recommendation_props?.caption?.font_id || "-"}
                                                                // // name="table_style"
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                caption: {
                                                                                    ...this.state.property.multi_recommendation_props.caption,
                                                                                    font_id: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {/* <option value="CBRE Table - Emerald Option 2">CBRE Table - Emerald Option 2</option> */}
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Caption Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.caption?.font_size || "-"}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                caption: {
                                                                                    ...this.state.property.multi_recommendation_props.caption,

                                                                                    font_size: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Caption Font Color </label>
                                                        </div>
                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                caption: {
                                                                                    ...this.state.property.multi_recommendation_props.caption,
                                                                                    font_color: ""
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "multi_recommendation_caption_font_color"
                                                                                ? null
                                                                                : "multi_recommendation_caption_font_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{multi_recommendation_props?.caption?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.caption?.font_color
                                                                            ? `#${multi_recommendation_props?.caption?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_caption_font_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={multi_recommendation_props?.caption?.font_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        caption: {
                                                                                            ...this.state.property.multi_recommendation_props.caption,

                                                                                            font_color: color.hex?.replace("#", "")
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Notes Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${
                                                                //     showErrorBorder && custom_legend?.show_legend && !total?.font_id
                                                                //         ? "error-border"
                                                                //         : ""
                                                                // }`}
                                                                className="dropdown"
                                                                value={multi_recommendation_props?.notes?.font_id || "-"}
                                                                // // name="table_style"
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                notes: {
                                                                                    ...this.state.property.multi_recommendation_props.notes,
                                                                                    font_id: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {/* <option value="CBRE Table - Emerald Option 2">CBRE Table - Emerald Option 2</option> */}
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Notes Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.notes?.font_size || "-"}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                notes: {
                                                                                    ...this.state.property.multi_recommendation_props.notes,

                                                                                    font_size: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Notes Font Color </label>
                                                        </div>
                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                notes: {
                                                                                    ...this.state.property.multi_recommendation_props.notes,
                                                                                    font_color: ""
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "multi_recommendation_notes_font_color"
                                                                                ? null
                                                                                : "multi_recommendation_notes_font_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{multi_recommendation_props?.notes?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.notes?.font_color
                                                                            ? `#${multi_recommendation_props?.notes?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_notes_font_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={multi_recommendation_props?.notes?.font_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        notes: {
                                                                                            ...this.state.property.multi_recommendation_props.notes,

                                                                                            font_color: color.hex?.replace("#", "")
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Sub Total Visible</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="frame"
                                                                value={multi_recommendation_props?.sub_total?.is_sub_total}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                sub_total: {
                                                                                    ...this.state.property.multi_recommendation_props.sub_total,

                                                                                    is_sub_total: e.target.value == "true"
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {multi_recommendation_props?.sub_total?.is_sub_total && (
                                                        <>
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Sub Total Font Name </label>
                                                                <div className="font-select">
                                                                    <select
                                                                        className="dropdown"
                                                                        value={multi_recommendation_props?.sub_total?.font_id || "-"}
                                                                        onChange={e =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        sub_total: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .sub_total,

                                                                                            font_id: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    >
                                                                        <option value="">Select</option>

                                                                        {FONT_FAMILY.map(f => (
                                                                            <option key={f.id} value={f.id}>
                                                                                {f.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Sub Total Font Size</label>

                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={multi_recommendation_props?.sub_total?.font_size}
                                                                        onValueChange={values =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        sub_total: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .sub_total,

                                                                                            font_size: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" Pt"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="font-color font-st col-md-3">
                                                                <div className="head_sub">
                                                                    <label>Sub Total Font Color </label>
                                                                </div>

                                                                <div className="dropdown">
                                                                    <span
                                                                        className="arrow_close"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={e =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        sub_total: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .sub_total,

                                                                                            font_colour: ""
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    >
                                                                        <i class="fas fa-times"></i>
                                                                    </span>
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "multi_recom_sub_total_font_color"
                                                                                        ? null
                                                                                        : "multi_recom_sub_total_font_color"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>{multi_recommendation_props?.sub_total?.font_colour || "Select"}</span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: multi_recommendation_props?.sub_total?.font_colour
                                                                                    ? `#${multi_recommendation_props?.sub_total?.font_colour}`
                                                                                    : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                                    </div>
                                                                    {colorModalState === "multi_recom_sub_total_font_color" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={multi_recommendation_props?.sub_total?.font_colour}
                                                                                onChangeComplete={color =>
                                                                                    this.setState({
                                                                                        property: {
                                                                                            ...this.state.property,
                                                                                            multi_recommendation_props: {
                                                                                                ...this.state.property.multi_recommendation_props,
                                                                                                sub_total: {
                                                                                                    ...this.state.property.multi_recommendation_props
                                                                                                        .sub_total,

                                                                                                    font_colour: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    })
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="font-color font-st col-md-3">
                                                                <div className="head_sub">
                                                                    <label>Sub Total Background Color </label>
                                                                </div>

                                                                <div className="dropdown">
                                                                    <span
                                                                        className="arrow_close"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={e =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        sub_total: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .sub_total,

                                                                                            background_colour: ""
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    >
                                                                        <i class="fas fa-times"></i>
                                                                    </span>
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "multi_recom_sub_total_BG_color"
                                                                                        ? null
                                                                                        : "multi_recom_sub_total_BG_color"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>
                                                                            {multi_recommendation_props?.sub_total?.background_colour || "Select"}
                                                                        </span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: multi_recommendation_props?.sub_total?.background_colour
                                                                                    ? `#${multi_recommendation_props?.sub_total?.background_colour}`
                                                                                    : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                                    </div>
                                                                    {colorModalState === "multi_recom_sub_total_BG_color" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={multi_recommendation_props?.sub_total?.background_colour}
                                                                                onChangeComplete={color =>
                                                                                    this.setState({
                                                                                        property: {
                                                                                            ...this.state.property,
                                                                                            multi_recommendation_props: {
                                                                                                ...this.state.property.multi_recommendation_props,
                                                                                                sub_total: {
                                                                                                    ...this.state.property.multi_recommendation_props
                                                                                                        .sub_total,

                                                                                                    background_colour: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    })
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="font-color font-st col-md-3">
                                                                <div className="head_sub">
                                                                    <label>Sub Total Border Color </label>
                                                                </div>

                                                                <div className="dropdown">
                                                                    <span
                                                                        className="arrow_close"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={e =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        sub_total: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .sub_total,

                                                                                            border_colour: ""
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    >
                                                                        <i class="fas fa-times"></i>
                                                                    </span>
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "mulit_recom_sub_total_border_colour"
                                                                                        ? null
                                                                                        : "mulit_recom_sub_total_border_colour"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>
                                                                            {multi_recommendation_props?.sub_total?.border_colour || "Select"}
                                                                        </span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: multi_recommendation_props?.sub_total?.border_colour
                                                                                    ? `#${multi_recommendation_props?.sub_total?.border_colour}`
                                                                                    : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                                    </div>
                                                                    {colorModalState === "mulit_recom_sub_total_border_colour" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={multi_recommendation_props?.sub_total?.border_colour}
                                                                                onChangeComplete={color =>
                                                                                    this.setState({
                                                                                        property: {
                                                                                            ...this.state.property,
                                                                                            multi_recommendation_props: {
                                                                                                ...this.state.property.multi_recommendation_props,
                                                                                                sub_total: {
                                                                                                    ...this.state.property.multi_recommendation_props
                                                                                                        .sub_total,

                                                                                                    border_colour: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    })
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="font-size font-st col-md-3">
                                                                <label>Sub Total Border</label>
                                                                <div className={`input-ft-size`}>
                                                                    <span className="check-align">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={multi_recommendation_props?.sub_total?.border?.left}
                                                                            onChange={e =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        multi_recommendation_props: {
                                                                                            ...this.state.property.multi_recommendation_props,
                                                                                            sub_total: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .sub_total,
                                                                                                border: {
                                                                                                    ...this.state.property.multi_recommendation_props
                                                                                                        .sub_total.border,
                                                                                                    left: e.target.checked
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        ></input>
                                                                        <label>Left</label>
                                                                    </span>
                                                                    <span className="check-align">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={multi_recommendation_props?.sub_total?.border?.right}
                                                                            onChange={e =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        multi_recommendation_props: {
                                                                                            ...this.state.property.multi_recommendation_props,
                                                                                            sub_total: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .sub_total,
                                                                                                border: {
                                                                                                    ...this.state.property.multi_recommendation_props
                                                                                                        .sub_total.border,
                                                                                                    right: e.target.checked
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        ></input>
                                                                        <label>Right</label>
                                                                    </span>
                                                                    <span className="check-align">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={multi_recommendation_props?.sub_total?.border?.top}
                                                                            onChange={e =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        multi_recommendation_props: {
                                                                                            ...this.state.property.multi_recommendation_props,
                                                                                            sub_total: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .sub_total,
                                                                                                border: {
                                                                                                    ...this.state.property.multi_recommendation_props
                                                                                                        .sub_total.border,
                                                                                                    top: e.target.checked
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        ></input>
                                                                        <label>Top</label>
                                                                    </span>
                                                                    <span className="check-align">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={multi_recommendation_props?.sub_total?.border?.bottom}
                                                                            onChange={e =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        multi_recommendation_props: {
                                                                                            ...this.state.property.multi_recommendation_props,
                                                                                            sub_total: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .sub_total,
                                                                                                border: {
                                                                                                    ...this.state.property.multi_recommendation_props
                                                                                                        .sub_total.border,
                                                                                                    bottom: e.target.checked
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        ></input>
                                                                        <label>Bottom</label>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Sub Total Cell Margin Top</label>
                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={multi_recommendation_props?.sub_total?.cell_margin?.top}
                                                                        onValueChange={values =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        sub_total: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .sub_total,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .sub_total.cell_margin,
                                                                                                top: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" inch"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Sub Total Cell Margin Left</label>
                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={multi_recommendation_props?.sub_total?.cell_margin?.left}
                                                                        onValueChange={values =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        sub_total: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .sub_total,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .sub_total.cell_margin,
                                                                                                left: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" inch"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Sub Total Cell Margin Right</label>
                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={multi_recommendation_props?.sub_total?.cell_margin?.right}
                                                                        onValueChange={values =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        sub_total: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .sub_total,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .sub_total.cell_margin,
                                                                                                right: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" inch"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Sub Total Cell Margin Bottom</label>
                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={multi_recommendation_props?.sub_total?.cell_margin?.bottom}
                                                                        onValueChange={values =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        sub_total: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .sub_total,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .sub_total.cell_margin,
                                                                                                bottom: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" inch"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Seperator Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("multi_recommendation_props", ["seperator_line"])
                                                                ? "cursor-disabled"
                                                                : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("multi_recommendation_props", ["seperator_line"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "multi_recommendation_props",
                                                                subKeys: ["seperator_line"],
                                                                band: "Seperator Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Border Size</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.seperator_line?.size}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                seperator_line: {
                                                                                    ...this.state.property.multi_recommendation_props.seperator_line,
                                                                                    size: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Border Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                seperator_line: {
                                                                                    ...this.state.property.multi_recommendation_props.seperator_line,
                                                                                    color: ""
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "multi_recommendation_seperator_color"
                                                                                ? null
                                                                                : "multi_recommendation_seperator_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{multi_recommendation_props?.seperator_line?.color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.seperator_line?.color
                                                                            ? `#${multi_recommendation_props?.seperator_line?.color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_seperator_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={multi_recommendation_props?.seperator_line?.color}
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        seperator_line: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .seperator_line,
                                                                                            color: color.hex?.replace("#", "")
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Border Style</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                value={multi_recommendation_props?.seperator_line?.style}
                                                                name="font_id"
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                seperator_line: {
                                                                                    ...this.state.property.multi_recommendation_props.seperator_line,
                                                                                    style: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                {/* <option value="">Select</option> */}
                                                                {FRAME_STYLES.map((fStyle, i) => (
                                                                    <option key={i} value={fStyle.name}>
                                                                        {fStyle.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Space After</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.seperator_line?.space_after}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                seperator_line: {
                                                                                    ...this.state.property.multi_recommendation_props.seperator_line,
                                                                                    space_after: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Space Before</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.seperator_line?.space_before}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                seperator_line: {
                                                                                    ...this.state.property.multi_recommendation_props.seperator_line,
                                                                                    space_before: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Filtered By Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("multi_recommendation_props", ["filter_by_custom_props"])
                                                                ? "cursor-disabled"
                                                                : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("multi_recommendation_props", ["filter_by_custom_props"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "multi_recommendation_props",
                                                                subKeys: ["filter_by_custom_props"],
                                                                band: "Filtered By Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Custom Heading Label</label>

                                                        <div className={`input-ft-size`}>
                                                            <input
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading
                                                                        ?.label || ""
                                                                }
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_custom_heading: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_custom_heading,
                                                                                        label: e.target?.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Custom Heading Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading
                                                                        ?.font_id || "-"
                                                                }
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_custom_heading: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_custom_heading,
                                                                                        font_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>

                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Custom Heading Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading
                                                                        ?.font_size
                                                                }
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_custom_heading: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_custom_heading,
                                                                                        font_size: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Custom Heading Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_custom_heading: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_custom_heading,
                                                                                        font_colour: ""
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "multi_recommendation_props_custom_heading_color"
                                                                                ? null
                                                                                : "multi_recommendation_props_custom_heading_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>
                                                                    {multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading
                                                                        ?.font_colour || "Select"}
                                                                </span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.filter_by_custom_props
                                                                            ?.filter_custom_heading?.font_colour
                                                                            ? `#${multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.font_colour}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_props_custom_heading_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={
                                                                            multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading
                                                                                ?.font_colour
                                                                        }
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        filter_by_custom_props: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props,
                                                                                            filter_custom_heading: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .filter_by_custom_props?.filter_custom_heading,
                                                                                                font_colour: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Custom Heading Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading
                                                                        ?.font_bold || "-"
                                                                }
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_custom_heading: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_custom_heading,
                                                                                        font_bold: e.target.value === "true"
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Label Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels
                                                                        ?.font_id || "-"
                                                                }
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_by_props: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_by_props,
                                                                                        labels: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props?.filter_by_props?.labels,
                                                                                            font_id: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>

                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Label Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels
                                                                        ?.font_size
                                                                }
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_by_props: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_by_props,
                                                                                        labels: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props?.filter_by_props?.labels,
                                                                                            font_size: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Label Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_by_props: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_by_props,
                                                                                        labels: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props?.filter_by_props?.labels,
                                                                                            font_colour: ""
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "multi_recommendation_props_labels_heading_color"
                                                                                ? null
                                                                                : "multi_recommendation_props_labels_heading_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>
                                                                    {multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels
                                                                        ?.font_colour || "Select"}
                                                                </span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.filter_by_custom_props
                                                                            ?.filter_by_props?.labels?.font_colour
                                                                            ? `#${multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels?.font_colour}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_props_labels_heading_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={
                                                                            multi_recommendation_props?.filter_by_custom_props?.filter_by_props
                                                                                ?.labels?.font_colour
                                                                        }
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        filter_by_custom_props: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props,
                                                                                            filter_by_props: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .filter_by_custom_props?.filter_by_props,
                                                                                                labels: {
                                                                                                    ...this.state.property.multi_recommendation_props
                                                                                                        .filter_by_custom_props?.filter_by_props
                                                                                                        ?.labels,
                                                                                                    font_colour: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Label Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels
                                                                        ?.font_bold || "-"
                                                                }
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_by_props: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_by_props,
                                                                                        labels: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props?.filter_by_props?.labels,
                                                                                            font_bold: e.target.value === "true"
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Values Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values
                                                                        ?.font_id || "-"
                                                                }
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_by_props: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_by_props,
                                                                                        values: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props?.filter_by_props?.values,
                                                                                            font_id: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>

                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Values Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values
                                                                        ?.font_size
                                                                }
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_by_props: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_by_props,
                                                                                        values: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props?.filter_by_props?.values,
                                                                                            font_size: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Values Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_by_props: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_by_props,
                                                                                        values: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props?.filter_by_props?.values,
                                                                                            font_colour: ""
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "multi_recommendation_props_values_heading_color"
                                                                                ? null
                                                                                : "multi_recommendation_props_values_heading_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>
                                                                    {multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values
                                                                        ?.font_colour || "Select"}
                                                                </span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.filter_by_custom_props
                                                                            ?.filter_by_props?.values?.font_colour
                                                                            ? `#${multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values?.font_colour}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_props_values_heading_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={
                                                                            multi_recommendation_props?.filter_by_custom_props?.filter_by_props
                                                                                ?.values?.font_colour
                                                                        }
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        filter_by_custom_props: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props,
                                                                                            filter_by_props: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .filter_by_custom_props?.filter_by_props,
                                                                                                values: {
                                                                                                    ...this.state.property.multi_recommendation_props
                                                                                                        .filter_by_custom_props?.filter_by_props
                                                                                                        ?.values,
                                                                                                    font_colour: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Values Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={
                                                                    multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values
                                                                        ?.font_bold || "-"
                                                                }
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    filter_by_props: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.filter_by_props,
                                                                                        values: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .filter_by_custom_props?.filter_by_props?.values,
                                                                                            font_bold: e.target.value === "true"
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Filtered By Alignment</label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                name="tag"
                                                                value={multi_recommendation_props?.filter_by_custom_props?.alignment}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    alignment: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                {" "}
                                                                <option value="">Select</option>
                                                                <option value={"left"}>Left</option>
                                                                <option value={"center"}>Center</option>
                                                                <option value={"right"}>Right</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Filtered By Margin Top</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.filter_by_custom_props?.cell_margin?.top}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    cell_margin: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.cell_margin,
                                                                                        top: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Filtered By Margin Left</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.filter_by_custom_props?.cell_margin?.left}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    cell_margin: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props?.cell_margin,
                                                                                        left: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Filtered By Margin Right</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.filter_by_custom_props?.cell_margin?.right}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    cell_margin: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props.cell_margin,
                                                                                        right: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Filtered By Margin Bottom</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.filter_by_custom_props?.cell_margin?.bottom}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    cell_margin: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .filter_by_custom_props.cell_margin,
                                                                                        bottom: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Filtered By Space After</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.filter_by_custom_props?.space_after}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    space_after: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Filtered By Space Before</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.filter_by_custom_props?.space_before}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                filter_by_custom_props: {
                                                                                    ...this.state.property.multi_recommendation_props
                                                                                        .filter_by_custom_props,
                                                                                    space_before: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Memo Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("multi_recommendation_props", ["memo_properties"])
                                                                ? "cursor-disabled"
                                                                : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("multi_recommendation_props", ["memo_properties"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "multi_recommendation_props",
                                                                subKeys: ["memo_properties"],
                                                                band: "Memo Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Apply Memo Field Property</label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={multi_recommendation_props?.memo_properties?.memo_props_active}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    memo_props_active: e.target.value === "true"
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={true}>Active</option>
                                                                <option value={false}>Inactive</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Heading Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={multi_recommendation_props?.memo_properties?.heading?.font_id || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    heading: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .memo_properties?.heading,
                                                                                        font_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Heading Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.memo_properties?.heading?.font_size || "-"}
                                                                onValueChange={values => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    heading: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .memo_properties?.heading,
                                                                                        font_size: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Heading Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    heading: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .memo_properties?.heading,
                                                                                        font_color: ""
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState ===
                                                                            "multi_recommendation_props_memo_properties_heading_color"
                                                                                ? null
                                                                                : "multi_recommendation_props_memo_properties_heading_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>
                                                                    {multi_recommendation_props?.memo_properties?.heading?.font_color || "Select"}
                                                                </span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.memo_properties?.heading?.font_color
                                                                            ? `#${multi_recommendation_props?.memo_properties?.heading?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_props_memo_properties_heading_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={multi_recommendation_props?.memo_properties?.heading?.font_color}
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        memo_properties: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .memo_properties,
                                                                                            heading: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .memo_properties?.heading,
                                                                                                font_color: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Heading Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={multi_recommendation_props?.memo_properties?.heading?.font_bold || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    heading: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .memo_properties?.heading,
                                                                                        font_bold: e.target.value === "true"
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Body Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={multi_recommendation_props?.memo_properties?.body?.font_id || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    body: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .memo_properties?.body,
                                                                                        font_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Body Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={multi_recommendation_props?.memo_properties?.body?.font_size || "-"}
                                                                onValueChange={values => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    body: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .memo_properties?.body,
                                                                                        font_size: values?.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Body Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    body: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .memo_properties?.body,
                                                                                        font_color: ""
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState ===
                                                                            "multi_recommendation_props_memo_properties_body_color"
                                                                                ? null
                                                                                : "multi_recommendation_props_memo_properties_body_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>
                                                                    {multi_recommendation_props?.memo_properties?.body?.font_color || "Select"}
                                                                </span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: multi_recommendation_props?.memo_properties?.body?.font_color
                                                                            ? `#${multi_recommendation_props?.memo_properties?.body?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "multi_recommendation_props_memo_properties_body_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={multi_recommendation_props?.memo_properties?.body?.font_color}
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    multi_recommendation_props: {
                                                                                        ...this.state.property.multi_recommendation_props,
                                                                                        memo_properties: {
                                                                                            ...this.state.property.multi_recommendation_props
                                                                                                .memo_properties,
                                                                                            body: {
                                                                                                ...this.state.property.multi_recommendation_props
                                                                                                    .memo_properties?.body,
                                                                                                font_color: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Body Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={multi_recommendation_props?.memo_properties?.body?.font_bold || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    body: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .memo_properties?.body,
                                                                                        font_bold: e.target.value === "true"
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Body Alignment</label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                name="tag"
                                                                value={multi_recommendation_props?.memo_properties?.body?.alignment}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            multi_recommendation_props: {
                                                                                ...this.state.property.multi_recommendation_props,
                                                                                memo_properties: {
                                                                                    ...this.state.property.multi_recommendation_props.memo_properties,
                                                                                    body: {
                                                                                        ...this.state.property.multi_recommendation_props
                                                                                            .memo_properties?.body,
                                                                                        alignment: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                {" "}
                                                                <option value="">Select</option>
                                                                <option value={"left"}>Left</option>
                                                                <option value={"center"}>Center</option>
                                                                <option value={"right"}>Right</option>
                                                                <option value={"justify"}>Justify</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : this.props.match.params.tab === "normalRecommendation" ||
                                  this.props.match.params.tab === "asset" ||
                                  (isSmartchartView && selectedTab === "normalRecommendation") ||
                                  (isSmartchartView && selectedTab === "asset") ? (
                                    <NormalRecommendationForm
                                        fontFamilyData={FONT_FAMILY}
                                        tableStyleData={TABLE_STYLE}
                                        setNormalRecomProperty={this.setNormalRecomProperty}
                                        normalRecomProperty={
                                            this.props.match.params.tab === "asset" || (isSmartchartView && selectedTab === "asset")
                                                ? asset_props
                                                : normal_recommendation_props
                                        }
                                        setNormalRecommendationTableColumnConfig={this.setNormalRecommendationTableColumnConfig}
                                        onRecommendationColumnOrderChange={this.onRecommendationColumnOrderChange}
                                        showErrorBorder={showErrorBorder}
                                        isAsset={this.props.match.params.tab === "asset" || (isSmartchartView && selectedTab === "asset")}
                                        ResetToDefault={this?.ResetToDefault}
                                        hasBandValueChanged={this?.hasBandValueChanged}
                                    />
                                ) : this.props.match.params.tab === "CA" || (isSmartchartView && selectedTab === "CA") ? (
                                    <>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Comparative Analysis Data Table Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["table"], "comp_analysis")
                                                                ? "cursor-disabled"
                                                                : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["table"], "comp_analysis")}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["table"],
                                                                columnKey: "comp_analysis",
                                                                band: "Comparative Analysis Data Table Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Table Style </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={comp_analysis?.table?.table_style_id || "-"}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        table_style_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {TABLE_STYLE.map(f => (
                                                                    <option value={f.id} key={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Table Column Width (Only for excel export)</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.col_width}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        col_width: Number(values.value)
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>
                                                            Table Page Fit{" "}
                                                            <i
                                                                className="fa fa-info info-ft-st"
                                                                data-for="table_page_fit"
                                                                data-tip="True- Fit table to page layout</br> False- Auto Adjust columns based on content"
                                                            />
                                                        </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                name="tag"
                                                                value={comp_analysis?.table?.table_page_fit}
                                                                onChange={e => {
                                                                    const value = e.target.value === "true";
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        table_page_fit: value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                {" "}
                                                                <option value="">Select</option>
                                                                <option value={"true"}>True</option>
                                                                <option value={"false"}>False</option>
                                                            </select>
                                                        </div>
                                                        <ReactTooltip
                                                            className="rc-tooltip-custom-class tool-format-bx"
                                                            id="table_page_fit"
                                                            backgroundColor="#007bff"
                                                            place="top"
                                                            effect="solid"
                                                            html={true}
                                                            getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="styles-sec">
                                                    <div className="d-flex f-outer">
                                                        <div className="font-family font-st col-md-3">
                                                            <label>Custom Heading Font Name </label>
                                                            <div className="font-select">
                                                                <select
                                                                    className="dropdown"
                                                                    value={comp_analysis?.table?.custom_head?.font_id}
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,

                                                                                            custom_head: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .custom_head,
                                                                                                font_id: e.target.value
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="">Select</option>
                                                                    {FONT_FAMILY.map(f => (
                                                                        <option key={f.id} value={f.id}>
                                                                            {f.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Font Size</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.custom_head?.font_size}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            custom_head: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    ?.custom_head,
                                                                                                font_size: Number(values.value)
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" Pt"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-color font-st col-md-3">
                                                            <label>Custom Heading Font Color </label>
                                                            <div className="dropdown">
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState:
                                                                                colorModalState === "table_custom_heading_color"
                                                                                    ? null
                                                                                    : "table_custom_heading_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{comp_analysis?.table?.custom_head?.font_color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{
                                                                            background: comp_analysis?.table?.custom_head?.font_color
                                                                                ? `#${comp_analysis?.table?.custom_head?.font_color}`
                                                                                : "#fff"
                                                                        }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "table_custom_heading_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={comp_analysis?.table?.custom_head?.font_color}
                                                                            onChangeComplete={color =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        properties: {
                                                                                            ...this.state.property.properties,
                                                                                            comp_analysis: {
                                                                                                ...this.state.property.properties.comp_analysis,
                                                                                                table: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table,
                                                                                                    custom_head: {
                                                                                                        ...this.state.property.properties
                                                                                                            .comp_analysis?.table.custom_head,
                                                                                                        font_color: color.hex?.replace("#", "")
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="font-color font-st col-md-3">
                                                            <label>Custom Heading Background Color </label>
                                                            <div className="dropdown">
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState:
                                                                                colorModalState === "table_custom_heading_bg_color"
                                                                                    ? null
                                                                                    : "table_custom_heading_bg_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{comp_analysis?.table?.custom_head?.bg_color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{
                                                                            background: comp_analysis?.table?.custom_head?.bg_color
                                                                                ? `#${comp_analysis?.table?.custom_head?.bg_color}`
                                                                                : "#fff"
                                                                        }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "table_custom_heading_bg_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={comp_analysis?.table?.custom_head?.bg_color}
                                                                            onChangeComplete={color =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        properties: {
                                                                                            ...this.state.property.properties,
                                                                                            comp_analysis: {
                                                                                                ...this.state.property.properties.comp_analysis,
                                                                                                table: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table,
                                                                                                    custom_head: {
                                                                                                        ...this.state.property.properties
                                                                                                            .comp_analysis?.table?.custom_head,
                                                                                                        bg_color: color.hex?.replace("#", "")
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="font-family font-st col-md-3">
                                                            <label>Custom Heading Alignment</label>
                                                            <div className="font-select">
                                                                <select
                                                                    className="dropdown"
                                                                    name="tag"
                                                                    value={comp_analysis?.table?.custom_head?.alignment}
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            custom_head: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    ?.custom_head,
                                                                                                alignment: e.target.value
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                >
                                                                    {" "}
                                                                    <option value="">Select</option>
                                                                    <option value={"left"}>Left</option>
                                                                    <option value={"center"}>Center</option>
                                                                    <option value={"right"}>Right</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Cell Margin Top</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.custom_head?.cell_margin?.top}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            custom_head: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    ?.custom_head,
                                                                                                cell_margin: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table?.custom_head.cell_margin,
                                                                                                    top: values.floatValue
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Cell Margin Left</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.custom_head?.cell_margin?.left}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            custom_head: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .custom_head,
                                                                                                cell_margin: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.custom_head.cell_margin,
                                                                                                    left: values.floatValue
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Cell Margin Right</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.custom_head?.cell_margin?.right}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            custom_head: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .custom_head,
                                                                                                cell_margin: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.custom_head.cell_margin,
                                                                                                    right: values.floatValue
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Cell Margin Bottom</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.custom_head?.cell_margin?.bottom}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            custom_head: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .custom_head,
                                                                                                cell_margin: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.custom_head.cell_margin,
                                                                                                    bottom: values.floatValue
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Blank Line Height</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.custom_head?.blank_line_height}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,

                                                                                            custom_head: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .custom_head,
                                                                                                blank_line_height: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" pt"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="styles-sec">
                                                    <div className="d-flex f-outer">
                                                        <div className="font-family font-st col-md-3">
                                                            <label>
                                                                Heading Item Label{" "}
                                                                <i
                                                                    className="fa fa-info info-ft-st"
                                                                    data-for="table_page_fit"
                                                                    data-tip="Comparative Analysis Table heading first index item value"
                                                                />
                                                            </label>
                                                            <div className={`input-ft-size`}>
                                                                <input
                                                                    value={comp_analysis?.table?.heading?.head_first_index_label || ""}
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            heading: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .heading,
                                                                                                head_first_index_label: e.target?.value
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-family font-st col-md-3">
                                                            <label>Heading Font Name </label>
                                                            <div className="font-select">
                                                                <select
                                                                    // className={`dropdown ${showErrorBorder && !header.client.font_id ? "error-border" : ""}`}
                                                                    className="dropdown"
                                                                    value={comp_analysis?.table?.heading?.font_id}
                                                                    // name="font_id"
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            heading: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .heading,
                                                                                                font_id: e.target.value
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="">Select</option>
                                                                    {FONT_FAMILY.map(f => (
                                                                        <option key={f.id} value={f.id}>
                                                                            {f.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Font Size</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.heading?.font_size}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            heading: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .heading,
                                                                                                font_size: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" Pt"
                                                                    // className={`${
                                                                    //     showErrorBorder && custom_legend?.show_legend && !total?.font_size
                                                                    //         ? "error-border"
                                                                    //         : ""
                                                                    // }`}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="font-color font-st col-md-3">
                                                            <label>Heading Font Color </label>
                                                            <div
                                                                // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                                className="dropdown"
                                                            >
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState:
                                                                                colorModalState === "table_heading_color"
                                                                                    ? null
                                                                                    : "table_heading_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{comp_analysis?.table?.heading?.font_color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{
                                                                            background: comp_analysis?.table?.heading?.font_color
                                                                                ? `#${comp_analysis?.table?.heading?.font_color}`
                                                                                : "#fff"
                                                                        }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "table_heading_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={comp_analysis?.table?.heading?.font_color}
                                                                            onChangeComplete={color =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        properties: {
                                                                                            ...this.state.property.properties,
                                                                                            comp_analysis: {
                                                                                                table: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table,
                                                                                                    heading: {
                                                                                                        ...this.state.property.properties
                                                                                                            .comp_analysis?.table.heading,
                                                                                                        font_color: color.hex?.replace("#", "")
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="font-color font-st col-md-3">
                                                            <label>Heading Background Color </label>
                                                            <div
                                                                // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                                className="dropdown"
                                                            >
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState:
                                                                                colorModalState === "table_heading_bg_color"
                                                                                    ? null
                                                                                    : "table_heading_bg_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{comp_analysis?.table?.heading?.bg_color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{
                                                                            background: comp_analysis?.table?.heading?.bg_color
                                                                                ? `#${comp_analysis?.table?.heading?.bg_color}`
                                                                                : "#fff"
                                                                        }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "table_heading_bg_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={comp_analysis?.table?.heading?.bg_color}
                                                                            onChangeComplete={color =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        properties: {
                                                                                            ...this.state.property.properties,
                                                                                            comp_analysis: {
                                                                                                ...this.state.property.properties.comp_analysis,
                                                                                                table: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table,
                                                                                                    heading: {
                                                                                                        ...this.state.property.properties
                                                                                                            .comp_analysis?.table.heading,
                                                                                                        bg_color: color.hex?.replace("#", "")
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="font-family font-st col-md-3">
                                                            <label>Heading Alignment</label>
                                                            <div className="font-select">
                                                                <select
                                                                    // className={`dropdown ${showErrorBorder && !total?.alignment ? "error-border" : ""}`}
                                                                    className="dropdown"
                                                                    name="tag"
                                                                    value={comp_analysis?.table?.heading?.alignment}
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            heading: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .heading,
                                                                                                alignment: e.target.value
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                >
                                                                    {" "}
                                                                    <option value="">Select</option>
                                                                    <option value={"left"}>Left</option>
                                                                    <option value={"center"}>Center</option>
                                                                    <option value={"right"}>Right</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Cell Margin Top</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.heading?.cell_margin?.top}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            heading: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .heading,
                                                                                                cell_margin: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.heading.cell_margin,
                                                                                                    top: values.floatValue
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Cell Margin Left</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.heading?.cell_margin?.left}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            heading: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .heading,
                                                                                                cell_margin: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.heading.cell_margin,
                                                                                                    left: values.floatValue
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Cell Margin Right</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.heading?.cell_margin?.right}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            heading: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .heading,
                                                                                                cell_margin: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.heading.cell_margin,
                                                                                                    right: values.floatValue
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Cell Margin Bottom</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={comp_analysis?.table?.heading?.cell_margin?.bottom}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    comp_analysis: {
                                                                                        ...this.state.property.properties.comp_analysis,
                                                                                        table: {
                                                                                            ...this.state.property.properties.comp_analysis?.table,
                                                                                            heading: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .heading,
                                                                                                cell_margin: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.heading.cell_margin,
                                                                                                    bottom: values.floatValue
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Data Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${showErrorBorder && !header.client.font_id ? "error-border" : ""}`}
                                                                className="dropdown"
                                                                value={comp_analysis?.table?.data?.font_id}
                                                                // name="font_id"
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        data: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .data,
                                                                                            font_id: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Font Size</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.data?.font_size}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        data: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .data,
                                                                                            font_size: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                                // className={`${
                                                                //     showErrorBorder && custom_legend?.show_legend && !total?.font_size
                                                                //         ? "error-border"
                                                                //         : ""
                                                                // }`}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <label>Data Font Color </label>
                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "table_custom_font_color"
                                                                                ? null
                                                                                : "table_custom_font_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{comp_analysis?.table?.data?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: comp_analysis?.table?.data?.font_color
                                                                            ? `#${comp_analysis?.table?.data?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "table_custom_font_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={comp_analysis?.table?.data?.font_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        comp_analysis: {
                                                                                            ...this.state.property.properties.comp_analysis,
                                                                                            table: {
                                                                                                ...this.state.property.properties.comp_analysis
                                                                                                    ?.table,
                                                                                                data: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.data,
                                                                                                    font_color: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Data Alignment</label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${showErrorBorder && !total?.alignment ? "error-border" : ""}`}
                                                                className="dropdown"
                                                                name="tag"
                                                                value={comp_analysis?.table?.data?.alignment}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        data: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .data,
                                                                                            alignment: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                {" "}
                                                                <option value="">Select</option>
                                                                <option value={"left"}>Left</option>
                                                                <option value={"center"}>Center</option>
                                                                <option value={"right"}>Right</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Cell Margin Top</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.data?.cell_margin?.top}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        data: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .data,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .data.cell_margin,
                                                                                                top: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Cell Margin Left</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.data?.cell_margin?.left}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        data: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .data,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .data.cell_margin,
                                                                                                left: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Cell Margin Right</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.data?.cell_margin?.right}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        data: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .data,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .data.cell_margin,
                                                                                                right: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Cell Margin Bottom</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.data?.cell_margin?.bottom}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        data: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .data,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .data.cell_margin,
                                                                                                bottom: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Blank Line Height</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.data?.blank_line_height}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        data: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .data,
                                                                                            blank_line_height: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" pt"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Sub Total Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${showErrorBorder && !header.client.font_id ? "error-border" : ""}`}
                                                                className="dropdown"
                                                                value={comp_analysis?.table?.sub_total?.font_id}
                                                                // name="font_id"
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        sub_total: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .sub_total,
                                                                                            font_id: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Font Size</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.sub_total?.font_size}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        sub_total: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .sub_total,
                                                                                            font_size: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                                // className={`${
                                                                //     showErrorBorder && custom_legend?.show_legend && !total?.font_size
                                                                //         ? "error-border"
                                                                //         : ""
                                                                // }`}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <label>Sub Total Font Color </label>
                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "table_subtotal_color" ? null : "table_subtotal_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{comp_analysis?.table?.sub_total?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: comp_analysis?.table?.sub_total?.font_color
                                                                            ? `#${comp_analysis?.table?.sub_total?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "table_subtotal_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={comp_analysis?.table?.sub_total?.font_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        comp_analysis: {
                                                                                            ...this.state.property.properties.comp_analysis,
                                                                                            table: {
                                                                                                ...this.state.property.properties.comp_analysis
                                                                                                    ?.table,
                                                                                                sub_total: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.sub_total,
                                                                                                    font_color: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <label>Sub Total Background Color </label>
                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "table_sub_total_bg_color"
                                                                                ? null
                                                                                : "table_sub_total_bg_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{comp_analysis?.table?.sub_total?.bg_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: comp_analysis?.table?.sub_total?.bg_color
                                                                            ? `#${comp_analysis?.table?.sub_total?.bg_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "table_sub_total_bg_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={comp_analysis?.table?.sub_total?.bg_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        comp_analysis: {
                                                                                            ...this.state.property.properties.comp_analysis,
                                                                                            table: {
                                                                                                ...this.state.property.properties.comp_analysis
                                                                                                    ?.table,
                                                                                                sub_total: {
                                                                                                    ...this.state.property.properties.comp_analysis
                                                                                                        ?.table.sub_total,
                                                                                                    bg_color: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="font-family font-st col-md-3">
                                                        <label>Sub Total Alignment</label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${showErrorBorder && !total?.alignment ? "error-border" : ""}`}
                                                                className="dropdown"
                                                                name="tag"
                                                                value={comp_analysis?.table?.sub_total?.alignment}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        sub_total: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .sub_total,
                                                                                            alignment: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                {" "}
                                                                <option value="">Select</option>
                                                                <option value={"left"}>Left</option>
                                                                <option value={"center"}>Center</option>
                                                                <option value={"right"}>Right</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Cell Margin Top</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.sub_total?.cell_margin?.top}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        sub_total: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .sub_total,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .sub_total.cell_margin,
                                                                                                top: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Cell Margin Left</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.sub_total?.cell_margin?.left}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        sub_total: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .sub_total,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .sub_total.cell_margin,
                                                                                                left: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Cell Margin Right</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.sub_total?.cell_margin?.right}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        sub_total: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .sub_total,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .sub_total.cell_margin,
                                                                                                right: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Cell Margin Bottom</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={comp_analysis?.table?.sub_total?.cell_margin?.bottom}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                comp_analysis: {
                                                                                    ...this.state.property.properties.comp_analysis,
                                                                                    table: {
                                                                                        ...this.state.property.properties.comp_analysis?.table,
                                                                                        sub_total: {
                                                                                            ...this.state.property.properties.comp_analysis?.table
                                                                                                .sub_total,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.comp_analysis?.table
                                                                                                    .sub_total.cell_margin,
                                                                                                bottom: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Table Column Configuration-Recommendation
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["ca_recommendation"], "comp_analysis")
                                                                ? "cursor-disabled"
                                                                : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["ca_recommendation"], "comp_analysis")}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["ca_recommendation"],
                                                                columnKey: "comp_analysis",
                                                                band: "Table Column Configuration-Recommendation"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <DragDropContext onDragEnd={this.onColumnDnd("ca_recommendation")}>
                                                {Array.from({
                                                    length: this.state?.totalRowsForColumnDnd
                                                }).map((rowData, i) => (
                                                    <Droppable droppableId={`droppable-${i}`} direction="horizontal">
                                                        {provided => (
                                                            <div ref={provided.innerRef} className="styles-sec">
                                                                <div className="d-flex f-outer">
                                                                    {comp_analysis?.ca_recommendation &&
                                                                        Object.entries(
                                                                            typeof comp_analysis?.ca_recommendation === "string"
                                                                                ? JSON.parse(comp_analysis?.ca_recommendation)
                                                                                : comp_analysis?.ca_recommendation
                                                                        )
                                                                            ?.slice(i * 4, (i + 1) * 4)
                                                                            ?.map(([columnKey, columnData], index) =>
                                                                                columnData?.label === "Code" ? (
                                                                                    <div className="font-family font-st col-md-3">
                                                                                        <div className="col-md-12 box-otr box-wide tabl-clm">
                                                                                            <div className="rem-txt ">
                                                                                                <label className="container-check">
                                                                                                    {columnData?.label || "-"}
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        checked={columnData?.selected}
                                                                                                        disabled={columnData?.label === "Code"}
                                                                                                        onChange={() => {
                                                                                                            this.setCaColumnConfig(
                                                                                                                columnKey,
                                                                                                                "selected",
                                                                                                                !columnData.selected,
                                                                                                                "ca_recommendation"
                                                                                                            );
                                                                                                        }}
                                                                                                    />
                                                                                                    <span
                                                                                                        className={`checkmark ${
                                                                                                            columnData?.label === "Code"
                                                                                                                ? "cursor-diabled"
                                                                                                                : ""
                                                                                                        }`}
                                                                                                    />
                                                                                                </label>
                                                                                            </div>
                                                                                            <div className="right-box-content">
                                                                                                <div class="input-box">
                                                                                                    <NumberFormat
                                                                                                        autoComplete={"nope"}
                                                                                                        className="custom-input form-control"
                                                                                                        value={columnData?.width}
                                                                                                        suffix={" inch"}
                                                                                                        thousandSeparator={true}
                                                                                                        onValueChange={values => {
                                                                                                            const { value } = values;
                                                                                                            this.setCaColumnConfig(
                                                                                                                columnKey,
                                                                                                                "width",
                                                                                                                Number(value),
                                                                                                                "ca_recommendation"
                                                                                                            );
                                                                                                        }}
                                                                                                    />
                                                                                                </div>
                                                                                                <div className="image-drag">
                                                                                                    <img src="/img/Group 2.svg" alt="" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (
                                                                                    <Draggable
                                                                                        key={`draggable-${i}${index}`}
                                                                                        draggableId={`draggable-${i}${index}`}
                                                                                        index={i * 4 + index}
                                                                                        isDragDisabled={columnData?.label === "Code"}
                                                                                    >
                                                                                        {provided => (
                                                                                            <div
                                                                                                ref={provided.innerRef}
                                                                                                {...provided.draggableProps}
                                                                                                {...provided.dragHandleProps}
                                                                                                key={`draggable-${index}`}
                                                                                                className="font-family font-st col-md-3"
                                                                                            >
                                                                                                <div className="col-md-12 box-otr box-wide tabl-clm">
                                                                                                    <div className="rem-txt">
                                                                                                        <label className="container-check">
                                                                                                            {columnData?.label || "-"}
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                checked={columnData?.selected}
                                                                                                                disabled={
                                                                                                                    columnData?.label === "Code"
                                                                                                                }
                                                                                                                onChange={() => {
                                                                                                                    this.setCaColumnConfig(
                                                                                                                        columnKey,
                                                                                                                        "selected",
                                                                                                                        !columnData.selected,
                                                                                                                        "ca_recommendation"
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className={`checkmark ${
                                                                                                                    columnData?.label === "Code"
                                                                                                                        ? "cursor-diabled"
                                                                                                                        : ""
                                                                                                                }`}
                                                                                                            />
                                                                                                        </label>
                                                                                                    </div>
                                                                                                    <div className="right-box-content">
                                                                                                        <div class="input-box">
                                                                                                            <NumberFormat
                                                                                                                autoComplete={"nope"}
                                                                                                                className="custom-input form-control"
                                                                                                                value={columnData?.width}
                                                                                                                suffix={" inch"}
                                                                                                                thousandSeparator={true}
                                                                                                                onValueChange={values => {
                                                                                                                    const { value } = values;
                                                                                                                    this.setCaColumnConfig(
                                                                                                                        columnKey,
                                                                                                                        "width",
                                                                                                                        Number(value),
                                                                                                                        "ca_recommendation"
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="image-drag">
                                                                                                            <img src="/img/Group 2.svg" alt="" />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {provided.placeholder}
                                                                                            </div>
                                                                                        )}
                                                                                    </Draggable>
                                                                                )
                                                                            )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                ))}
                                            </DragDropContext>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Table Column Configuration-Asset
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["ca_asset"], "comp_analysis")
                                                                ? "cursor-disabled"
                                                                : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["ca_asset"], "comp_analysis")}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["ca_asset"],
                                                                columnKey: "comp_analysis",
                                                                band: "Table Column Configuration-Asset"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>

                                            <DragDropContext onDragEnd={this.onColumnDnd("ca_asset")}>
                                                {Array.from({
                                                    length: this.state?.totalRowsForColumnDnd
                                                }).map((rowData, i) => (
                                                    <Droppable droppableId={`droppable-${i}`} direction="horizontal">
                                                        {provided => (
                                                            <div ref={provided.innerRef} className="styles-sec">
                                                                <div className="d-flex f-outer">
                                                                    {comp_analysis?.ca_asset &&
                                                                        Object.entries(
                                                                            typeof comp_analysis?.ca_asset === "string"
                                                                                ? JSON.parse(comp_analysis?.ca_asset)
                                                                                : comp_analysis?.ca_asset
                                                                        )
                                                                            ?.slice(i * 4, (i + 1) * 4)
                                                                            ?.map(([columnKey, columnData], index) =>
                                                                                columnData?.label === "Code" ? (
                                                                                    <div className="font-family font-st col-md-3">
                                                                                        <div className="col-md-12 box-otr box-wide tabl-clm">
                                                                                            <div className="rem-txt ">
                                                                                                <label className="container-check">
                                                                                                    {columnData?.label || "-"}
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        checked={columnData?.selected}
                                                                                                        disabled={columnData?.label === "Code"}
                                                                                                        onChange={() => {
                                                                                                            this.setCaColumnConfig(
                                                                                                                columnKey,
                                                                                                                "selected",
                                                                                                                !columnData.selected,
                                                                                                                "ca_asset"
                                                                                                            );
                                                                                                        }}
                                                                                                    />
                                                                                                    <span
                                                                                                        className={`checkmark ${
                                                                                                            columnData?.label === "Code"
                                                                                                                ? "cursor-diabled"
                                                                                                                : ""
                                                                                                        }`}
                                                                                                    />
                                                                                                </label>
                                                                                            </div>
                                                                                            <div className="right-box-content">
                                                                                                <div class="input-box">
                                                                                                    <NumberFormat
                                                                                                        autoComplete={"nope"}
                                                                                                        className="custom-input form-control"
                                                                                                        value={columnData?.width}
                                                                                                        suffix={" inch"}
                                                                                                        thousandSeparator={true}
                                                                                                        onValueChange={values => {
                                                                                                            const { value } = values;
                                                                                                            this.setCaColumnConfig(
                                                                                                                columnKey,
                                                                                                                "width",
                                                                                                                Number(value),
                                                                                                                "ca_asset"
                                                                                                            );
                                                                                                        }}
                                                                                                    />
                                                                                                </div>
                                                                                                <div className="image-drag">
                                                                                                    <img src="/img/Group 2.svg" alt="" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (
                                                                                    <Draggable
                                                                                        key={`draggable-${i}${index}`}
                                                                                        draggableId={`draggable-${i}${index}`}
                                                                                        index={i * 4 + index}
                                                                                        isDragDisabled={columnData?.label === "Code"}
                                                                                    >
                                                                                        {provided => (
                                                                                            <div
                                                                                                ref={provided.innerRef}
                                                                                                {...provided.draggableProps}
                                                                                                {...provided.dragHandleProps}
                                                                                                key={`draggable-${index}`}
                                                                                                className="font-family font-st col-md-3"
                                                                                            >
                                                                                                <div className="col-md-12 box-otr box-wide tabl-clm">
                                                                                                    <div className="rem-txt">
                                                                                                        <label className="container-check">
                                                                                                            {columnData?.label || "-"}
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                checked={columnData?.selected}
                                                                                                                disabled={
                                                                                                                    columnData?.label === "Code"
                                                                                                                }
                                                                                                                onChange={() => {
                                                                                                                    this.setCaColumnConfig(
                                                                                                                        columnKey,
                                                                                                                        "selected",
                                                                                                                        !columnData.selected,
                                                                                                                        "ca_asset"
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className={`checkmark ${
                                                                                                                    columnData?.label === "Code"
                                                                                                                        ? "cursor-diabled"
                                                                                                                        : ""
                                                                                                                }`}
                                                                                                            />
                                                                                                        </label>
                                                                                                    </div>
                                                                                                    <div className="right-box-content">
                                                                                                        <div class="input-box">
                                                                                                            <NumberFormat
                                                                                                                autoComplete={"nope"}
                                                                                                                className="custom-input form-control"
                                                                                                                value={columnData?.width}
                                                                                                                suffix={" inch"}
                                                                                                                thousandSeparator={true}
                                                                                                                onValueChange={values => {
                                                                                                                    const { value } = values;
                                                                                                                    this.setCaColumnConfig(
                                                                                                                        columnKey,
                                                                                                                        "width",
                                                                                                                        Number(value),
                                                                                                                        "ca_asset"
                                                                                                                    );
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="image-drag">
                                                                                                            <img src="/img/Group 2.svg" alt="" />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                {provided.placeholder}
                                                                                            </div>
                                                                                        )}
                                                                                    </Draggable>
                                                                                )
                                                                            )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                ))}
                                            </DragDropContext>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Page Header (Client Template Only)
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["header"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["header"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["header"],
                                                                band: "Page Header (Client Template Only)"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Client Font Name *</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown ${
                                                                    showErrorBorder && !header.client.font_id ? "error-border" : ""
                                                                }`}
                                                                value={header?.client?.font_id}
                                                                name="font_id"
                                                                onChange={e => this.handleChangeHeader("client", "font_id", e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Client Font Size *</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={header?.client?.font_size}
                                                                onValueChange={values =>
                                                                    this.handleChangeHeader("client", "font_size", values.floatValue)
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                                className={`${showErrorBorder && !header?.client?.font_size ? "error-border" : ""}`}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <label>Client Font Color *</label>
                                                        <div
                                                            className={`dropdown ${showErrorBorder && !header?.client?.color ? "error-border" : ""}`}
                                                        >
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "header_client_color" ? null : "header_client_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{header?.client?.color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: header?.client?.color ? `#${header?.client?.color}` : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "header_client_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={header?.client?.color}
                                                                        onChangeComplete={color =>
                                                                            this.handleChangeHeader("client", "color", color.hex?.replace("#", ""))
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Client Font Bold</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="tag"
                                                                value={header?.client?.bold}
                                                                onChange={e => this.handleChangeHeader("client", "bold", e.target.value === "true")}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Project Font Name *</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown ${
                                                                    showErrorBorder && !header.project.font_id ? "error-border" : ""
                                                                }`}
                                                                value={header?.project?.font_id}
                                                                name="font_id"
                                                                onChange={e => this.handleChangeHeader("project", "font_id", e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Project Font Size *</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={header?.project?.font_size}
                                                                onValueChange={values =>
                                                                    this.handleChangeHeader("project", "font_size", values.floatValue)
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                                className={`${showErrorBorder && !header?.project?.font_size ? "error-border" : ""}`}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <label>Project Font Color *</label>
                                                        <div
                                                            className={`dropdown ${showErrorBorder && !header?.project?.color ? "error-border" : ""}`}
                                                        >
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "header_project_color" ? null : "header_project_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{header?.project?.color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: header?.project?.color ? `#${header?.project?.color}` : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "header_project_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={header?.project?.color}
                                                                        onChangeComplete={color =>
                                                                            this.handleChangeHeader("project", "color", color.hex?.replace("#", ""))
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Project Font Bold</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="tag"
                                                                value={header?.project?.bold}
                                                                onChange={e => this.handleChangeHeader("project", "bold", e.target.value === "true")}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Logo Width</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={header?.logo?.width}
                                                                onValueChange={values => this.handleChangeHeader("logo", "width", values.floatValue)}
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <label>Logo Height</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={header?.logo?.height}
                                                                onValueChange={values => this.handleChangeHeader("logo", "height", values.floatValue)}
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Logo Client</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="tag"
                                                                value={header?.logo?.client}
                                                                onChange={e => this.handleChangeHeader("logo", "client", e.target.value === "true")}
                                                            >
                                                                <option value={true}>True</option>
                                                                <option value={false}>False</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Chart Heading
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["heading"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["heading"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["heading"],
                                                                band: "Chart Heading"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Font Name *</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown ${showErrorBorder && !heading?.font_id ? "error-border" : ""}`}
                                                                value={heading?.font_id}
                                                                name="font_id"
                                                                onChange={e => this.handleChangeChart("heading", "font_id", e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Font Size *</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={heading?.font_size}
                                                                onValueChange={values =>
                                                                    this.handleChangeChart("heading", "font_size", values.floatValue)
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                                className={`${showErrorBorder && !heading?.font_size ? "error-border" : ""}`}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <label>Font Color *</label>
                                                        <div className={`dropdown ${showErrorBorder && !heading?.color ? "error-border" : ""}`}>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState: colorModalState === "heading_color" ? null : "heading_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{heading?.color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{ background: heading?.color ? `#${heading?.color}` : "#fff" }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "heading_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={heading?.color}
                                                                        onChangeComplete={color =>
                                                                            this.handleChangeChart("heading", "color", color.hex?.replace("#", ""))
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Font Bold</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="tag"
                                                                value={heading?.bold}
                                                                onChange={e => this.handleChangeChart("heading", "bold", e.target.value === "true")}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Font Alignment</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown ${showErrorBorder && !heading?.alignment ? "error-border" : ""}`}
                                                                name="tag"
                                                                value={heading?.alignment}
                                                                onChange={e => this.handleChangeChart("heading", "alignment", e.target.value)}
                                                            >
                                                                <option value={"left"}>Left</option>
                                                                <option value={"center"}>Center</option>
                                                                <option value={"right"}>Right</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Chart Outer Frame (Border)
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["chart"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["chart"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["chart"],
                                                                band: "Chart Outer Frame (Border)"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Visible</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="frame"
                                                                value={chart?.frame}
                                                                onChange={e => this.handleChangeChart("chart", "frame", e.target.value === "true")}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {chart?.frame ? (
                                                <div className="styles-sec">
                                                    <div className="d-flex f-outer">
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Frame Width</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={chart?.frame_props?.size}
                                                                    onValueChange={values => {
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    chart: {
                                                                                        ...this.state.property.properties.chart,
                                                                                        frame_props: {
                                                                                            ...this.state.property.properties.chart.frame_props,
                                                                                            size: values.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        });
                                                                    }}
                                                                    allowNegative={false}
                                                                    suffix=" Pt"
                                                                    // className={`${showErrorBorder && !header?.client?.font_size ? "error-border" : ""}`}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Frame Padding</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={chart?.frame_props?.space}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    chart: {
                                                                                        ...this.state.property.properties.chart,
                                                                                        frame_props: {
                                                                                            ...this.state.property.properties.chart.frame_props,
                                                                                            space: values.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" Pt"
                                                                    // className={`${showErrorBorder && !header?.client?.font_size ? "error-border" : ""}`}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-color font-st col-md-3">
                                                            <label>Frame Color</label>
                                                            <div className={`dropdown`}>
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState: colorModalState === "frame_color" ? null : "frame_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{chart?.frame_props?.color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{
                                                                            background: chart?.frame_props?.color
                                                                                ? `#${chart?.frame_props?.color}`
                                                                                : "#fff"
                                                                        }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "frame_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={chart?.frame_props?.color}
                                                                            onChangeComplete={color => {
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        properties: {
                                                                                            ...this.state.property.properties,
                                                                                            chart: {
                                                                                                ...this.state.property.properties.chart,
                                                                                                frame_props: {
                                                                                                    ...this.state.property.properties.chart
                                                                                                        .frame_props,
                                                                                                    color: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="font-family font-st col-md-3">
                                                            <label>Frame Style</label>
                                                            <div className="font-select">
                                                                <select
                                                                    className={`dropdown`}
                                                                    value={chart?.frame_props?.val}
                                                                    name="font_id"
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    chart: {
                                                                                        ...this.state.property.properties.chart,
                                                                                        frame_props: {
                                                                                            ...this.state.property.properties.chart.frame_props,
                                                                                            val: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                >
                                                                    {/* <option value="">Select</option> */}
                                                                    {FRAME_STYLES.map((fStyle, i) => (
                                                                        <option key={i} value={fStyle.name}>
                                                                            {fStyle.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Chart X-Axis
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["chart_font", "x_axis"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["chart_font", "x_axis"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["chart_font", "x_axis"],
                                                                band: "Chart X-Axis"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Font Name</label>
                                                        <i
                                                            data-tip="Font Name of X-Axis, Y-Axis, Data Labels and Legends must be the same"
                                                            data-for="chart_property"
                                                            className="fas fa-info-circle ml-2"
                                                        />
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                value={chart_font?.font_id}
                                                                name="font_id"
                                                                onChange={e => this.handleChangeChart("chart_font", "font_id", e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Font Size</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={x_axis?.font_size}
                                                                onValueChange={values =>
                                                                    this.handleChangeChart("x_axis", "font_size", values.floatValue)
                                                                }
                                                                allowNegative={false}
                                                                suffix=" px"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <label>Font Color</label>
                                                        <div className={`dropdown`}>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState: colorModalState === "x_axis_color" ? null : "x_axis_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{x_axis?.color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{ background: x_axis?.color ? `#${x_axis?.color}` : "#fff" }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "x_axis_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={x_axis?.color}
                                                                        onChangeComplete={color =>
                                                                            this.handleChangeChart("x_axis", "color", color.hex?.replace("#", ""))
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop properties_restBtn">
                                                <h2 className="recom-h2-sec">
                                                    Chart Y-Axis
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["chart_font", "y_axis"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["chart_font", "y_axis"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["chart_font", "y_axis"],
                                                                band: " Chart Y-Axis"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Font Name</label>
                                                        <i
                                                            data-tip="Font Name of X-Axis, Y-Axis, Data Labels and Legends must be the same"
                                                            data-for="chart_property"
                                                            className="fas fa-info-circle ml-2"
                                                        />
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                value={chart_font?.font_id}
                                                                name="font_id"
                                                                onChange={e => this.handleChangeChart("chart_font", "font_id", e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Font Size</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={y_axis?.font_size}
                                                                onValueChange={values =>
                                                                    this.handleChangeChart("y_axis", "font_size", values.floatValue)
                                                                }
                                                                allowNegative={false}
                                                                suffix=" px"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <label>Font Color</label>
                                                        <div className={`dropdown`}>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState: colorModalState === "y_axis_color" ? null : "y_axis_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{y_axis?.color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{ background: y_axis?.color ? `#${y_axis?.color}` : "#fff" }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "y_axis_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={y_axis?.color}
                                                                        onChangeComplete={color =>
                                                                            this.handleChangeChart("y_axis", "color", color.hex?.replace("#", ""))
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Chart Data Labels
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["chart_font", "data_labels"])
                                                                ? "cursor-disabled"
                                                                : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["chart_font", "data_labels"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["chart_font", "data_labels"],
                                                                band: " Chart Data Labels"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Font Name</label>
                                                        <i
                                                            data-tip="Font Name of X-Axis, Y-Axis, Data Labels and Legends must be the same"
                                                            data-for="chart_property"
                                                            className="fas fa-info-circle ml-2"
                                                        />
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                value={chart_font?.font_id}
                                                                name="font_id"
                                                                onChange={e => this.handleChangeChart("chart_font", "font_id", e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Font Size</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={data_labels?.font_size}
                                                                onValueChange={values =>
                                                                    this.handleChangeChart("data_labels", "font_size", values.floatValue)
                                                                }
                                                                allowNegative={false}
                                                                suffix=" px"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <label>Font Color</label>
                                                        <div className={`dropdown`}>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "data_labels_color" ? null : "data_labels_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{data_labels?.color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{ background: data_labels?.color ? `#${data_labels?.color}` : "#fff" }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "data_labels_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={data_labels?.color}
                                                                        onChangeComplete={color =>
                                                                            this.handleChangeChart(
                                                                                "data_labels",
                                                                                "color",
                                                                                color.hex?.replace("#", "")
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Chart Custom Legend (Color Legend as part of the Chart)
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["chart_font", "legend"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["chart_font", "legend"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["chart_font", "legend"],
                                                                band: "Chart Custom Legend (Color Legend as part of the Chart) "
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Visible</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="show_legend"
                                                                value={legend?.show_legend}
                                                                onChange={e =>
                                                                    this.handleChangeChart("legend", "show_legend", e.target.value === "true")
                                                                }
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {legend?.show_legend && (
                                                <>
                                                    <div className="styles-sec">
                                                        <div className="d-flex f-outer">
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Font Name</label>
                                                                <i
                                                                    data-tip="Font Name of X-Axis, Y-Axis, Data Labels and Legends must be the same"
                                                                    data-for="chart_property"
                                                                    className="fas fa-info-circle ml-2"
                                                                />
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown`}
                                                                        value={chart_font?.font_id}
                                                                        name="font_id"
                                                                        onChange={e =>
                                                                            this.handleChangeChart("chart_font", "font_id", e.target.value)
                                                                        }
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {FONT_FAMILY.map(f => (
                                                                            <option key={f.id} value={f.id}>
                                                                                {f.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Font Size</label>
                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={legend?.font_size}
                                                                        onValueChange={values =>
                                                                            this.handleChangeChart("legend", "font_size", values.floatValue)
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" px"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="font-color font-st col-md-3">
                                                                <label>Font Color</label>
                                                                <div className={`dropdown`}>
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "legend_font_color"
                                                                                        ? null
                                                                                        : "legend_font_color"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>{legend?.font_color || "Select"}</span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: legend?.font_color ? `#${legend?.font_color}` : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                    </div>
                                                                    {colorModalState === "legend_font_color" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={legend?.font_color}
                                                                                onChangeComplete={color =>
                                                                                    this.handleChangeChart(
                                                                                        "legend",
                                                                                        "font_color",
                                                                                        color.hex?.replace("#", "")
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Font Bold</label>
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown`}
                                                                        name="legend"
                                                                        value={legend?.bold}
                                                                        onChange={e =>
                                                                            this.handleChangeChart("legend", "bold", e.target.value === "true")
                                                                        }
                                                                    >
                                                                        <option value={false}>No</option>
                                                                        <option value={true}>Yes</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="styles-sec">
                                                        <div className="d-flex f-outer">
                                                            <div className="font-color font-st col-md-3">
                                                                <label>Background Color</label>
                                                                <div className={`dropdown`}>
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "legend_bg_color" ? null : "legend_bg_color"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>{legend?.backgroundColor || "Select"}</span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: legend?.backgroundColor
                                                                                    ? `#${legend?.backgroundColor}`
                                                                                    : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                    </div>
                                                                    {colorModalState === "legend_bg_color" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={legend?.backgroundColor}
                                                                                onChangeComplete={color =>
                                                                                    this.handleChangeChart(
                                                                                        "legend",
                                                                                        "backgroundColor",
                                                                                        color.hex?.replace("#", "")
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="font-color font-st col-md-3">
                                                                <label>Border Color</label>
                                                                <div className={`dropdown`}>
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "legend_border_color"
                                                                                        ? null
                                                                                        : "legend_border_color"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>{legend?.borderColor || "Select"}</span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: legend?.borderColor ? `#${legend?.borderColor}` : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                    </div>
                                                                    {colorModalState === "legend_border_color" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={legend?.borderColor}
                                                                                onChangeComplete={color =>
                                                                                    this.handleChangeChart(
                                                                                        "legend",
                                                                                        "borderColor",
                                                                                        color.hex?.replace("#", "")
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Border Width</label>
                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={legend?.borderWidth}
                                                                        onValueChange={values =>
                                                                            this.handleChangeChart("legend", "borderWidth", values.floatValue)
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" px"
                                                                        // className={`${showErrorBorder && !legend?.borderWidth ? "error-border" : ""}`}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Border Radius</label>
                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={legend?.borderRadius}
                                                                        onValueChange={values =>
                                                                            this.handleChangeChart("legend", "borderRadius", values.floatValue)
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" px"
                                                                        // className={`${
                                                                        //     showErrorBorder && !legend?.borderRadius ? "error-border" : ""
                                                                        // }`}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* k or m  */}
                                                    <div className="styles-sec">
                                                        <div className="d-flex f-outer">
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Value Display Settings:</label>
                                                                <i
                                                                    data-tip="Show Values in Thousands (K), Millions (M)"
                                                                    data-for="display_formats"
                                                                    className="fas fa-info-circle ml-2"
                                                                />
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown`}
                                                                        value={legend?.display_formats?.length === 1 ? "true" : "false"}
                                                                        name="display_formats"
                                                                        onChange={e =>
                                                                            this.handleDisplaySettings("legend", "display_formats", e.target.value)
                                                                        }
                                                                    >
                                                                        <option value="false"> Display Value in K, M</option>
                                                                        <option value="true">Always Show in M </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Chart Value and % Breakdown (Below the Chart)
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["custom_legend"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["custom_legend"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["custom_legend"],
                                                                band: "Chart Value and % Breakdown (Below the Chart)"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Visible</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="tag"
                                                                value={custom_legend?.show_legend}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                custom_legend: {
                                                                                    ...this.state.property.properties.custom_legend,
                                                                                    show_legend: e.target.value === "true"
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {custom_legend?.show_legend ? (
                                                <>
                                                    <div className="styles-sec">
                                                        <div className="d-flex f-outer">
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Header Font Name *</label>
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown ${
                                                                            showErrorBorder &&
                                                                            custom_legend.show_legend &&
                                                                            !custom_legend?.legend_heading?.font_id
                                                                                ? "error-border"
                                                                                : ""
                                                                        }`}
                                                                        value={custom_legend?.legend_heading?.font_id}
                                                                        name="font_id"
                                                                        onChange={e =>
                                                                            this.handleChangeCustomLegend("legend_heading", "font_id", e.target.value)
                                                                        }
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {FONT_FAMILY.map(f => (
                                                                            <option key={f.id} value={f.id}>
                                                                                {f.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Header Font Size *</label>
                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={custom_legend?.legend_heading?.font_size}
                                                                        onValueChange={values =>
                                                                            this.handleChangeCustomLegend(
                                                                                "legend_heading",
                                                                                "font_size",
                                                                                values.floatValue
                                                                            )
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" Pt"
                                                                        className={`${
                                                                            showErrorBorder &&
                                                                            custom_legend.show_legend &&
                                                                            !custom_legend?.legend_heading?.font_size
                                                                                ? "error-border"
                                                                                : ""
                                                                        }`}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="font-color font-st col-md-3">
                                                                <label>Header Font Color *</label>
                                                                <div
                                                                    className={`dropdown ${
                                                                        showErrorBorder && !custom_legend?.legend_heading?.color ? "error-border" : ""
                                                                    }`}
                                                                >
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "custom_legend_heading_color"
                                                                                        ? null
                                                                                        : "custom_legend_heading_color"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>{custom_legend?.legend_heading?.color || "Select"}</span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: custom_legend?.legend_heading?.color
                                                                                    ? `#${custom_legend?.legend_heading?.color}`
                                                                                    : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                    </div>
                                                                    {colorModalState === "custom_legend_heading_color" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={custom_legend?.legend_heading?.color}
                                                                                onChangeComplete={color =>
                                                                                    this.handleChangeCustomLegend(
                                                                                        "legend_heading",
                                                                                        "color",
                                                                                        color.hex?.replace("#", "")
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Header Font Bold</label>
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown`}
                                                                        name="tag"
                                                                        value={custom_legend?.legend_heading?.bold}
                                                                        onChange={e =>
                                                                            this.handleChangeCustomLegend(
                                                                                "legend_heading",
                                                                                "bold",
                                                                                e.target.value === "true"
                                                                            )
                                                                        }
                                                                    >
                                                                        <option value={false}>No</option>
                                                                        <option value={true}>Yes</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex f-outer">
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Header Font Alignment</label>
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown ${
                                                                            showErrorBorder && !custom_legend?.legend_heading?.alignment
                                                                                ? "error-border"
                                                                                : ""
                                                                        }`}
                                                                        name="tag"
                                                                        value={custom_legend?.legend_heading?.alignment}
                                                                        onChange={e =>
                                                                            this.handleChangeCustomLegend(
                                                                                "legend_heading",
                                                                                "alignment",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    >
                                                                        <option value={"left"}>Left</option>
                                                                        <option value={"center"}>Center</option>
                                                                        <option value={"right"}>Right</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="font-color font-st col-md-3">
                                                                <label>Header Background Color *</label>
                                                                <div
                                                                    className={`dropdown ${
                                                                        showErrorBorder && !custom_legend?.legend_heading?.bg_color
                                                                            ? "error-border"
                                                                            : ""
                                                                    }`}
                                                                >
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "custom_legend_heading_bg_color"
                                                                                        ? null
                                                                                        : "custom_legend_heading_bg_color"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>{custom_legend?.legend_heading?.bg_color || "Select"}</span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: custom_legend?.legend_heading?.bg_color
                                                                                    ? `#${custom_legend?.legend_heading?.bg_color}`
                                                                                    : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                    </div>
                                                                    {colorModalState === "custom_legend_heading_bg_color" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={custom_legend?.legend_heading?.bg_color}
                                                                                onChangeComplete={color =>
                                                                                    this.handleChangeCustomLegend(
                                                                                        "legend_heading",
                                                                                        "bg_color",
                                                                                        color.hex?.replace("#", "")
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="styles-sec">
                                                        <div className="d-flex f-outer">
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Value Font Name *</label>
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown ${
                                                                            showErrorBorder &&
                                                                            custom_legend.show_legend &&
                                                                            !custom_legend?.legend_value?.font_id
                                                                                ? "error-border"
                                                                                : ""
                                                                        }`}
                                                                        value={custom_legend?.legend_value?.font_id}
                                                                        name="font_id"
                                                                        onChange={e =>
                                                                            this.handleChangeCustomLegend("legend_value", "font_id", e.target.value)
                                                                        }
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {FONT_FAMILY.map(f => (
                                                                            <option key={f.id} value={f.id}>
                                                                                {f.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="font-size font-st col-md-3">
                                                                <label>Value Font Size *</label>
                                                                <div className={`input-ft-size`}>
                                                                    <NumberFormat
                                                                        value={custom_legend?.legend_value?.font_size}
                                                                        onValueChange={values =>
                                                                            this.handleChangeCustomLegend(
                                                                                "legend_value",
                                                                                "font_size",
                                                                                values.floatValue
                                                                            )
                                                                        }
                                                                        allowNegative={false}
                                                                        suffix=" Pt"
                                                                        className={`${
                                                                            showErrorBorder &&
                                                                            custom_legend.show_legend &&
                                                                            !custom_legend?.legend_value?.font_size
                                                                                ? "error-border"
                                                                                : ""
                                                                        }`}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="font-color font-st col-md-3">
                                                                <label>Value Font Color *</label>
                                                                <div
                                                                    className={`dropdown ${
                                                                        showErrorBorder && !custom_legend?.legend_value?.color ? "error-border" : ""
                                                                    }`}
                                                                >
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "custom_legend_value_color"
                                                                                        ? null
                                                                                        : "custom_legend_value_color"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>{custom_legend?.legend_value?.color || "Select"}</span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: custom_legend?.legend_value?.color
                                                                                    ? `#${custom_legend?.legend_value?.color}`
                                                                                    : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                    </div>
                                                                    {colorModalState === "custom_legend_value_color" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={custom_legend?.legend_value?.color}
                                                                                onChangeComplete={color =>
                                                                                    this.handleChangeCustomLegend(
                                                                                        "legend_value",
                                                                                        "color",
                                                                                        color.hex?.replace("#", "")
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Value Font Bold</label>
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown`}
                                                                        name="tag"
                                                                        value={custom_legend?.legend_value?.bold}
                                                                        onChange={e =>
                                                                            this.handleChangeCustomLegend(
                                                                                "legend_value",
                                                                                "bold",
                                                                                e.target.value === "true"
                                                                            )
                                                                        }
                                                                    >
                                                                        <option value={false}>No</option>
                                                                        <option value={true}>Yes</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex f-outer">
                                                            <div className="font-family font-st col-md-3">
                                                                <label>Value Font Alignment</label>
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown ${
                                                                            showErrorBorder && !custom_legend?.legend_value?.alignment
                                                                                ? "error-border"
                                                                                : ""
                                                                        }`}
                                                                        name="tag"
                                                                        value={custom_legend?.legend_value?.alignment}
                                                                        onChange={e =>
                                                                            this.handleChangeCustomLegend("legend_value", "alignment", e.target.value)
                                                                        }
                                                                    >
                                                                        <option value={"left"}>Left</option>
                                                                        <option value={"center"}>Center</option>
                                                                        <option value={"right"}>Right</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="font-color font-st col-md-3">
                                                                <label>Value Background Color *</label>
                                                                <div
                                                                    className={`dropdown ${
                                                                        showErrorBorder && !custom_legend?.legend_value?.bg_color
                                                                            ? "error-border"
                                                                            : ""
                                                                    }`}
                                                                >
                                                                    <div
                                                                        className="dropdown-toggle"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState:
                                                                                    colorModalState === "custom_legend_value_bg_color"
                                                                                        ? null
                                                                                        : "custom_legend_value_bg_color"
                                                                            });
                                                                        }}
                                                                    >
                                                                        <span>{custom_legend?.legend_value?.bg_color || "Select"}</span>
                                                                        <span
                                                                            className="color-bx"
                                                                            style={{
                                                                                background: custom_legend?.legend_value?.bg_color
                                                                                    ? `#${custom_legend?.legend_value?.bg_color}`
                                                                                    : "#fff"
                                                                            }}
                                                                        ></span>
                                                                        <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                    </div>
                                                                    {colorModalState === "custom_legend_value_bg_color" && (
                                                                        <div className="z-index-10" style={{ position: "absolute" }}>
                                                                            <CompactPicker
                                                                                className="picker"
                                                                                colors={FONT_COLOR}
                                                                                color={custom_legend?.legend_value?.bg_color}
                                                                                onChangeComplete={color =>
                                                                                    this.handleChangeCustomLegend(
                                                                                        "legend_value",
                                                                                        "bg_color",
                                                                                        color.hex?.replace("#", "")
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {/* k or m  */}

                                                            <div className="font-family font-st col-md-3">
                                                                <label>Value Display Settings:</label>
                                                                <i
                                                                    data-tip="Show Values in Thousands (K), Millions (M)"
                                                                    data-for="display_formats"
                                                                    className="fas fa-info-circle ml-2"
                                                                />
                                                                <div className="font-select">
                                                                    <select
                                                                        className={`dropdown`}
                                                                        value={
                                                                            custom_legend?.legend_value.display_formats?.length === 1
                                                                                ? "true"
                                                                                : "false"
                                                                        }
                                                                        name="display_formats"
                                                                        onChange={e =>
                                                                            this.handleDisplaySettings(
                                                                                "custom_legend",
                                                                                "display_formats",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    >
                                                                        <option value="false"> Display Value in K, M</option>
                                                                        <option value="true">Always Show in M </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : null}
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Chart Total (Below the Chart)
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["total"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["total"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["total"],
                                                                band: "Chart Total (Below the Chart)"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Visible</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="tag"
                                                                value={total?.show_total}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                total: {
                                                                                    ...this.state.property.properties.total,
                                                                                    show_total: e.target.value === "true"
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {total?.show_total ? (
                                                <div className="styles-sec">
                                                    <div className="d-flex f-outer">
                                                        <div className="font-family font-st col-md-3">
                                                            <label>Font Name *</label>
                                                            <div className="font-select">
                                                                <select
                                                                    className={`dropdown ${
                                                                        showErrorBorder && custom_legend?.show_legend && !total?.font_id
                                                                            ? "error-border"
                                                                            : ""
                                                                    }`}
                                                                    value={total?.font_id}
                                                                    name="font_id"
                                                                    onChange={e => this.handleChangeChart("total", "font_id", e.target.value)}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {FONT_FAMILY.map(f => (
                                                                        <option key={f.id} value={f.id}>
                                                                            {f.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Font Size *</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={total?.font_size}
                                                                    onValueChange={values =>
                                                                        this.handleChangeChart("total", "font_size", values.floatValue)
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" Pt"
                                                                    className={`${
                                                                        showErrorBorder && custom_legend?.show_legend && !total?.font_size
                                                                            ? "error-border"
                                                                            : ""
                                                                    }`}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-color font-st col-md-3">
                                                            <label>Font Color *</label>
                                                            <div className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}>
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState: colorModalState === "total_color" ? null : "total_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{total?.color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{ background: total?.color ? `#${total?.color}` : "#fff" }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "total_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={total?.color}
                                                                            onChangeComplete={color =>
                                                                                this.handleChangeChart("total", "color", color.hex?.replace("#", ""))
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="font-family font-st col-md-3">
                                                            <label>Font Bold</label>
                                                            <div className="font-select">
                                                                <select
                                                                    className={`dropdown`}
                                                                    name="tag"
                                                                    value={total?.bold}
                                                                    onChange={e => this.handleChangeChart("total", "bold", e.target.value === "true")}
                                                                >
                                                                    <option value={false}>No</option>
                                                                    <option value={true}>Yes</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex f-outer">
                                                        <div className="font-family font-st col-md-3">
                                                            <label>Font Alignment</label>
                                                            <div className="font-select">
                                                                <select
                                                                    className={`dropdown ${
                                                                        showErrorBorder && !total?.alignment ? "error-border" : ""
                                                                    }`}
                                                                    name="tag"
                                                                    value={total?.alignment}
                                                                    onChange={e => this.handleChangeChart("total", "alignment", e.target.value)}
                                                                >
                                                                    <option value={"left"}>Left</option>
                                                                    <option value={"center"}>Center</option>
                                                                    <option value={"right"}>Right</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="font-color font-st col-md-3">
                                                            <label>Background Color *</label>
                                                            <div className={`dropdown ${showErrorBorder && !total?.bg_color ? "error-border" : ""}`}>
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState:
                                                                                colorModalState === "total_bg_color" ? null : "total_bg_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{total?.bg_color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{ background: total?.bg_color ? `#${total?.bg_color}` : "#fff" }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "total_bg_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={total?.bg_color}
                                                                            onChangeComplete={color =>
                                                                                this.handleChangeChart(
                                                                                    "total",
                                                                                    "bg_color",
                                                                                    color.hex?.replace("#", "")
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : null}
                                            {/* k or m  */}
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Value Display Settings:</label>
                                                        <i
                                                            data-tip="Show Values in Thousands (K), Millions (M)"
                                                            data-for="display_formats"
                                                            className="fas fa-info-circle ml-2"
                                                        />
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                value={total?.display_formats?.length === 1 ? "true" : "false"}
                                                                name="display_formats"
                                                                onChange={e => this.handleDisplaySettings("total", "display_formats", e.target.value)}
                                                            >
                                                                <option value="false"> Display Value in K, M</option>
                                                                <option value="true">Always Show in M </option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* table properties */}
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Chart Data Table Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["table"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["table"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["table"],
                                                                band: "Chart Data Table Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Table Style </label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${
                                                                //     showErrorBorder && custom_legend?.show_legend && !total?.font_id
                                                                //         ? "error-border"
                                                                //         : ""
                                                                // }`}
                                                                className="dropdown"
                                                                value={table?.table_style_id || "-"}
                                                                // name="table_style"
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    table_style_id: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {/* <option value="CBRE Table - Emerald Option 2">CBRE Table - Emerald Option 2</option> */}
                                                                {TABLE_STYLE.map(f => (
                                                                    <option value={f.id} key={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Table Column Width (Only for excel export)</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.col_width}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    col_width: Number(values.value)
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>
                                                            Table Page Fit{" "}
                                                            <i
                                                                className="fa fa-info info-ft-st"
                                                                data-for="table_page_fit"
                                                                data-tip="True- Fit table to page layout</br> False- Auto Adjust columns based on content"
                                                            />
                                                        </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                name="tag"
                                                                value={table?.table_page_fit}
                                                                onChange={e => {
                                                                    const value = e.target.value === "true";
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties?.table,
                                                                                    table_page_fit: value
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                {" "}
                                                                <option value="">Select</option>
                                                                <option value={"true"}>True</option>
                                                                <option value={"false"}>False</option>
                                                            </select>
                                                        </div>
                                                        <ReactTooltip
                                                            className="rc-tooltip-custom-class tool-format-bx"
                                                            id="table_page_fit"
                                                            backgroundColor="#007bff"
                                                            place="top"
                                                            effect="solid"
                                                            html={true}
                                                            getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="styles-sec">
                                                    <div className="d-flex f-outer">
                                                        <div className="font-family font-st col-md-3">
                                                            <label>Custom Heading Font Name </label>
                                                            <div className="font-select">
                                                                <select
                                                                    // className={`dropdown ${showErrorBorder && !header.client.font_id ? "error-border" : ""}`}
                                                                    className="dropdown"
                                                                    value={table?.custom_head?.font_id}
                                                                    // name="font_id"
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        custom_head: {
                                                                                            ...this.state.property.properties.table.custom_head,
                                                                                            font_id: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="">Select</option>
                                                                    {FONT_FAMILY.map(f => (
                                                                        <option key={f.id} value={f.id}>
                                                                            {f.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Font Size</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.custom_head?.font_size}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        custom_head: {
                                                                                            ...this.state.property.properties.table.custom_head,
                                                                                            font_size: Number(values.value)
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" Pt"
                                                                    // className={`${
                                                                    //     showErrorBorder && custom_legend?.show_legend && !total?.font_size
                                                                    //         ? "error-border"
                                                                    //         : ""
                                                                    // }`}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="font-color font-st col-md-3">
                                                            <label>Custom Heading Font Color </label>
                                                            <div
                                                                // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                                className="dropdown"
                                                            >
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState:
                                                                                colorModalState === "table_custom_heading_color"
                                                                                    ? null
                                                                                    : "table_custom_heading_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{table?.custom_head?.font_color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{
                                                                            background: table?.custom_head?.font_color
                                                                                ? `#${table?.custom_head?.font_color}`
                                                                                : "#fff"
                                                                        }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "table_custom_heading_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={table?.custom_head?.font_color}
                                                                            onChangeComplete={color =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        properties: {
                                                                                            ...this.state.property.properties,
                                                                                            table: {
                                                                                                ...this.state.property.properties.table,
                                                                                                custom_head: {
                                                                                                    ...this.state.property.properties.table
                                                                                                        .custom_head,
                                                                                                    font_color: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="font-color font-st col-md-3">
                                                            <label>Custom Heading Background Color </label>
                                                            <div
                                                                // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                                className="dropdown"
                                                            >
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState:
                                                                                colorModalState === "table_custom_heading_bg_color"
                                                                                    ? null
                                                                                    : "table_custom_heading_bg_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{table?.custom_head?.bg_color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{
                                                                            background: table?.custom_head?.bg_color
                                                                                ? `#${table?.custom_head?.bg_color}`
                                                                                : "#fff"
                                                                        }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "table_custom_heading_bg_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={table?.custom_head?.bg_color}
                                                                            onChangeComplete={color =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        properties: {
                                                                                            ...this.state.property.properties,
                                                                                            table: {
                                                                                                ...this.state.property.properties.table,
                                                                                                custom_head: {
                                                                                                    ...this.state.property.properties.table
                                                                                                        .custom_head,
                                                                                                    bg_color: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="font-family font-st col-md-3">
                                                            <label>Custom Heading Alignment</label>
                                                            <div className="font-select">
                                                                <select
                                                                    // className={`dropdown ${showErrorBorder && !total?.alignment ? "error-border" : ""}`}
                                                                    className="dropdown"
                                                                    name="tag"
                                                                    value={table?.custom_head?.alignment}
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        custom_head: {
                                                                                            ...this.state.property.properties.table.custom_head,
                                                                                            alignment: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                >
                                                                    {" "}
                                                                    <option value="">Select</option>
                                                                    <option value={"left"}>Left</option>
                                                                    <option value={"center"}>Center</option>
                                                                    <option value={"right"}>Right</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Cell Margin Top</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.custom_head?.cell_margin?.top}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        custom_head: {
                                                                                            ...this.state.property.properties.table.custom_head,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.table.custom_head
                                                                                                    .cell_margin,
                                                                                                top: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Cell Margin Left</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.custom_head?.cell_margin?.left}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        custom_head: {
                                                                                            ...this.state.property.properties.table.custom_head,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.table.custom_head
                                                                                                    .cell_margin,
                                                                                                left: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Cell Margin Right</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.custom_head?.cell_margin?.right}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        custom_head: {
                                                                                            ...this.state.property.properties.table.custom_head,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.table.custom_head
                                                                                                    .cell_margin,
                                                                                                right: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Cell Margin Bottom</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.custom_head?.cell_margin?.bottom}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        custom_head: {
                                                                                            ...this.state.property.properties.table.custom_head,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.table.custom_head
                                                                                                    .cell_margin,
                                                                                                bottom: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Custom Heading Blank Line Height</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.custom_head?.blank_line_height}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        custom_head: {
                                                                                            ...this.state.property.properties.table.custom_head,
                                                                                            blank_line_height: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" pt"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="styles-sec">
                                                    <div className="d-flex f-outer">
                                                        <div className="font-family font-st col-md-3">
                                                            <label>Heading Font Name </label>
                                                            <div className="font-select">
                                                                <select
                                                                    // className={`dropdown ${showErrorBorder && !header.client.font_id ? "error-border" : ""}`}
                                                                    className="dropdown"
                                                                    value={table?.heading?.font_id}
                                                                    // name="font_id"
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        heading: {
                                                                                            ...this.state.property.properties.table.heading,
                                                                                            font_id: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                >
                                                                    <option value="">Select</option>
                                                                    {FONT_FAMILY.map(f => (
                                                                        <option key={f.id} value={f.id}>
                                                                            {f.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Font Size</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.heading?.font_size}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        heading: {
                                                                                            ...this.state.property.properties.table.heading,
                                                                                            font_size: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" Pt"
                                                                    // className={`${
                                                                    //     showErrorBorder && custom_legend?.show_legend && !total?.font_size
                                                                    //         ? "error-border"
                                                                    //         : ""
                                                                    // }`}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="font-color font-st col-md-3">
                                                            <label>Heading Font Color </label>
                                                            <div
                                                                // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                                className="dropdown"
                                                            >
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState:
                                                                                colorModalState === "table_heading_color"
                                                                                    ? null
                                                                                    : "table_heading_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{table?.heading?.font_color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{
                                                                            background: table?.heading?.font_color
                                                                                ? `#${table?.heading?.font_color}`
                                                                                : "#fff"
                                                                        }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "table_heading_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={table?.heading?.font_color}
                                                                            onChangeComplete={color =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        properties: {
                                                                                            ...this.state.property.properties,
                                                                                            table: {
                                                                                                ...this.state.property.properties.table,
                                                                                                heading: {
                                                                                                    ...this.state.property.properties.table.heading,
                                                                                                    font_color: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="font-color font-st col-md-3">
                                                            <label>Heading Background Color </label>
                                                            <div
                                                                // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                                className="dropdown"
                                                            >
                                                                <div
                                                                    className="dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            colorModalState:
                                                                                colorModalState === "table_heading_bg_color"
                                                                                    ? null
                                                                                    : "table_heading_bg_color"
                                                                        });
                                                                    }}
                                                                >
                                                                    <span>{table?.heading?.bg_color || "Select"}</span>
                                                                    <span
                                                                        className="color-bx"
                                                                        style={{
                                                                            background: table?.heading?.bg_color
                                                                                ? `#${table?.heading?.bg_color}`
                                                                                : "#fff"
                                                                        }}
                                                                    ></span>
                                                                    <i aria-hidden="true" className="grey chevron down icon"></i>
                                                                </div>
                                                                {colorModalState === "table_heading_bg_color" && (
                                                                    <div className="z-index-10" style={{ position: "absolute" }}>
                                                                        <CompactPicker
                                                                            className="picker"
                                                                            colors={FONT_COLOR}
                                                                            color={table?.heading?.bg_color}
                                                                            onChangeComplete={color =>
                                                                                this.setState({
                                                                                    property: {
                                                                                        ...this.state.property,
                                                                                        properties: {
                                                                                            ...this.state.property.properties,
                                                                                            table: {
                                                                                                ...this.state.property.properties.table,
                                                                                                heading: {
                                                                                                    ...this.state.property.properties.table.heading,
                                                                                                    bg_color: color.hex?.replace("#", "")
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="font-family font-st col-md-3">
                                                            <label>Heading Alignment</label>
                                                            <div className="font-select">
                                                                <select
                                                                    // className={`dropdown ${showErrorBorder && !total?.alignment ? "error-border" : ""}`}
                                                                    className="dropdown"
                                                                    name="tag"
                                                                    value={table?.heading?.alignment}
                                                                    onChange={e =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        heading: {
                                                                                            ...this.state.property.properties.table.heading,
                                                                                            alignment: e.target.value
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                >
                                                                    {" "}
                                                                    <option value="">Select</option>
                                                                    <option value={"left"}>Left</option>
                                                                    <option value={"center"}>Center</option>
                                                                    <option value={"right"}>Right</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Cell Margin Top</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.heading?.cell_margin?.top}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        heading: {
                                                                                            ...this.state.property.properties.table.heading,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.table.heading
                                                                                                    .cell_margin,
                                                                                                top: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Cell Margin Left</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.heading?.cell_margin?.left}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        heading: {
                                                                                            ...this.state.property.properties.table.heading,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.table.heading
                                                                                                    .cell_margin,
                                                                                                left: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Cell Margin Right</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.heading?.cell_margin?.right}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        heading: {
                                                                                            ...this.state.property.properties.table.heading,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.table.heading
                                                                                                    .cell_margin,
                                                                                                right: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="font-size font-st col-md-3">
                                                            <label>Heading Cell Margin Bottom</label>
                                                            <div className={`input-ft-size`}>
                                                                <NumberFormat
                                                                    value={table?.heading?.cell_margin?.bottom}
                                                                    onValueChange={values =>
                                                                        this.setState({
                                                                            property: {
                                                                                ...this.state.property,
                                                                                properties: {
                                                                                    ...this.state.property.properties,
                                                                                    table: {
                                                                                        ...this.state.property.properties.table,
                                                                                        heading: {
                                                                                            ...this.state.property.properties.table.heading,
                                                                                            cell_margin: {
                                                                                                ...this.state.property.properties.table.heading
                                                                                                    .cell_margin,
                                                                                                bottom: values.floatValue
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        })
                                                                    }
                                                                    allowNegative={false}
                                                                    suffix=" inch"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Data Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${showErrorBorder && !header.client.font_id ? "error-border" : ""}`}
                                                                className="dropdown"
                                                                value={table?.data?.font_id}
                                                                // name="font_id"
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    data: {
                                                                                        ...this.state.property.properties.table.data,
                                                                                        font_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Font Size</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.data?.font_size}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    data: {
                                                                                        ...this.state.property.properties.table.data,
                                                                                        font_size: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                                // className={`${
                                                                //     showErrorBorder && custom_legend?.show_legend && !total?.font_size
                                                                //         ? "error-border"
                                                                //         : ""
                                                                // }`}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-color font-st col-md-3">
                                                        <label>Data Font Color </label>
                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "table_custom_font_color"
                                                                                ? null
                                                                                : "table_custom_font_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{table?.data?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: table?.data?.font_color ? `#${table?.data?.font_color}` : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "table_custom_font_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={table?.data?.font_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        table: {
                                                                                            ...this.state.property.properties.table,
                                                                                            data: {
                                                                                                ...this.state.property.properties.table.data,
                                                                                                font_color: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Data Alignment</label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${showErrorBorder && !total?.alignment ? "error-border" : ""}`}
                                                                className="dropdown"
                                                                name="tag"
                                                                value={table?.data?.alignment}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    data: {
                                                                                        ...this.state.property.properties.table.data,
                                                                                        alignment: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                {" "}
                                                                <option value="">Select</option>
                                                                <option value={"left"}>Left</option>
                                                                <option value={"center"}>Center</option>
                                                                <option value={"right"}>Right</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Cell Margin Top</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.data?.cell_margin?.top}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    data: {
                                                                                        ...this.state.property.properties.table.data,
                                                                                        cell_margin: {
                                                                                            ...this.state.property.properties.table.data.cell_margin,
                                                                                            top: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Cell Margin Left</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.data?.cell_margin?.left}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    data: {
                                                                                        ...this.state.property.properties.table.data,
                                                                                        cell_margin: {
                                                                                            ...this.state.property.properties.table.data.cell_margin,
                                                                                            left: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Cell Margin Right</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.data?.cell_margin?.right}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    data: {
                                                                                        ...this.state.property.properties.table.data,
                                                                                        cell_margin: {
                                                                                            ...this.state.property.properties.table.data.cell_margin,
                                                                                            right: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Data Cell Margin Bottom</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.data?.cell_margin?.bottom}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    data: {
                                                                                        ...this.state.property.properties.table.data,
                                                                                        cell_margin: {
                                                                                            ...this.state.property.properties.table.data.cell_margin,
                                                                                            bottom: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Sub Total Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${showErrorBorder && !header.client.font_id ? "error-border" : ""}`}
                                                                className="dropdown"
                                                                value={table?.sub_total?.font_id}
                                                                // name="font_id"
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    sub_total: {
                                                                                        ...this.state.property.properties.table.sub_total,
                                                                                        font_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Font Size</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.sub_total?.font_size}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    sub_total: {
                                                                                        ...this.state.property.properties.table.sub_total,
                                                                                        font_size: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                                // className={`${
                                                                //     showErrorBorder && custom_legend?.show_legend && !total?.font_size
                                                                //         ? "error-border"
                                                                //         : ""
                                                                // }`}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <label>Sub Total Font Color </label>
                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "table_subtotal_color" ? null : "table_subtotal_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{table?.sub_total?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: table?.sub_total?.font_color
                                                                            ? `#${table?.sub_total?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "table_subtotal_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={table?.sub_total?.font_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        table: {
                                                                                            ...this.state.property.properties.table,
                                                                                            sub_total: {
                                                                                                ...this.state.property.properties.table.sub_total,
                                                                                                font_color: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <label>Sub Total Background Color </label>
                                                        <div
                                                            // className={`dropdown ${showErrorBorder && !total?.color ? "error-border" : ""}`}
                                                            className="dropdown"
                                                        >
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "table_sub_total_bg_color"
                                                                                ? null
                                                                                : "table_sub_total_bg_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{table?.sub_total?.bg_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: table?.sub_total?.bg_color
                                                                            ? `#${table?.sub_total?.bg_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon"></i>
                                                            </div>
                                                            {colorModalState === "table_sub_total_bg_color" && (
                                                                <div className="z-index-10" style={{ position: "absolute" }}>
                                                                    <CompactPicker
                                                                        className="picker"
                                                                        colors={FONT_COLOR}
                                                                        color={table?.sub_total?.bg_color}
                                                                        onChangeComplete={color =>
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        table: {
                                                                                            ...this.state.property.properties.table,
                                                                                            sub_total: {
                                                                                                ...this.state.property.properties.table.sub_total,
                                                                                                bg_color: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="font-family font-st col-md-3">
                                                        <label>Sub Total Alignment</label>
                                                        <div className="font-select">
                                                            <select
                                                                // className={`dropdown ${showErrorBorder && !total?.alignment ? "error-border" : ""}`}
                                                                className="dropdown"
                                                                name="tag"
                                                                value={table?.sub_total?.alignment}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    sub_total: {
                                                                                        ...this.state.property.properties.table.sub_total,
                                                                                        alignment: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                {" "}
                                                                <option value="">Select</option>
                                                                <option value={"left"}>Left</option>
                                                                <option value={"center"}>Center</option>
                                                                <option value={"right"}>Right</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Cell Margin Top</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.sub_total?.cell_margin?.top}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    sub_total: {
                                                                                        ...this.state.property.properties.table.sub_total,
                                                                                        cell_margin: {
                                                                                            ...this.state.property.properties.table.sub_total
                                                                                                .cell_margin,
                                                                                            top: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Cell Margin Left</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.sub_total?.cell_margin?.left}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    sub_total: {
                                                                                        ...this.state.property.properties.table.sub_total,
                                                                                        cell_margin: {
                                                                                            ...this.state.property.properties.table.sub_total
                                                                                                .cell_margin,
                                                                                            left: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Cell Margin Right</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.sub_total?.cell_margin?.right}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    sub_total: {
                                                                                        ...this.state.property.properties.table.sub_total,
                                                                                        cell_margin: {
                                                                                            ...this.state.property.properties.table.sub_total
                                                                                                .cell_margin,
                                                                                            right: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Sub Total Cell Margin Bottom</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={table?.sub_total?.cell_margin?.bottom}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                table: {
                                                                                    ...this.state.property.properties.table,
                                                                                    sub_total: {
                                                                                        ...this.state.property.properties.table.sub_total,
                                                                                        cell_margin: {
                                                                                            ...this.state.property.properties.table.sub_total
                                                                                                .cell_margin,
                                                                                            bottom: values.floatValue
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Memo Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["memo_properties"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["memo_properties"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["memo_properties"],
                                                                band: "Memo Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Apply Memo Field Property</label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.memo_properties?.memo_props_active}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                memo_properties: {
                                                                                    ...this.state.property.properties.memo_properties,
                                                                                    memo_props_active: e.target.value === "true"
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={true}>Active</option>
                                                                <option value={false}>Inactive</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Heading Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.memo_properties?.heading?.font_id || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                memo_properties: {
                                                                                    ...this.state.property.properties.memo_properties,
                                                                                    heading: {
                                                                                        ...this.state.property.properties.memo_properties?.heading,
                                                                                        font_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Heading Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={properties?.memo_properties?.heading?.font_size || "-"}
                                                                onValueChange={values => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                memo_properties: {
                                                                                    ...this.state.property.properties.memo_properties,
                                                                                    heading: {
                                                                                        ...this.state.property.properties.memo_properties?.heading,
                                                                                        font_size: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Heading Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                memo_properties: {
                                                                                    ...this.state.property.properties.memo_properties,
                                                                                    heading: {
                                                                                        ...this.state.property.properties.memo_properties?.heading,
                                                                                        font_color: ""
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "properties_memo_properties_heading_color"
                                                                                ? null
                                                                                : "properties_memo_properties_heading_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{properties?.memo_properties?.heading?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: properties?.memo_properties?.heading?.font_color
                                                                            ? `#${properties?.memo_properties?.heading?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "properties_memo_properties_heading_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={properties?.memo_properties?.heading?.font_color}
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        memo_properties: {
                                                                                            ...this.state.property.properties.memo_properties,
                                                                                            heading: {
                                                                                                ...this.state.property.properties.memo_properties
                                                                                                    ?.heading,
                                                                                                font_color: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Heading Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.memo_properties?.heading?.font_bold || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                memo_properties: {
                                                                                    ...this.state.property.properties.memo_properties,
                                                                                    heading: {
                                                                                        ...this.state.property.properties.memo_properties?.heading,
                                                                                        font_bold: e.target.value === "true"
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Body Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.memo_properties?.body?.font_id || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                memo_properties: {
                                                                                    ...this.state.property.properties.memo_properties,
                                                                                    body: {
                                                                                        ...this.state.property.properties.memo_properties?.body,
                                                                                        font_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Body Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={properties?.memo_properties?.body?.font_size || "-"}
                                                                onValueChange={values => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                memo_properties: {
                                                                                    ...this.state.property.properties.memo_properties,
                                                                                    body: {
                                                                                        ...this.state.property.properties.memo_properties?.body,
                                                                                        font_size: values?.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Body Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                memo_properties: {
                                                                                    ...this.state.property.properties.memo_properties,
                                                                                    body: {
                                                                                        ...this.state.property.properties.memo_properties?.body,
                                                                                        font_color: ""
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "properties_memo_properties_body_color"
                                                                                ? null
                                                                                : "properties_memo_properties_body_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{properties?.memo_properties?.body?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: properties?.memo_properties?.body?.font_color
                                                                            ? `#${properties?.memo_properties?.body?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "properties_memo_properties_body_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={properties?.memo_properties?.body?.font_color}
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        memo_properties: {
                                                                                            ...this.state.property.properties.memo_properties,
                                                                                            body: {
                                                                                                ...this.state.property.properties.memo_properties
                                                                                                    ?.body,
                                                                                                font_color: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Body Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.memo_properties?.body?.font_bold || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                memo_properties: {
                                                                                    ...this.state.property.properties.memo_properties,
                                                                                    body: {
                                                                                        ...this.state.property.properties.memo_properties?.body,
                                                                                        font_bold: e.target.value === "true"
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    User Document Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["user_doc"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["user_doc"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["user_doc"],
                                                                band: "User Document Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Building Image Width</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={properties?.user_doc?.building_default_image?.img_width || "-"}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                user_doc: {
                                                                                    ...this.state.property.properties.user_doc,
                                                                                    building_default_image: {
                                                                                        ...this.state.property.properties.user_doc
                                                                                            ?.building_default_image,
                                                                                        img_width: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-size font-st col-md-3">
                                                        <label>Building Image Height</label>
                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={properties?.user_doc?.building_default_image?.img_height || "-"}
                                                                onValueChange={values =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                user_doc: {
                                                                                    ...this.state.property.properties.user_doc,
                                                                                    building_default_image: {
                                                                                        ...this.state.property.properties.user_doc
                                                                                            ?.building_default_image,
                                                                                        img_height: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                                allowNegative={false}
                                                                suffix=" inch"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Building Image Alignment</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown ${showErrorBorder && !heading?.alignment ? "error-border" : ""}`}
                                                                name="tag"
                                                                value={properties?.user_doc?.building_default_image?.alignment || "-"}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                user_doc: {
                                                                                    ...this.state.property.properties.user_doc,
                                                                                    building_default_image: {
                                                                                        ...this.state.property.properties.user_doc
                                                                                            ?.building_default_image,
                                                                                        alignment: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value={"left"}>Left</option>
                                                                <option value={"center"}>Center</option>
                                                                <option value={"right"}>Right</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Page Header Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["page_header"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["page_header"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["page_header"],
                                                                band: "Page Header Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.page_header?.font_id || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                page_header: {
                                                                                    ...this.state.property.properties.page_header,
                                                                                    font_id: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={properties?.page_header?.font_size || "-"}
                                                                onValueChange={values => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                page_header: {
                                                                                    ...this.state.property.properties.page_header,
                                                                                    font_size: values.floatValue
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                page_header: {
                                                                                    ...this.state.property.properties.page_header,
                                                                                    font_color: ""
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "properties_page_header_heading_color"
                                                                                ? null
                                                                                : "properties_page_header_heading_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{properties?.page_header?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: properties?.page_header?.font_color
                                                                            ? `#${properties?.page_header?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "properties_page_header_heading_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={properties?.page_header?.font_color}
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        page_header: {
                                                                                            ...this.state.property.properties.page_header,
                                                                                            font_color: color.hex?.replace("#", "")
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.page_header?.font_bold || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                page_header: {
                                                                                    ...this.state.property.properties.page_header,
                                                                                    font_bold: e.target.value === "true"
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Font Alignment</label>
                                                        <div className="font-select">
                                                            <select
                                                                className={`dropdown`}
                                                                name="tag"
                                                                value={properties?.page_header?.alignment || "-"}
                                                                onChange={e =>
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                page_header: {
                                                                                    ...this.state.property.properties.page_header,
                                                                                    alignment: e.target.value
                                                                                }
                                                                            }
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                <option value={"left"}>Left</option>
                                                                <option value={"center"}>Center</option>
                                                                <option value={"right"}>Right</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="styles-box">
                                            <div className="outer-wrapp-resetprop">
                                                <h2 className="recom-h2-sec">
                                                    Gauge Chart Properties
                                                    <button
                                                        type="button"
                                                        className={`reset-btn-recom ${
                                                            this?.hasBandValueChanged("properties", ["gauge_chart_props"]) ? "cursor-disabled" : ""
                                                        }`}
                                                        data-tip="Undo changes (made in this edit session) in this Band "
                                                        data-for="display_formats"
                                                        disabled={this?.hasBandValueChanged("properties", ["gauge_chart_props"])}
                                                        onClick={() => {
                                                            this?.ResetToDefault({
                                                                mainKey: "properties",
                                                                subKeys: ["gauge_chart_props"],
                                                                band: "Gauge Chart Properties"
                                                            });
                                                        }}
                                                    >
                                                        <i className="fas fa-history reset text"></i>
                                                    </button>
                                                </h2>
                                            </div>
                                            <div className="styles-sec">
                                                <div className="d-flex f-outer">
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Body Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.gauge_chart_props?.body?.font_id || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                gauge_chart_props: {
                                                                                    ...this.state.property.properties.gauge_chart_props,
                                                                                    body: {
                                                                                        ...this.state.property.properties.gauge_chart_props?.body,
                                                                                        font_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Body Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={properties?.gauge_chart_props?.body?.font_size || "-"}
                                                                onValueChange={values => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                gauge_chart_props: {
                                                                                    ...this.state.property.properties.gauge_chart_props,
                                                                                    body: {
                                                                                        ...this.state.property.properties.gauge_chart_props?.body,
                                                                                        font_size: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Body Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                gauge_chart_props: {
                                                                                    ...this.state.property.properties.gauge_chart_props,
                                                                                    body: {
                                                                                        ...this.state.property.properties.gauge_chart_props?.body,
                                                                                        font_color: ""
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "properties_gauge_chart_props_heading_color"
                                                                                ? null
                                                                                : "properties_gauge_chart_props_heading_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{properties?.gauge_chart_props?.body?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: properties?.gauge_chart_props?.body?.font_color
                                                                            ? `#${properties?.gauge_chart_props?.body?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "properties_gauge_chart_props_heading_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={properties?.gauge_chart_props?.body?.font_color}
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        gauge_chart_props: {
                                                                                            ...this.state.property.properties.gauge_chart_props,
                                                                                            body: {
                                                                                                ...this.state.property.properties.gauge_chart_props
                                                                                                    ?.body,
                                                                                                font_color: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Body Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.gauge_chart_props?.body?.font_bold || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                gauge_chart_props: {
                                                                                    ...this.state.property.properties.gauge_chart_props,
                                                                                    body: {
                                                                                        ...this.state.property.properties.gauge_chart_props?.body,
                                                                                        font_bold: e.target.value === "true"
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-family font-st col-md-3">
                                                        <label>Total Font Name </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.gauge_chart_props?.total?.font_id || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                gauge_chart_props: {
                                                                                    ...this.state.property.properties.gauge_chart_props,
                                                                                    total: {
                                                                                        ...this.state.property.properties.gauge_chart_props?.total,
                                                                                        font_id: e.target.value
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                {FONT_FAMILY.map(f => (
                                                                    <option key={f.id} value={f.id}>
                                                                        {f.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="font-size font-st col-md-3">
                                                        <label>Total Font Size</label>

                                                        <div className={`input-ft-size`}>
                                                            <NumberFormat
                                                                value={properties?.gauge_chart_props?.total?.font_size || "-"}
                                                                onValueChange={values => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                gauge_chart_props: {
                                                                                    ...this.state.property.properties.gauge_chart_props,
                                                                                    total: {
                                                                                        ...this.state.property.properties.gauge_chart_props?.total,
                                                                                        font_size: values.floatValue
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                                allowNegative={false}
                                                                suffix=" Pt"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="font-color font-st col-md-3">
                                                        <div className="head_sub">
                                                            <label>Total Font Color </label>
                                                        </div>

                                                        <div className="dropdown">
                                                            <span
                                                                className="arrow_close"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                gauge_chart_props: {
                                                                                    ...this.state.property.properties.gauge_chart_props,
                                                                                    total: {
                                                                                        ...this.state.property.properties.gauge_chart_props?.total,
                                                                                        font_color: ""
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i class="fas fa-times"></i>
                                                            </span>
                                                            <div
                                                                className="dropdown-toggle"
                                                                type="button"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        colorModalState:
                                                                            colorModalState === "properties_gauge_chart_props_body_color"
                                                                                ? null
                                                                                : "properties_gauge_chart_props_body_color"
                                                                    });
                                                                }}
                                                            >
                                                                <span>{properties?.gauge_chart_props?.total?.font_color || "Select"}</span>
                                                                <span
                                                                    className="color-bx"
                                                                    style={{
                                                                        background: properties?.gauge_chart_props?.total?.font_color
                                                                            ? `#${properties?.gauge_chart_props?.total?.font_color}`
                                                                            : "#fff"
                                                                    }}
                                                                ></span>
                                                                <i aria-hidden="true" className="grey chevron down icon arrow_right"></i>
                                                            </div>
                                                            {colorModalState === "properties_gauge_chart_props_body_color" && (
                                                                <div style={styles.popover}>
                                                                    <div
                                                                        style={styles.cover}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                colorModalState: null
                                                                            });
                                                                        }}
                                                                    />
                                                                    <SketchPicker
                                                                        position="right"
                                                                        color={properties?.gauge_chart_props?.total?.font_color}
                                                                        presetColors={[
                                                                            "#95cd50",
                                                                            "#ffe242",
                                                                            "#ffa105",
                                                                            "#ff0305",
                                                                            "#0018A8",
                                                                            "#800080",
                                                                            "#3E8EDE",
                                                                            "#417505"
                                                                        ]}
                                                                        onChange={color => {
                                                                            this.setState({
                                                                                property: {
                                                                                    ...this.state.property,
                                                                                    properties: {
                                                                                        ...this.state.property.properties,
                                                                                        gauge_chart_props: {
                                                                                            ...this.state.property.properties.gauge_chart_props,
                                                                                            total: {
                                                                                                ...this.state.property.properties.gauge_chart_props
                                                                                                    ?.total,
                                                                                                font_color: color.hex?.replace("#", "")
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="font-family font-st col-md-3">
                                                        <label>Total Font Bold </label>
                                                        <div className="font-select">
                                                            <select
                                                                className="dropdown"
                                                                value={properties?.gauge_chart_props?.total?.font_bold || "-"}
                                                                onChange={e => {
                                                                    this.setState({
                                                                        property: {
                                                                            ...this.state.property,
                                                                            properties: {
                                                                                ...this.state.property.properties,
                                                                                gauge_chart_props: {
                                                                                    ...this.state.property.properties.gauge_chart_props,
                                                                                    total: {
                                                                                        ...this.state.property.properties.gauge_chart_props?.total,
                                                                                        font_bold: e.target.value === "true"
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <option value={false}>No</option>
                                                                <option value={true}>Yes</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <ReactTooltip id={`chart_property`} backgroundColor="#007bff" place="top" effect="solid" />
                    </div>
                    <ReactTooltip
                        className="rc-tooltip-custom-class tool-format-bx"
                        id="display_formats"
                        backgroundColor="#007bff"
                        place="top"
                        effect="solid"
                        html={true}
                        getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
                    />
                    <ReactTooltip id={`chart_property`} backgroundColor="#007bff" place="top" effect="solid" />
                </div>
                {this.renderConfirmationModal()}
                {this.renderResetToDefaultExportProperties()}
                {this.renderResetConfirmationModal()}
            </LoadingOverlay>
        );
    }
}
const mapStateToProps = state => {
    const { chartPropertyReducer, reportPropertyReducer } = state;
    return { chartPropertyReducer, reportPropertyReducer };
};

const { getDropdownList } = reportPropertyActions;
const { setFormDirty } = commonActions;

export default withRouter(
    connect(mapStateToProps, {
        ...actions,
        getDropdownList,
        setFormDirty
    })(Form)
);
